if (!customElements.get("daireler-element")) {
  class Daireler extends HTMLElement {
    constructor() {
      super();
      this.apiUrl = this.getAttribute("data-api");
      this.page = 1;
      this.paginationSize =
        parseInt(this.getAttribute("data-pagination-size")) || 12;
      this.cardTemplate = this.querySelector("#card-template");
      this.mapContainer = this.querySelector("#map-container");
      this.cardContainer = this.querySelector("#card-container");
      this.aboutCard = this.querySelector(".flats__about");
      this.filtersButton =
        this.querySelector(
          ".flats__more-filters-button .flats__options-filters-toggle"
        ) || this.querySelector(".flats__options-filters-toggle");
      this.mobileFilterTrigger = this.querySelector("#mobile-filter-trigger");
      this.mobileSearchTrigger = this.querySelector("#mobile-search-trigger");
      this.mobileSearchBar = this.querySelector(".flats__mobile-search-bar");
      // mobileSearchModal will be set in initMobileSearch() after DOM is ready
      this.mobileSearchModal = null;
      this.mobileLocationDisplay = this.querySelector(
        "#mobile-location-display"
      );
      this.mobileDatesDisplay = this.querySelector("#mobile-dates-display");
      this.filtersReset = this.querySelector(".flats__filters-reset");
      this.filtersClearAll = document.querySelectorAll(
        ".flats__filters-clear-all"
      );
      this.filtersModal = document.getElementById("flatsFiltersModal");
      this.applyFiltersButton = this.querySelector(".flats__filters-apply");
      this.applyFiltersButtonDesktop = this.querySelector(
        ".flats__filters-apply-desktop"
      );
      this.filtersCloseButton = this.querySelector(".flats__filters-close-btn");
      this.availableFilter = this.querySelector("#filter_available");
      this.availableFilterMobile = this.querySelector(
        "#filter_available_mobile"
      );
      this.paginationShowMore = this.querySelector(
        ".flats__pagination-show-more"
      );
      this.searchInput = this.querySelector(
        ".flats__options-filters-search input"
      );
      this.searchInputMobile = this.querySelector("#search-input-mobile");
      this.searchInputMobileClear = this.querySelector(
        "#search-input-mobile-clear"
      );
      this.loading = this.querySelector(".flats__loading");
      this.searchButton = this.querySelector(
        ".flats__options-filters-search button"
      );
      this.searchButtonMobile = this.querySelector(
        ".flats__filters-mobile-search .flats__options-filters-search button"
      );
      this.clearSearchButton = this.querySelector(
        ".flats__options-filters-search .clear-search"
      );
      this.clearSearchButtonMobile = this.querySelector(
        ".flats__filters-mobile-search .flats__options-filters-search .clear-search"
      );
      // Select filter options
      this.sortOptions = this.querySelector(
        '.flats__filters-option-fieldset[data-value="sort"]'
      );
      this.livingRooms = this.querySelector(
        '.flats__filters-option-fieldset[data-value="livingrooms"]'
      );
      this.bedrooms = this.querySelector(
        '.flats__filters-option-fieldset[data-value="bedrooms"]'
      );
      this.bathrooms = this.querySelector(
        '.flats__filters-option-fieldset[data-value="bathrooms"]'
      );
      this.datePicker = this.querySelector(
        ".flats__filters-option #date-range-picker"
      );
      this.locations = this.querySelector(
        '.flats__filters-option-fieldset[data-value="locations"]'
      );
      this.priceRange = this.querySelector(".flats__filters-option-range");
      this.priceRangeMin = this.querySelector("#price-range-min");
      this.priceRangeMax = this.querySelector("#price-range-max");
      // Quick filter elements
      this.quickFilterLocation = this.querySelector("#quick-filter-location");
      this.quickFilterDates = this.querySelector("#quick-filter-dates");
      this.quickFilterResidenceType = this.querySelector(
        "#quick-filter-residence-type"
      );
      this.dividerAfterLocation = this.querySelector("#divider-after-location");
      this.dividerAfterDates = this.querySelector("#divider-after-dates");
      this.dividerAfterResidenceType = this.querySelector(
        "#divider-after-residence-type"
      );
      this.quickLocationValue = this.querySelector("#quick-location-value");
      this.quickLocationDropdown = this.querySelector(
        "#quick-location-dropdown"
      );
      // Aktif filtre badge alanları (hem desktop hem modal)
      this.activeFilterBadges = this.querySelector("#active-filter-badges");
      this.activeFilterBadgesModal = this.querySelector(
        "#active-filter-badges-modal"
      );
      this.quickDatesValue = this.querySelector("#quick-dates-value");
      this.quickDatesDropdown = this.querySelector("#quick-dates-dropdown");
      this.quickResidenceTypeValue = this.querySelector(
        "#quick-residence-type-value"
      );
      this.quickResidenceTypeDropdown = this.querySelector(
        "#quick-residence-type-dropdown"
      );
      this.quickDatePicker = this.querySelector("#quick-date-picker");
      this.calendarContainer = this.querySelector("#calendar-container");
      this.moveInDisplay = this.querySelector("#move-in-display");
      this.moveOutDisplay = this.querySelector("#move-out-display");
      this.datePickerClear = this.querySelector("#date-picker-clear");
      this.datePickerApply = this.querySelector("#date-picker-apply");
      this.nightsCount = this.querySelector("#nights-count");
      // Contact elements
      this.contactPhone = this.querySelector("#contact-phone");
      this.contactEmail = this.querySelector("#contact-email");
      // Mobile clear filter button
      this.quickFilterClearMobile = this.querySelector(
        "#quick-filter-clear-mobile"
      );
      // Search modal elements
      this.searchModal = this.querySelector("#search-modal");
      this.searchModalInput = this.querySelector("#search-modal-input");
      this.searchModalClose = this.querySelector(".flats__search-modal-close");
      this.searchModalClear = this.querySelector("#search-modal-clear");
      this.searchModalOverlay = this.querySelector(
        ".flats__search-modal-overlay"
      );
      this.quickFilterSearchButton = this.querySelector("#quick-search-button");
      this.quickSearchClear = this.querySelector("#quick-search-clear");
      this.quickFilterSearchField = this.querySelector(
        "#quick-filter-search-field"
      );
      this.quickFilterSearchTrigger = this.querySelector(
        "#quick-filter-search-trigger"
      );
      this.quickFilterSearchFieldClear = this.querySelector(
        "#quick-filter-search-field-clear"
      );
      // Initialize properties
      this.map = null;
      this.data = null;
      this.filteredData = null;
      this.mapInitialized = false;
      this.priceRangeInitialized = false;
      this.mobileModalCalendarInitialized = false;
      this.priceRangeCache = null; // Cache min/max prices
      this.searchDebounceTimer = null;
      this.currentMoment = null; // Cache moment object
      this.notificationTimeout = null; // For notification auto-hide
      this.pendingFilterChanges = false; // Track if user made filter changes
      this.priceSliderUpdating = false; // Prevent circular updates between slider and facets
      this.isInternalSearch = false; // Flag to hide search term from user when searching from marker
      this.mapSelectionCount = 0; // Track number of properties selected from map
      this.mapSelectionBadge = null; // Reference to map selection badge element
      // Initialize options with default values
      this.options = {
        sort: null,
        priceRange: {
          min: null,
          max: null,
        },
        location: [],
        projectName: [],
        livingRooms: null,
        bedrooms: null,
        bathrooms: null,
        searchTerm: "",
        available: null,
        residenceType: [],
      };

      // Don't fetch data in constructor, wait for connectedCallback
    }

    getPropertyStatusCodes(property) {
      if (!property) {
        return [];
      }

      const rawCodes =
        property.propertyStatusCodes || property.property_status_codes || [];

      if (Array.isArray(rawCodes)) {
        return rawCodes
          .map((code) =>
            typeof code === "object" && code !== null
              ? code.code || code.name || ""
              : code
          )
          .map((code) => String(code).trim().toLowerCase())
          .filter((code) => code.length > 0);
      }

      if (typeof rawCodes === "string") {
        return [rawCodes.trim().toLowerCase()].filter((code) => code.length > 0);
      }

      return [];
    }

    isPropertyHidden(property) {
      const codes = this.getPropertyStatusCodes(property);
      const statusValue = String(property?.status ?? "");
      return statusValue === "0" && codes.includes("liste_disi");
    }

    getVisibleProperties(data) {
      const source = data?.properties || [];
      return source.filter((property) => !this.isPropertyHidden(property));
    }

    getAvailabilityDisplay(property) {
      if (!this.currentMoment) {
        this.currentMoment = moment();
      }

      const codes = this.getPropertyStatusCodes(property);
      const statusValue = String(property?.status ?? "");
      const isStatusOne = statusValue === "1";
      const isPasif = isStatusOne && codes.includes("pasif");
      const isOnRezervasyon =
        isStatusOne && codes.includes("on_rezervasyon");
      const isKurulum = isStatusOne && codes.includes("kurulum");

      const rawAvailabilityDate = property?.musaitlikTarihi;
      const isAvailabilityDateMissing =
        !rawAvailabilityDate ||
        rawAvailabilityDate === "null" ||
        rawAvailabilityDate === "undefined";

      let endDate = moment(rawAvailabilityDate, "YYYY-MM-DD");
      const hasValidDate = endDate.isValid();
      if (!hasValidDate) {
        endDate = this.currentMoment;
      }

      let printDate;
      const isAvailableNow =
        property?.musaitlikDurumu === true ||
        property?.musaitlikDurumu === "true";

      if (isPasif) {
        printDate = hasValidDate ? endDate : this.currentMoment;
      } else if (isAvailableNow || endDate.isBefore(this.currentMoment)) {
        printDate = this.currentMoment;
      } else {
        printDate = endDate;
      }

      let label = null;
      // Gösterilecek tarih bugünle aynı güne eşitse "Bugün Müsait" yazsın
      if (printDate && printDate.isSame(this.currentMoment, 'day')) {
        label = "Bugün Müsait";
      }

      return {
        label,
        dateText: printDate.format("DD MMMM YYYY"),
      };
    }
    connectedCallback() {
      // Ensure API URL is available before fetching
      if (!this.apiUrl) {
        this.apiUrl = this.getAttribute("data-api");
      }

      // Set sticky offset for mobile bar under the header
      this.setMobileStickyOffset();
      this.initStickyMobileBar();
      this._onResizeSticky = () => this.setMobileStickyOffset();
      window.addEventListener("resize", this._onResizeSticky, {
        passive: true,
      });

      // If API URL is still not available, wait a bit for metafield to load
      if (!this.apiUrl || this.apiUrl.trim() === "") {
        // Retry after a short delay in case metafield hasn't loaded yet
        setTimeout(() => {
          this.apiUrl = this.getAttribute("data-api");
          if (this.apiUrl && this.apiUrl.trim() !== "" && !this.data) {
            this.fetchData();
          } else if (!this.apiUrl || this.apiUrl.trim() === "") {
            console.error("API URL is not defined after retry");
            this.showError("API URL bulunamadı. Lütfen sayfayı yenileyin.");
          }
        }, 100);
        return;
      }

      if (!this.data) {
        this.fetchData();
      }
    }
    disconnectedCallback() {
      if (this._onResizeSticky) {
        window.removeEventListener("resize", this._onResizeSticky);
        this._onResizeSticky = null;
      }
      if (this._onScrollSticky) {
        window.removeEventListener("scroll", this._onScrollSticky);
        this._onScrollSticky = null;
      }
    }

    // Calculates header height and sets CSS var for sticky offset (mobile)
    setMobileStickyOffset() {
      try {
        const header = document.querySelector(
          "header, .shopify-section-header, .header-wrapper, .site-header, .header"
        );
        const height = header
          ? Math.ceil(header.getBoundingClientRect().height)
          : 56;
        // Clamp to avoid excessive gaps if header expands (e.g., open menus)
        const offset = Math.min(Math.max(height, 40), 88);
        document.documentElement.style.setProperty(
          "--mobile-sticky-offset",
          `${offset}px`
        );

        // Also set current mobile search bar height for spacer
        if (this.mobileSearchBar) {
          const barH =
            Math.ceil(this.mobileSearchBar.getBoundingClientRect().height) ||
            56;
          document.documentElement.style.setProperty(
            "--mobile-search-height",
            `${barH}px`
          );
        }
      } catch (e) {
        // Fallback
        document.documentElement.style.setProperty(
          "--mobile-sticky-offset",
          `64px`
        );
      }
    }

    // Initialize JS fallback for sticky (position:fixed) and live updates
    initStickyMobileBar() {
      const mm = window.matchMedia("(max-width: 767.98px)");
      const enable = () => {
        if (!this.mobileSearchBar) return;
        // Compute start position (top of element relative to page)
        const rect = this.mobileSearchBar.getBoundingClientRect();
        this._stickyStart = window.pageYOffset + rect.top;
        // Update bar height var for spacer
        const barH = Math.ceil(rect.height) || 56;
        document.documentElement.style.setProperty(
          "--mobile-search-height",
          `${barH}px`
        );
        this.handleScrollSticky();
      };
      const disable = () => {
        if (!this.mobileSearchBar) return;
        this.mobileSearchBar.classList.remove("is-fixed");
        this.removeStickySpacer();
      };

      this._onScrollSticky = () => this.handleScrollSticky();
      this._onMMChange = (e) => {
        e.matches ? enable() : disable();
      };
      window.addEventListener("scroll", this._onScrollSticky, {
        passive: true,
      });
      mm.addEventListener
        ? mm.addEventListener("change", this._onMMChange)
        : mm.addListener(this._onMMChange);
      if (mm.matches) enable();
    }

    handleScrollSticky() {
      if (!this.mobileSearchBar) return;
      const mm = window.matchMedia("(max-width: 767.98px)");
      if (!mm.matches) return;
      // Recompute offset on scroll to follow shrinking/expanding headers
      this.setMobileStickyOffset();
      const offsetPx =
        parseInt(
          getComputedStyle(document.documentElement).getPropertyValue(
            "--mobile-sticky-offset"
          )
        ) || 64;
      const shouldFix = window.pageYOffset + offsetPx >= this._stickyStart;
      // Padding is tied to 'is-fixed' state only; no pre-stick padding
      if (shouldFix) {
        if (!this.mobileSearchBar.classList.contains("is-fixed")) {
          this.mobileSearchBar.classList.add("is-fixed");
          this.insertStickySpacer();
        }
      } else {
        if (this.mobileSearchBar.classList.contains("is-fixed")) {
          this.mobileSearchBar.classList.remove("is-fixed");
          this.removeStickySpacer();
        }
      }
    }

    insertStickySpacer() {
      if (!this.mobileSearchBar) return;
      if (this._stickySpacer && this._stickySpacer.isConnected) return;
      this._stickySpacer = document.createElement("div");
      this._stickySpacer.className = "flats__mobile-search-spacer";
      this.mobileSearchBar.insertAdjacentElement(
        "afterend",
        this._stickySpacer
      );
    }

    removeStickySpacer() {
      if (this._stickySpacer && this._stickySpacer.parentNode) {
        this._stickySpacer.parentNode.removeChild(this._stickySpacer);
      }
      this._stickySpacer = null;
    }

    fetchData() {
      // Show loading state
      if (this.loading) {
        this.loading.classList.remove("hidden");
      }

      // Validate API URL
      if (!this.apiUrl || this.apiUrl.trim() === "") {
        console.error("API URL is empty or invalid:", this.apiUrl);
        this.showError("API URL geçersiz. Lütfen sayfayı yenileyin.");
        return;
      }

      // If we get here, either cache is invalid or parsing failed - fetch fresh data
      fetch(this.apiUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(
              `Network response was not ok: ${response.status} ${response.statusText}`
            );
          }
          return response.json();
        })
        .then((data) => {
          if (!data || !data.properties) {
            throw new Error("Invalid data format received from API");
          }
          this.data = data;
          this.data.properties = this.data.properties.filter((property) => {
            // can filter out properties that don't have images or handle
            if (
              !property.images ||
              property.images.length === 0 ||
              !property.handle
            ) {
              return false;
            }
            // Filter out properties with invalid prices (NaN or undefined)
            const price = property.priceRange?.MonthlyPrices?.["12_12"]?.["cash"];
            if (price === undefined || price === null || isNaN(price)) {
              return false;
            }
            // Also check the price used for sorting
            const sortPrice =
              property.priceRange?.MonthlyPrices?.["12_12"]?.["cash"];
            if (
              sortPrice === undefined ||
              sortPrice === null ||
              isNaN(sortPrice)
            ) {
              return false;
            }
            return true;
          });
          this.init();
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          this.showError(
            "Veriler yüklenirken bir hata oluştu. Lütfen sayfayı yenileyin."
          );
        });
    }
    showError(message) {
      if (this.loading) {
        this.loading.classList.add("hidden");
      }
      if (this.cardContainer) {
        this.cardContainer.innerHTML = `<div style="padding: 20px; text-align: center; color: #d32f2f;">
          <p style="margin-bottom: 10px;">${message}</p>
          <button onclick="location.reload()" style="padding: 10px 20px; background: #151515; color: white; border: none; border-radius: 6px; cursor: pointer;">
            Sayfayı Yenile
          </button>
        </div>`;
      }
    }
    init() {
      // Add event listeners for UI interactions
      if (this.filtersButton) {
        this.filtersButton.addEventListener("click", () => {
          if (this.filtersModal) {
            const modal = new bootstrap.Modal(this.filtersModal);
            modal.show();
            // Update filter options when opening the modal
            this.updateAllQuickFilterOptions();
            this.updateMainFilterOptions();
            // Reset pending changes flag - not needed anymore
            this.pendingFilterChanges = false;
          }
        });
      }

      // Modal shown event - histogram'ı çiz
      if (this.filtersModal) {
        // Prevent body scroll when modal is shown
        this.filtersModal.addEventListener("show.bs.modal", () => {
          this.lockBodyScroll();
        });

        this.filtersModal.addEventListener("shown.bs.modal", () => {
          console.log("Modal fully shown, ensuring histogram is drawn");
          // Modal tamamen göründükten sonra histogram'ı her zaman initial data ile çiz
          if (this.histogramInitialData && this.priceRangeCache) {
            console.log(
              "Redrawing histogram with initial data after modal shown"
            );

            // Her zaman initial histogram'ı çiz
            this.drawHistogram(
              this.histogramInitialData.histogramData,
              this.histogramInitialData.minValue,
              this.histogramInitialData.maxValue,
              this.histogramInitialData.binSize
            );

            // Sonra diğer filtreleri güncelle (slider pozisyonu, selection vb.)
            this.updateAllQuickFilterOptions();
          }
        });

        // Restore body scroll when modal is hidden
        this.filtersModal.addEventListener("hide.bs.modal", () => {
          this.unlockBodyScroll();
        });
      }

      // Mobile filter button event listener
      if (this.mobileFilterTrigger) {
        this.mobileFilterTrigger.addEventListener("click", () => {
          if (this.filtersModal) {
            const BootstrapModal =
              (window.bootstrap && window.bootstrap.Modal) ||
              (typeof bootstrap !== "undefined" && bootstrap.Modal);
            if (BootstrapModal) {
              const modal = new BootstrapModal(this.filtersModal);
              modal.show();
              // Update filter options when opening the modal
              this.updateAllQuickFilterOptions();
              this.updateMainFilterOptions();
              // Reset pending changes flag - not needed anymore
              this.pendingFilterChanges = false;
            }
          }
        });
      }
      if (this.aboutCard) {
        const aboutClose = this.aboutCard.querySelector(".flats__about-close");
        if (aboutClose) {
          aboutClose.addEventListener("click", () => {
            this.aboutCard.classList.add("hidden");
          });
        }
      }

      if (this.availableFilter) {
        this.availableFilter.addEventListener("change", (event) => {
          if (event.target.checked) {
            this.options.available = true;
          } else {
            this.options.available = false;
          }
          // Sync mobile checkbox
          if (this.availableFilterMobile) {
            this.availableFilterMobile.checked = event.target.checked;
          }
          // Update all filter options based on availability
          this.updateAllQuickFilterOptions();
          this.updateMainFilterOptions();
          // Mark that there are pending changes
          this.pendingFilterChanges = true;
        });
      }
      // Mobile available filter
      if (this.availableFilterMobile) {
        this.availableFilterMobile.addEventListener("change", (event) => {
          if (event.target.checked) {
            this.options.available = true;
          } else {
            this.options.available = false;
          }
          // Sync desktop checkbox
          if (this.availableFilter) {
            this.availableFilter.checked = event.target.checked;
          }
          // Update all filter options based on availability
          this.updateAllQuickFilterOptions();
          this.updateMainFilterOptions();
          // Mark that there are pending changes
          this.pendingFilterChanges = true;
        });
      }

      // Initialize filters
      if (this.sortOptions) {
        this.sortOptions.addEventListener("change", (event) => {
          this.options.sort = event.target.value;
          this.pendingFilterChanges = true;
          // Filtreler hemen uygulanmaz, sadece beklemeye alınır
        });
      }
      if (this.livingRooms) {
        this.livingRooms.addEventListener("change", (event) => {
          // Eğer "all" checkbox'ı tıklandıysa, öncelikle işle
          if (event.target.value === "all") {
            // Eğer all unchecked edilmeye çalışılıyorsa, bunu engelle
            if (!event.target.checked) {
              event.target.checked = true;
            } else {
              // All seçiliyse diğerlerini temizle
              this.livingRooms
                .querySelectorAll('input[type="checkbox"]')
                .forEach((input) => {
                  if (input.value !== "all") {
                    input.checked = false;
                  }
                });
            }
            this.options.livingRooms = ["all"];
          } else {
            // Diğer checkbox'lar için normal işlem
            this.options.livingRooms = [];
            this.livingRooms
              .querySelectorAll('input[type="checkbox"]')
              .forEach((input) => {
                if (input.value === "all") {
                  input.checked = false;
                }
                if (input.checked) {
                  this.options.livingRooms.push(input.value);
                }
              });
            // Hiçbir şey seçili değilse "all"ı seç
            if (this.options.livingRooms.length === 0) {
              this.livingRooms
                .querySelectorAll('input[type="checkbox"]')
                .forEach((input) => {
                  if (input.value !== "all") {
                    input.checked = false;
                  } else {
                    input.checked = true;
                  }
                });
              this.options.livingRooms = ["all"];
            }
          }
          this.updateAllQuickFilterOptions();
          this.updateMainFilterOptions();
          this.pendingFilterChanges = true;
          // Update available filter state immediately
          this.updateAvailableFilterState();
        });
      }
      if (this.bedrooms) {
        this.bedrooms.addEventListener("change", (event) => {
          // Eğer "all" checkbox'ı tıklandıysa, öncelikle işle
          if (event.target.value === "all") {
            // Eğer all unchecked edilmeye çalışılıyorsa, bunu engelle
            if (!event.target.checked) {
              event.target.checked = true;
            } else {
              // All seçiliyse diğerlerini temizle
              this.bedrooms
                .querySelectorAll('input[type="checkbox"]')
                .forEach((input) => {
                  if (input.value !== "all") {
                    input.checked = false;
                  }
                });
            }
            this.options.bedrooms = ["all"];
          } else {
            // Diğer checkbox'lar için normal işlem
            this.options.bedrooms = [];
            this.bedrooms
              .querySelectorAll('input[type="checkbox"]')
              .forEach((input) => {
                if (input.value === "all") {
                  input.checked = false;
                }
                if (input.checked) {
                  this.options.bedrooms.push(input.value);
                }
              });
            // Hiçbir şey seçili değilse "all"ı seç
            if (this.options.bedrooms.length === 0) {
              this.bedrooms
                .querySelectorAll('input[type="checkbox"]')
                .forEach((input) => {
                  if (input.value !== "all") {
                    input.checked = false;
                  } else {
                    input.checked = true;
                  }
                });
              this.options.bedrooms = ["all"];
            }
          }
          this.updateAllQuickFilterOptions();
          this.updateMainFilterOptions();
          this.pendingFilterChanges = true;
          // Update available filter state immediately
          this.updateAvailableFilterState();
        });
      }
      if (this.bathrooms) {
        this.bathrooms.addEventListener("change", (event) => {
          // Eğer "all" checkbox'ı tıklandıysa, öncelikle işle
          if (event.target.value === "all") {
            // Eğer all unchecked edilmeye çalışılıyorsa, bunu engelle
            if (!event.target.checked) {
              event.target.checked = true;
            } else {
              // All seçiliyse diğerlerini temizle
              this.bathrooms
                .querySelectorAll('input[type="checkbox"]')
                .forEach((input) => {
                  if (input.value !== "all") {
                    input.checked = false;
                  }
                });
            }
            this.options.bathrooms = ["all"];
          } else {
            // Diğer checkbox'lar için normal işlem
            this.options.bathrooms = [];
            this.bathrooms
              .querySelectorAll('input[type="checkbox"]')
              .forEach((input) => {
                if (input.value === "all") {
                  input.checked = false;
                }
                if (input.checked) {
                  this.options.bathrooms.push(input.value);
                }
              });
            // Hiçbir şey seçili değilse "all"ı seç
            if (this.options.bathrooms.length === 0) {
              this.bathrooms
                .querySelectorAll('input[type="checkbox"]')
                .forEach((input) => {
                  if (input.value !== "all") {
                    input.checked = false;
                  } else {
                    input.checked = true;
                  }
                });
              this.options.bathrooms = ["all"];
            }
          }
          this.updateAllQuickFilterOptions();
          this.updateMainFilterOptions();
          this.pendingFilterChanges = true;
          // Update available filter state immediately
          this.updateAvailableFilterState();
        });
      }
      if (this.applyFiltersButtonDesktop) {
        this.applyFiltersButtonDesktop.addEventListener("click", () => {
          // Get search value from mobile input if exists
          if (this.searchInputMobile && this.searchInputMobile.value.trim()) {
            this.options.searchTerm = this.searchInputMobile.value
              .trim()
              .toLocaleLowerCase("tr-TR");
          }
          // Apply filters and close modal
          this.applyFilters();
          this.pendingFilterChanges = false;
          if (this.filtersModal) {
            const modal = bootstrap.Modal.getInstance(this.filtersModal);
            if (modal) {
              modal.hide();
            }
          }
        });
      }
      if (this.priceRange) {
        this.initPriceRange();
      }
      // Initialize locations (for both main filter and quick filter)
      this.initLocations();

      // Add event listener to main filter locations if it exists
      if (this.locations) {
        this.locations.addEventListener("change", (event) => {
          const checkboxes = this.locations.querySelectorAll(
            'input[type="checkbox"]'
          );
          this.options.location = [];
          checkboxes.forEach((checkbox) => {
            if (checkbox.checked) {
              this.options.location.push(checkbox.value);
            }
          });
          this.updateLocationQuickFilter();
          this.updateAllQuickFilterOptions();
          this.updateMainFilterOptions();
          this.pendingFilterChanges = true;
          // Update available filter state immediately
          this.updateAvailableFilterState();
        });
      }
      // Desktop search
      if (this.searchButton && this.searchInput) {
        this.searchButton.addEventListener("click", () => {
          this.search();
        });
        // Debounce search input for better performance
        this.searchInput.addEventListener("input", (e) => {
          clearTimeout(this.searchDebounceTimer);
          // Update button state and field value immediately for visual feedback
          this.updateSearchButtonState();
          this.updateSearchFieldValue();
          // Toggle clear button visibility
          if (this.clearSearchButton) {
            if (e.target.value.trim().length > 0) {
              this.clearSearchButton.classList.add("visible");
            } else {
              this.clearSearchButton.classList.remove("visible");
            }
          }
          this.searchDebounceTimer = setTimeout(() => {
            // Sync mobile input
            if (this.searchInputMobile) {
              this.searchInputMobile.value = e.target.value;
            }
            this.search();
          }, 300); // 300ms debounce
        });
        this.searchInput.addEventListener("keyup", (e) => {
          if (e.key === "Enter" || e.keyCode === 13) {
            clearTimeout(this.searchDebounceTimer);
            this.search();
          }
        });
        if (this.clearSearchButton) {
          this.clearSearchButton.addEventListener("click", () => {
            this.clearSearch();
          });
        }
      }

      // Mobile search input (simple input without button)
      if (this.searchInputMobile) {
        // Prevent modal from closing when interacting with search input
        this.searchInputMobile.addEventListener("click", (e) => {
          e.stopPropagation();
        });
        this.searchInputMobile.addEventListener("focus", (e) => {
          e.stopPropagation();
        });
        this.searchInputMobile.addEventListener("keydown", (e) => {
          e.stopPropagation();
        });
        this.searchInputMobile.addEventListener("keyup", (e) => {
          e.stopPropagation();
        });
        // For mobile modal, just update the value without triggering search
        // Search will be triggered when "Filtre Uygula" button is clicked
        this.searchInputMobile.addEventListener("input", (e) => {
          e.stopPropagation(); // Prevent event from bubbling to modal

          // Show/hide clear button based on input value
          if (this.searchInputMobileClear) {
            if (e.target.value.trim().length > 0) {
              this.searchInputMobileClear.style.display = "flex";
            } else {
              this.searchInputMobileClear.style.display = "none";
            }
          }

          // Just store the value, don't trigger search
          // Sync desktop input value only
          if (this.searchInput) {
            this.searchInput.value = e.target.value;
            // Sync desktop clear button too
            if (this.clearSearchButton) {
              if (e.target.value.trim().length > 0) {
                this.clearSearchButton.classList.add("visible");
              } else {
                this.clearSearchButton.classList.remove("visible");
              }
            }
          }
        });

        // Mobile search clear button
        if (this.searchInputMobileClear) {
          this.searchInputMobileClear.addEventListener("click", (e) => {
            e.stopPropagation();
            // Clear the input
            this.searchInputMobile.value = "";
            // Hide clear button
            this.searchInputMobileClear.style.display = "none";
            // Sync desktop input
            if (this.searchInput) {
              this.searchInput.value = "";
              if (this.clearSearchButton) {
                this.clearSearchButton.classList.remove("visible");
              }
            }
          });
        }
      }

      if (this.datePicker) {
        this.initDatePicker();
      }
      if (this.filtersReset) {
        this.filtersReset.addEventListener("click", () => {
          this.resetFilters();
        });
      }

      if (this.filtersClearAll && this.filtersClearAll.length > 0) {
        this.filtersClearAll.forEach((button) => {
          button.addEventListener("click", () => {
            this.resetFilters();
          });
        });
      }

      // Initialize quick filters
      this.initQuickFilters();

      // Initialize projects after data is loaded
      this.initProjects();

      // Initialize residence types after data is loaded
      this.initResidenceTypes();

      // Initialize contact info
      this.initContactInfo();

      // Mobile clear filter button
      if (this.quickFilterClearMobile) {
        this.quickFilterClearMobile.addEventListener("click", () => {
          this.resetFilters();
        });
      }

      // Handle scroll fade effect for mobile quick filters
      this.initQuickFiltersScrollEffect();

      // Initialize search modal
      this.initSearchModal();

      // Initialize sliding background
      this.initSlidingBackground();

      // Initialize mobile search modal
      try {
        this.initMobileSearch();
      } catch (error) {
        console.error("Error initializing mobile search:", error);
      }

      this.applyFilters();
    }

    showNotification(message, duration = 3000) {
      // Create notification element if it doesn't exist
      let notification = document.getElementById("flats-notification");

      if (!notification) {
        notification = document.createElement("div");
        notification.id = "flats-notification";
        notification.className = "flats__notification";
        document.body.appendChild(notification);
      }

      // Clear any existing timeout
      if (this.notificationTimeout) {
        clearTimeout(this.notificationTimeout);
      }

      // Set message and show
      notification.textContent = message;
      notification.classList.add("show");

      // Auto hide after duration
      this.notificationTimeout = setTimeout(() => {
        notification.classList.remove("show");
      }, duration);
    }

    initSlidingBackground() {
      const quickFilters = this.querySelector(".flats__quick-filters");
      if (!quickFilters) return;

      // Function to update sliding background position
      const updateSlidingBackground = (targetElement) => {
        if (
          !targetElement ||
          targetElement.classList.contains("flats__quick-filter-item--button")
        ) {
          // Hide indicator if no valid target
          quickFilters.style.setProperty("--indicator-opacity", "0");
          return;
        }

        const rect = targetElement.getBoundingClientRect();
        const parentRect = quickFilters.getBoundingClientRect();

        // Calculate position relative to parent - start EXACTLY from item's left edge
        const left = rect.left - parentRect.left;
        let width = rect.width; // Default: only the item's own width

        // Special case: Only "Daire Tipi" should extend to search button
        const isResidenceTypeFilter =
          targetElement.id === "quick-filter-residence-type";
        if (isResidenceTypeFilter) {
          const searchButton = quickFilters.querySelector(
            ".flats__quick-filter-search-button"
          );
          if (searchButton) {
            const searchRect = searchButton.getBoundingClientRect();
            // Extend from item to the right edge of search button
            width = searchRect.right - parentRect.left - left;
          }
        }

        const top = 0; // Always fill from top
        const height = parentRect.height; // Always fill full height

        quickFilters.style.setProperty("--indicator-left", `${left}px`);
        quickFilters.style.setProperty("--indicator-width", `${width}px`);
        quickFilters.style.setProperty("--indicator-height", `${height}px`);
        quickFilters.style.setProperty("--indicator-top", `${top}px`);
        quickFilters.style.setProperty("--indicator-opacity", "1");
      };

      // Don't set initial position - wait for user to click
      // No automatic positioning on load

      // Update on window resize only if there's an active item
      let resizeTimeout;
      window.addEventListener("resize", () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(() => {
          const activeItem = quickFilters.querySelector(
            ".flats__quick-filter-item.active"
          );
          if (activeItem) {
            updateSlidingBackground(activeItem);
          }
        }, 100);
      });

      // Store the update function for later use
      this.updateSlidingBackground = updateSlidingBackground;
    }

    initSearchModal() {
      // Open modal when search button is clicked (but not the clear icon)
      if (this.quickFilterSearchButton) {
        this.quickFilterSearchButton.addEventListener("click", (e) => {
          // Don't open modal if clicking on clear icon
          if (e.target.closest(".search-clear-icon")) {
            return;
          }
          e.preventDefault();
          e.stopPropagation();
          this.openSearchModal();
        });

        // Update sliding background when search button hovers/expands (only for "Daire Tipi")
        this.quickFilterSearchButton.addEventListener("mouseenter", () => {
          const quickFilters = this.querySelector(".flats__quick-filters");
          if (quickFilters && this.updateSlidingBackground) {
            // Check if "Daire Tipi" is active (not hover, as hover is handled by CSS)
            const residenceTypeItem = this.quickFilterResidenceType;
            if (
              residenceTypeItem &&
              residenceTypeItem.classList.contains("active")
            ) {
              setTimeout(() => {
                this.updateSlidingBackground(residenceTypeItem);
              }, 50);
            }
          }
        });

        this.quickFilterSearchButton.addEventListener("mouseleave", () => {
          const quickFilters = this.querySelector(".flats__quick-filters");
          if (quickFilters && this.updateSlidingBackground) {
            const residenceTypeItem = this.quickFilterResidenceType;
            if (
              residenceTypeItem &&
              residenceTypeItem.classList.contains("active")
            ) {
              setTimeout(() => {
                this.updateSlidingBackground(residenceTypeItem);
              }, 50);
            }
          }
        });
      }

      // Close modal when close button is clicked
      if (this.searchModalClose) {
        this.searchModalClose.addEventListener("click", () => {
          this.closeSearchModal();
        });
      }

      // Close modal when overlay is clicked (but not modal content)
      if (this.searchModal) {
        this.searchModal.addEventListener("click", (e) => {
          // Only close if clicking the modal background, not the content
          if (
            e.target === this.searchModal ||
            e.target === this.searchModalOverlay
          ) {
            this.closeSearchModal();
          }
        });
      }

      // Close modal on ESC key
      document.addEventListener("keydown", (e) => {
        if (
          e.key === "Escape" &&
          this.searchModal &&
          this.searchModal.classList.contains("active")
        ) {
          this.closeSearchModal();
        }
      });

      // Clear search input in modal
      if (this.searchModalClear) {
        this.searchModalClear.addEventListener("click", () => {
          if (this.searchModalInput) {
            this.searchModalInput.value = "";
            this.searchModalInput.focus();
            this.searchModalClear.classList.remove("visible");
            // Clear search term from filters
            this.options.searchTerm = "";
            // Clear other search inputs
            if (this.searchInput) {
              this.searchInput.value = "";
            }
            if (this.searchInputMobile) {
              this.searchInputMobile.value = "";
            }
            // Update search button state
            this.updateSearchButtonState();
            // Apply filters to remove search filter
            this.applyFilters();
          }
        });
      }

      // Clear search from clear icon inside search button
      if (this.quickSearchClear) {
        this.quickSearchClear.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();
          // Clear all search inputs
          if (this.searchInput) {
            this.searchInput.value = "";
          }
          if (this.searchInputMobile) {
            this.searchInputMobile.value = "";
          }
          if (this.searchModalInput) {
            this.searchModalInput.value = "";
          }
          // Clear search term
          this.options.searchTerm = "";
          // Update search button state (will hide clear icon via CSS)
          this.updateSearchButtonState();
          // Apply filters
          this.applyFilters();
        });
      }

      // Handle search on Enter key and show/hide clear button
      if (this.searchModalInput) {
        this.searchModalInput.addEventListener("input", (e) => {
          // Show/hide clear button
          if (this.searchModalClear) {
            if (e.target.value.length > 0) {
              this.searchModalClear.classList.add("visible");
            } else {
              this.searchModalClear.classList.remove("visible");
            }
          }
          // Update search button state and field value
          this.updateSearchButtonState();
          this.updateSearchFieldValue();
        });

        this.searchModalInput.addEventListener("keyup", (e) => {
          if (e.key === "Enter" || e.keyCode === 13) {
            const searchValue = this.searchModalInput.value.trim();
            if (searchValue) {
              // Sync with main search inputs
              if (this.searchInput) {
                this.searchInput.value = searchValue;
              }
              if (this.searchInputMobile) {
                this.searchInputMobile.value = searchValue;
              }
              this.options.searchTerm = searchValue.toLocaleLowerCase("tr-TR");
              this.applyFilters();
              this.updateSearchButtonState(); // Show clear button
              this.updateSearchFieldValue(); // Update field value display
              this.closeSearchModal();
            }
          }
        });
      }
    }

    openSearchModal() {
      if (this.searchModal) {
        // Calculate scrollbar width before hiding it
        const scrollbarWidth =
          window.innerWidth - document.documentElement.clientWidth;

        // Add padding to prevent layout shift
        if (scrollbarWidth > 0) {
          document.body.style.paddingRight = `${scrollbarWidth}px`;

          // Also add padding to fixed elements if any
          const header = document.querySelector(
            ".shopify-section-group-header-group"
          );
          if (header) {
            header.style.paddingRight = `${scrollbarWidth}px`;
          }
        }

        document.body.style.overflow = "hidden";
        this.searchModal.classList.add("active");

        // Add has-search class to search button
        if (this.quickFilterSearchButton) {
          this.quickFilterSearchButton.classList.add("has-search");
        }

        // Set input value to current search term if exists
        if (this.searchModalInput) {
          const currentSearch =
            this.options.searchTerm ||
            (this.searchInput && this.searchInput.value) ||
            (this.searchInputMobile && this.searchInputMobile.value) ||
            "";
          this.searchModalInput.value = currentSearch;

          // Show/hide clear button based on value
          if (this.searchModalClear) {
            if (currentSearch.length > 0) {
              this.searchModalClear.classList.add("visible");
            } else {
              this.searchModalClear.classList.remove("visible");
            }
          }
        }

        // Focus on input after a small delay for animation
        setTimeout(() => {
          if (this.searchModalInput) {
            this.searchModalInput.focus();
            // Move cursor to end
            this.searchModalInput.setSelectionRange(
              this.searchModalInput.value.length,
              this.searchModalInput.value.length
            );
          }
        }, 100);

        // Update search field value display
        this.updateSearchFieldValue();
      }
    }

    closeSearchModal() {
      if (this.searchModal) {
        this.searchModal.classList.remove("active");
        document.body.style.overflow = "";
        document.body.style.paddingRight = "";

        // Remove padding from fixed elements
        const header = document.querySelector(
          ".shopify-section-group-header-group"
        );
        if (header) {
          header.style.paddingRight = "";
        }

        // Remove active class from search field
        if (this.quickFilterSearchField) {
          this.quickFilterSearchField.classList.remove("active");
        }

        // Don't clear input - keep the search term
        // Update search button state
        this.updateSearchButtonState();
      }
    }

    updateSearchButtonState() {
      if (!this.quickFilterSearchButton) return;

      // Check if modal is active or search has value
      const modalActive =
        this.searchModal && this.searchModal.classList.contains("active");
      const hasSearchValue =
        (this.searchInput && this.searchInput.value.trim().length > 0) ||
        (this.searchInputMobile &&
          this.searchInputMobile.value.trim().length > 0) ||
        (this.searchModalInput &&
          this.searchModalInput.value.trim().length > 0) ||
        (this.options.searchTerm && this.options.searchTerm.length > 0);

      // Show "Arama" text and clear icon when modal is active or has search value
      if (modalActive || hasSearchValue) {
        this.quickFilterSearchButton.classList.add("has-search");
      } else {
        this.quickFilterSearchButton.classList.remove("has-search");
      }

      // Update search field value display
      this.updateSearchFieldValue();

      // Clear icon is shown/hidden via CSS using .has-search class
    }

    updateSearchFieldValue() {
      const searchFieldValue = this.querySelector("#quick-search-field-value");
      if (!searchFieldValue) return;

      // Get original (non-lowercase) search term from inputs
      const searchTerm =
        (this.searchModalInput && this.searchModalInput.value.trim()) ||
        (this.searchInput && this.searchInput.value.trim()) ||
        (this.searchInputMobile && this.searchInputMobile.value.trim()) ||
        (this.options.searchTerm && this.options.searchTerm) ||
        "";

      if (searchTerm && searchTerm.length > 0) {
        // Show the original search term (not lowercase)
        searchFieldValue.textContent = searchTerm;
        // Show clear button
        if (this.quickFilterSearchFieldClear) {
          this.quickFilterSearchFieldClear.style.display = "flex";
        }
      } else {
        searchFieldValue.textContent = "ID veya proje arayın";
        // Hide clear button
        if (this.quickFilterSearchFieldClear) {
          this.quickFilterSearchFieldClear.style.display = "none";
        }
      }
    }

    initQuickFiltersScrollEffect() {
      const quickFilters = this.querySelector(".flats__quick-filters");
      if (!quickFilters) return;

      const updateScrollIndicator = () => {
        const isScrollable =
          quickFilters.scrollWidth > quickFilters.clientWidth;
        const isAtEnd =
          quickFilters.scrollLeft + quickFilters.clientWidth >=
          quickFilters.scrollWidth - 5;

        if (isScrollable && !isAtEnd) {
          quickFilters.classList.add("has-scroll");
        } else {
          quickFilters.classList.remove("has-scroll");
        }
      };

      // Check on load
      setTimeout(updateScrollIndicator, 100);

      // Check on scroll
      quickFilters.addEventListener("scroll", updateScrollIndicator);

      // Check on resize
      window.addEventListener("resize", updateScrollIndicator);
    }

    setupQuickFilterCloseButtons() {
      // Get all close buttons
      const closeButtons = this.querySelectorAll(
        ".flats__quick-filter-dropdown-close"
      );

      closeButtons.forEach((button) => {
        button.addEventListener("click", (e) => {
          e.stopPropagation();

          // Close all dropdowns (filters already applied automatically)
          if (this.quickFilterLocation)
            this.quickFilterLocation.classList.remove("active");
          if (this.quickFilterDates)
            this.quickFilterDates.classList.remove("active");
          if (this.quickFilterResidenceType)
            this.quickFilterResidenceType.classList.remove("active");

          // Update overlay and wrapper state
          this.updateQuickFilterOverlay();
          this.updateQuickFilterWrapperState();

          // Hide sliding background
          if (this.updateSlidingBackground) {
            this.updateSlidingBackground(null);
          }
        });
      });

      // Setup overlay click to close
      const overlay = this.querySelector("#quick-filter-overlay");
      if (overlay) {
        overlay.addEventListener("click", () => {
          // Close all dropdowns (filters already applied automatically)
          if (this.quickFilterLocation)
            this.quickFilterLocation.classList.remove("active");
          if (this.quickFilterDates)
            this.quickFilterDates.classList.remove("active");
          if (this.quickFilterResidenceType)
            this.quickFilterResidenceType.classList.remove("active");

          // Update overlay and wrapper state
          this.updateQuickFilterOverlay();
          this.updateQuickFilterWrapperState();

          // Hide sliding background
          if (this.updateSlidingBackground) {
            this.updateSlidingBackground(null);
          }
        });
      }
    }

    updateQuickFilterOverlay() {
      const overlay = this.querySelector("#quick-filter-overlay");
      if (!overlay) return;

      // Check if any dropdown is active
      const hasActiveDropdown =
        (this.quickFilterLocation &&
          this.quickFilterLocation.classList.contains("active")) ||
        (this.quickFilterDates &&
          this.quickFilterDates.classList.contains("active")) ||
        (this.quickFilterResidenceType &&
          this.quickFilterResidenceType.classList.contains("active"));

      // Only show overlay on phones; align with CSS @media (max-width: 767.98px)
      const isMobile = window.matchMedia("(max-width: 767.98px)").matches;

      if (hasActiveDropdown && isMobile) {
        overlay.classList.add("active");
        document.body.style.overflow = "hidden"; // Prevent body scroll on mobile
      } else {
        overlay.classList.remove("active");
        document.body.style.overflow = ""; // Restore body scroll
      }

      // Update wrapper background state
      this.updateQuickFilterWrapperState();
    }

    updateQuickFilterWrapperState() {
      const quickFilters = this.querySelector(".flats__quick-filters");
      if (!quickFilters) return;

      // Check if any item is active
      const hasActiveItem =
        (this.quickFilterLocation &&
          this.quickFilterLocation.classList.contains("active")) ||
        (this.quickFilterDates &&
          this.quickFilterDates.classList.contains("active")) ||
        (this.quickFilterResidenceType &&
          this.quickFilterResidenceType.classList.contains("active")) ||
        (this.quickFilterSearchField &&
          this.quickFilterSearchField.classList.contains("active"));

      if (hasActiveItem) {
        quickFilters.classList.add("has-active");
        quickFilters.classList.remove("has-hover"); // Remove hover state when active
      } else {
        quickFilters.classList.remove("has-active");
      }
    }

    initQuickFilters() {
      // Location quick filter
      if (this.quickFilterLocation) {
        // Click on the entire item to activate
        this.quickFilterLocation.addEventListener("click", (e) => {
          const wasActive =
            this.quickFilterLocation.classList.contains("active");
          const quickFilters = this.querySelector(".flats__quick-filters");

          // Remove active from others
          if (this.quickFilterDates)
            this.quickFilterDates.classList.remove("active");
          if (this.quickFilterResidenceType) {
            this.quickFilterResidenceType.classList.remove("active");
            // Show divider when residence type is deactivated
            if (this.dividerAfterDates) {
              this.dividerAfterDates.classList.remove("hide-divider");
            }
          }

          // Remove has-hover state when clicking
          if (quickFilters) quickFilters.classList.remove("has-hover");

          // Toggle this one
          this.quickFilterLocation.classList.toggle("active");

          // Update sliding background
          if (this.updateSlidingBackground) {
            if (this.quickFilterLocation.classList.contains("active")) {
              this.updateSlidingBackground(this.quickFilterLocation);
            } else {
              this.updateSlidingBackground(null);
            }
          }

          // Update available options when opening the dropdown
          if (
            !wasActive &&
            this.quickFilterLocation.classList.contains("active")
          ) {
            this.updateAllQuickFilterOptions();
          }

          // Update overlay and wrapper state
          this.updateQuickFilterOverlay();
          this.updateQuickFilterWrapperState();
        });

        // Prevent clicks inside dropdown from closing it
        const locationDropdown = this.quickFilterLocation.querySelector(
          ".flats__quick-filter-dropdown"
        );
        if (locationDropdown) {
          locationDropdown.addEventListener("click", (e) => {
            e.stopPropagation();
          });
        }

        // Hover effect - "Yer" için sadece kendi alanı gri olur, sliding background yok
        // CSS'deki normal hover state yeterli

        // Location dropdown will be populated in initLocations()
      }

      // Dates quick filter - opens date picker dropdown
      if (this.quickFilterDates) {
        this.quickFilterDates.addEventListener("click", (e) => {
          const quickFilters = this.querySelector(".flats__quick-filters");

          // Remove active from others
          if (this.quickFilterLocation)
            this.quickFilterLocation.classList.remove("active");
          if (this.quickFilterResidenceType) {
            this.quickFilterResidenceType.classList.remove("active");
            // Show divider when residence type is deactivated
            if (this.dividerAfterDates) {
              this.dividerAfterDates.classList.remove("hide-divider");
            }
          }

          // Remove has-hover state when clicking
          if (quickFilters) quickFilters.classList.remove("has-hover");

          // Toggle this one
          this.quickFilterDates.classList.toggle("active");

          // Position dropdown to be centered within the quick filters container
          if (this.quickFilterDates.classList.contains("active")) {
            const dropdown = this.quickDatesDropdown;

            if (dropdown && quickFilters) {
              setTimeout(() => {
                const filtersRect = quickFilters.getBoundingClientRect();
                const dropdownRect = dropdown.getBoundingClientRect();
                const datesRect = this.quickFilterDates.getBoundingClientRect();

                // Calculate centered position
                const filtersCenter = filtersRect.width / 2;
                const dropdownHalfWidth = dropdownRect.width / 2;
                const datesLeft = datesRect.left - filtersRect.left;

                // Offset to center dropdown within filters container
                const offset = filtersCenter - dropdownHalfWidth - datesLeft;
                dropdown.style.left = `${offset}px`;
              }, 10);
            }
          }

          // Update sliding background
          if (this.updateSlidingBackground) {
            if (this.quickFilterDates.classList.contains("active")) {
              this.updateSlidingBackground(this.quickFilterDates);
            } else {
              this.updateSlidingBackground(null);
            }
          }

          // Update overlay and wrapper state
          this.updateQuickFilterOverlay();
          this.updateQuickFilterWrapperState();

          // Initialize date picker in dropdown if not already initialized
          if (
            this.quickFilterDates.classList.contains("active") &&
            this.quickDatePicker &&
            !this.quickDatePickerObj
          ) {
            this.initQuickDatePicker();
          }
        });

        // Prevent clicks inside dropdown from closing it
        const datesDropdown = this.quickFilterDates.querySelector(
          ".flats__quick-filter-dropdown"
        );
        if (datesDropdown) {
          datesDropdown.addEventListener("click", (e) => {
            e.stopPropagation();
          });
        }

        // "Ne zaman" için hover - sadece CSS hover state kullanılır, sliding background yok
      }

      // Residence Type quick filter
      if (this.quickFilterResidenceType) {
        this.quickFilterResidenceType.addEventListener("click", (e) => {
          const wasActive =
            this.quickFilterResidenceType.classList.contains("active");
          const quickFilters = this.querySelector(".flats__quick-filters");

          // Remove active from others
          if (this.quickFilterLocation)
            this.quickFilterLocation.classList.remove("active");
          if (this.quickFilterDates)
            this.quickFilterDates.classList.remove("active");

          // Remove has-hover state when clicking
          if (quickFilters) quickFilters.classList.remove("has-hover");

          // Toggle this one
          this.quickFilterResidenceType.classList.toggle("active");

          // Hide/show left divider based on active state
          if (this.dividerAfterDates) {
            if (this.quickFilterResidenceType.classList.contains("active")) {
              this.dividerAfterDates.classList.add("hide-divider");
            } else {
              this.dividerAfterDates.classList.remove("hide-divider");
            }
          }

          // Update sliding background - "Daire Tipi" extends to search button like "Ne zaman"
          if (this.updateSlidingBackground) {
            if (this.quickFilterResidenceType.classList.contains("active")) {
              this.updateSlidingBackground(this.quickFilterResidenceType);
            } else {
              this.updateSlidingBackground(null);
            }
          }

          // Update available options when opening the dropdown
          if (
            !wasActive &&
            this.quickFilterResidenceType.classList.contains("active")
          ) {
            this.updateAllQuickFilterOptions();
          }

          // Update overlay and wrapper state
          this.updateQuickFilterOverlay();
          this.updateQuickFilterWrapperState();
        });

        // Prevent clicks inside dropdown from closing it
        const residenceTypeDropdown =
          this.quickFilterResidenceType.querySelector(
            ".flats__quick-filter-dropdown"
          );
        if (residenceTypeDropdown) {
          residenceTypeDropdown.addEventListener("click", (e) => {
            e.stopPropagation();
          });
        }

        // Hover effect for residence type - hide left divider when hovered
        if (this.quickFilterResidenceType && this.dividerAfterDates) {
          this.quickFilterResidenceType.addEventListener("mouseenter", () => {
            if (this.dividerAfterDates) {
              this.dividerAfterDates.classList.add("hide-divider");
            }
          });

          this.quickFilterResidenceType.addEventListener("mouseleave", () => {
            if (
              this.dividerAfterDates &&
              !this.quickFilterResidenceType.classList.contains("active")
            ) {
              this.dividerAfterDates.classList.remove("hide-divider");
            }
          });
        }

        // Also handle group hover
        const residenceGroup = this.quickFilterResidenceType?.closest(
          ".flats__quick-filter-group"
        );
        if (residenceGroup && this.dividerAfterDates) {
          residenceGroup.addEventListener("mouseenter", () => {
            if (this.dividerAfterDates) {
              this.dividerAfterDates.classList.add("hide-divider");
            }
          });

          residenceGroup.addEventListener("mouseleave", () => {
            if (
              this.dividerAfterDates &&
              !this.quickFilterResidenceType?.classList.contains("active")
            ) {
              this.dividerAfterDates.classList.remove("hide-divider");
            }
          });
        }

        // Residence Type dropdown will be populated in initResidenceTypes()
      }

      // New Search Field - opens search modal when clicked
      if (this.quickFilterSearchField) {
        const searchField = this.quickFilterSearchField;
        const searchTrigger = this.quickFilterSearchTrigger;
        const searchLabel = searchField.querySelector(
          ".flats__quick-filter-label"
        );

        // Function to open modal
        const openModal = (e) => {
          // Don't open modal if clicking on clear button
          if (e.target.closest(".flats__quick-filter-search-clear")) {
            return;
          }

          e.preventDefault();
          e.stopPropagation();

          // Add active class to search field
          searchField.classList.add("active");

          // Update wrapper state to show gray background
          this.updateQuickFilterWrapperState();

          this.openSearchModal();
        };

        // Add click listener to the entire search field item
        searchField.addEventListener("click", openModal);

        // Add click listener to the trigger div
        if (searchTrigger) {
          searchTrigger.addEventListener("click", openModal);
        }

        // Add click listener to the label
        if (searchLabel) {
          searchLabel.addEventListener("click", openModal);
        }

        // Remove active class when modal closes
        if (this.searchModal) {
          const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
              if (
                mutation.type === "attributes" &&
                mutation.attributeName === "class"
              ) {
                if (
                  !this.searchModal.classList.contains("active") &&
                  searchField
                ) {
                  searchField.classList.remove("active");
                  // Update wrapper state to remove gray background
                  this.updateQuickFilterWrapperState();
                }
              }
            });
          });
          observer.observe(this.searchModal, { attributes: true });
        }
      }

      // Clear search button in search field
      if (this.quickFilterSearchFieldClear) {
        this.quickFilterSearchFieldClear.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          // Clear search term
          this.options.searchTerm = "";

          // Clear all search inputs
          if (this.searchModalInput) {
            this.searchModalInput.value = "";
          }
          if (this.searchInput) {
            this.searchInput.value = "";
          }
          if (this.searchInputMobile) {
            this.searchInputMobile.value = "";
          }

          // Update displays
          this.updateSearchFieldValue();
          this.updateSearchButtonState();

          // Apply filters to refresh results
          this.applyFilters();
        });
      }

      // Close dropdowns when clicking outside
      document.addEventListener("click", (e) => {
        const quickFilters = this.querySelector(".flats__quick-filters");

        // Check if click is outside quick filters container
        if (quickFilters && !quickFilters.contains(e.target)) {
          // Check if any dropdown is currently active
          const hasActiveDropdown =
            (this.quickFilterLocation &&
              this.quickFilterLocation.classList.contains("active")) ||
            (this.quickFilterDates &&
              this.quickFilterDates.classList.contains("active")) ||
            (this.quickFilterResidenceType &&
              this.quickFilterResidenceType.classList.contains("active"));

          if (hasActiveDropdown) {
            if (this.quickFilterLocation)
              this.quickFilterLocation.classList.remove("active");
            if (this.quickFilterDates)
              this.quickFilterDates.classList.remove("active");
            if (this.quickFilterResidenceType)
              this.quickFilterResidenceType.classList.remove("active");

            // Show divider when residence type is deactivated
            if (this.dividerAfterDates) {
              this.dividerAfterDates.classList.remove("hide-divider");
            }

            // Remove has-hover state when clicking outside
            quickFilters.classList.remove("has-hover");

            // Update overlay and wrapper state
            this.updateQuickFilterOverlay();
            this.updateQuickFilterWrapperState();

            // Hide sliding background
            if (this.updateSlidingBackground) {
              this.updateSlidingBackground(null);
            }
          }
        }
      });

      // Setup close buttons for mobile
      this.setupQuickFilterCloseButtons();
    }

    initQuickDatePicker() {
      if (!this.quickDatePicker || !this.calendarContainer) return;

      const minDays = 100;
      const maxMonths = 12; // Maximum 12 months selection
      let selectedStart = null;
      let selectedEnd = null;

      // Helper function to update disabled dates in the calendar
      const updateDisabledDates = () => {
        if (!this.quickDatePickerObj || !this.quickDatePickerObj.el) return;

        const today = moment().add(1, "day"); // minDate
        const maxAllowedDate = moment().add(12, "months"); // maxDate

        setTimeout(() => {
          const days =
            this.quickDatePickerObj.el.querySelectorAll(".lightpick__day");
          days.forEach((dayElement) => {
            const dayTime = parseInt(dayElement.getAttribute("data-time"));
            if (!dayTime) return;

            const dayDate = moment(dayTime);

            // Always disable dates outside the allowed range (today+1 to today+12 months)
            let shouldDisable =
              dayDate.isBefore(today, "day") ||
              dayDate.isAfter(maxAllowedDate, "day");

            // If start is selected BUT end is NOT selected, apply +100 days rule
            if (!shouldDisable && selectedStart && !selectedEnd) {
              const minEndDate = moment(selectedStart).add(minDays, "days");
              const maxEndDate = moment(selectedStart).add(maxMonths, "months");

              // Disable if before minimum OR after maximum (within the allowed range)
              shouldDisable =
                dayDate.isBefore(minEndDate, "day") ||
                dayDate.isAfter(maxEndDate, "day");
            }

            // If both dates are selected, only disable dates outside the allowed range (already handled above)

            if (shouldDisable) {
              dayElement.classList.add("is-disabled");
              dayElement.classList.remove("is-available");
            } else if (
              !dayElement.classList.contains("is-start-date") &&
              !dayElement.classList.contains("is-previous-month") &&
              !dayElement.classList.contains("is-next-month")
            ) {
              dayElement.classList.remove("is-disabled");
              dayElement.classList.add("is-available");
            }
          });
        }, 50);
      };

      // Initialize single date picker with range selection
      this.quickDatePickerObj = new Lightpick({
        field: this.quickDatePicker,
        singleDate: false, // Enable range selection
        numberOfMonths: 2, // Show 2 months side by side
        minDate: moment().add(1, "day").toDate(),
        maxDate: moment().add(12, "months").toDate(), // Max 12 months from today
        inline: true,
        autoclose: false, // DON'T auto-close - we handle closing manually in onSelect
        repick: false, // Disable repick to have more control
        lang: "tr",
        parentEl: this.calendarContainer,
        disableDates: (date) => {
          const dateMoment = moment(date);
          const today = moment().add(1, "day"); // minDate
          const maxAllowedDate = moment().add(12, "months"); // maxDate

          // Always disable dates outside the allowed range (today+1 to today+12 months)
          if (
            dateMoment.isBefore(today, "day") ||
            dateMoment.isAfter(maxAllowedDate, "day")
          ) {
            return true;
          }

          // If start is selected BUT end is NOT selected, apply +100 days rule
          if (selectedStart && !selectedEnd) {
            const minEndDate = moment(selectedStart).add(minDays, "days");
            const maxEndDate = moment(selectedStart).add(maxMonths, "months");

            // Disable if before minimum OR after maximum (within the allowed range)
            return (
              dateMoment.isBefore(minEndDate, "day") ||
              dateMoment.isAfter(maxEndDate, "day")
            );
          }

          // If both dates are selected, only disable dates outside the allowed range (already handled above)
          return false;
        },
        onSelect: (start, end) => {
          // Prevent auto-selection of end date by Lightpick
          // Check if this callback is being called with both start and end in the same call
          // This happens when Lightpick auto-selects end date after start is selected
          if (end && start) {
            // Check if start was just selected (not previously set, or different from current selectedStart)
            const startJustSelected =
              !selectedStart ||
              (selectedStart && !moment(start).isSame(selectedStart, "day"));

            if (startJustSelected) {
              // This is an auto-selection - Lightpick is trying to set end date immediately after start
              // Clear it and prevent the selection
              setTimeout(() => {
                if (this.quickDatePickerObj) {
                  this.quickDatePickerObj.setEndDate(null, true);
                }
                selectedEnd = null;
                this.selectedEnd = null;
                if (this.moveOutDisplay) {
                  this.moveOutDisplay.textContent = "Çıkış tarihi seçin";
                }
              }, 0);
              end = null; // Clear end for this callback - only process start
            }
          }

          if (!end) {
            // First click - user is selecting a new start date
            // If both dates were previously selected, fully reset Lightpick state before starting new selection
            if (selectedStart && selectedEnd) {
              selectedStart = null;
              selectedEnd = null;
              if (this.quickDatePickerObj) {
                this.quickDatePickerObj.setStartDate(null, true);
                this.quickDatePickerObj.setEndDate(null, true);
              }
              // Clear displays
              if (this.moveOutDisplay) {
                this.moveOutDisplay.textContent = "Takvim seçin";
              }
              if (this.moveInDisplay) {
                this.moveInDisplay.textContent = "Takvim seçin";
              }
              this.updateNightsCount(null, null);
            }

            // If end date was previously selected (even if start is different), clear it
            // This handles the case where user clicks a new start date while end date is still selected
            if (selectedEnd) {
              selectedEnd = null;
              if (this.quickDatePickerObj) {
                this.quickDatePickerObj.setEndDate(null, true);
              }
              if (this.moveOutDisplay) {
                this.moveOutDisplay.textContent = "Çıkış tarihi seçin";
              }
              this.updateNightsCount(null, null);
            }

            // Set the new start date (prevent triggering callbacks)
            selectedStart = start ? moment(start) : null;
            selectedEnd = null; // Explicitly clear end date

            // Update instance variables
            this.selectedStart = selectedStart ? selectedStart.toDate() : null;
            this.selectedEnd = null;

            if (this.quickDatePickerObj) {
              this.quickDatePickerObj.setStartDate(start, true);
              this.quickDatePickerObj.setEndDate(null, true);
            }

            // Clear exit date display when selecting a new start date
            if (this.moveOutDisplay) {
              this.moveOutDisplay.textContent = "Çıkış tarihi seçin";
            }
            if (this.moveInDisplay) {
              this.moveInDisplay.textContent =
                moment(start).format("D MMM YYYY");
            }
            this.updateNightsCount(null, null);

            // Dropdown içeriden tıklamalarda zaten kapanmıyor; yeniden açmaya gerek yok
            const suggestedEnd = moment(start).add(minDays, "days").toDate();

            // DON'T set minDays - it causes Lightpick to auto-select end date!
            // We rely on disableDates callback instead
            // this.quickDatePickerObj._opts.minDays = minDays;

            // DON'T set the date range automatically - let user select
            // this.quickDatePickerObj.setDateRange(start, suggestedEnd);

            // Force re-render to apply disabled dates based on new selectedStart
            // Manually update disabled dates in the calendar
            // Wait a bit for Lightpick to update its internal state
            setTimeout(() => {
              updateDisabledDates();
            }, 100);

            // Move calendar view to show the +100 days area with smooth animation
            setTimeout(() => {
              if (this.quickDatePickerObj.gotoDate) {
                // Calculate months difference for smooth transition
                const currentMonth = moment(start);
                const targetMonth = moment(suggestedEnd);
                const monthsDiff = targetMonth.diff(currentMonth, "months");

                // Animate month by month with slower, smoother transitions
                let currentStep = 0;
                const animateToTarget = () => {
                  if (currentStep < monthsDiff) {
                    currentStep++;
                    const nextMonth = moment(start)
                      .add(currentStep, "months")
                      .toDate();

                    // Add fade effect before transition
                    const monthsContainer =
                      this.querySelector(".lightpick__months");
                    if (monthsContainer) {
                      monthsContainer.style.opacity = "0.5";
                      monthsContainer.style.transition = "opacity 0.3s ease";
                    }

                    setTimeout(() => {
                      this.quickDatePickerObj.gotoDate(nextMonth);

                      // Update disabled dates after month change
                      updateDisabledDates();

                      // Fade back in
                      if (monthsContainer) {
                        setTimeout(() => {
                          monthsContainer.style.opacity = "1";
                        }, 50);
                      }
                    }, 100);

                    setTimeout(animateToTarget, 400); // Slower: 400ms between each month
                  } else {
                    // Final position
                    this.quickDatePickerObj.gotoDate(suggestedEnd);

                    // Force render after final navigation
                    setTimeout(() => {
                      if (this.quickDatePickerObj.render) {
                        this.quickDatePickerObj.render();
                      }

                      // Update disabled dates after final navigation
                      updateDisabledDates();

                      // Ensure full opacity
                      const monthsContainer =
                        this.querySelector(".lightpick__months");
                      if (monthsContainer) {
                        monthsContainer.style.opacity = "1";
                      }
                    }, 100);
                  }
                };

                animateToTarget();
              }
            }, 50);

            // Update displays
            if (this.moveInDisplay) {
              this.moveInDisplay.textContent =
                moment(start).format("D MMM YYYY");
            }
            if (this.moveOutDisplay) {
              this.moveOutDisplay.textContent = "Çıkış tarihi seçin";
            }

            // Clear nights count until user selects end date
            this.updateNightsCount(null, null);

            // DON'T auto-apply or close - wait for user to select end date
            // Modal should stay open for user to select end date
          } else {
            // Second click - user selected end date
            selectedStart = start;
            selectedEnd = end;

            // Update selectedEnd in the scope
            this.selectedStart = selectedStart ? selectedStart.toDate() : null;
            this.selectedEnd = selectedEnd ? selectedEnd.toDate() : null;

            // Validate minimum 100 days and maximum 12 months
            const daysDiff = moment(end).diff(moment(start), "days");
            const monthsDiff = moment(end).diff(moment(start), "months", true);

            if (daysDiff < minDays) {
              // Auto-correct to minimum days
              const correctedEnd = moment(start).add(minDays, "days").toDate();
              selectedEnd = correctedEnd;
              this.quickDatePickerObj.setDateRange(start, correctedEnd);

              if (this.moveOutDisplay) {
                this.moveOutDisplay.textContent =
                  moment(correctedEnd).format("D MMM YYYY");
              }
              this.updateNightsCount(start, correctedEnd);

              // Move calendar to show the corrected end date
              setTimeout(() => {
                if (this.quickDatePickerObj.gotoDate) {
                  this.quickDatePickerObj.gotoDate(correctedEnd);
                }
              }, 50);

              // Auto-apply with corrected date
              this.updateDatesQuickFilter();
              this.applyFilters();

              // Dropdownu zorla yeniden açmayın; kullanıcı etkileşimi içeride kalır
            } else if (monthsDiff > maxMonths) {
              // Auto-correct to maximum 12 months
              const correctedEnd = moment(start)
                .add(maxMonths, "months")
                .toDate();
              selectedEnd = correctedEnd;
              this.quickDatePickerObj.setDateRange(start, correctedEnd);

              if (this.moveOutDisplay) {
                this.moveOutDisplay.textContent =
                  moment(correctedEnd).format("D MMM YYYY");
              }
              this.updateNightsCount(start, correctedEnd);

              // Move calendar to show the corrected end date
              setTimeout(() => {
                if (this.quickDatePickerObj.gotoDate) {
                  this.quickDatePickerObj.gotoDate(correctedEnd);
                }
              }, 50);

              // Auto-apply with corrected date
              this.updateDatesQuickFilter();
              this.applyFilters();

              // Dropdownu zorla yeniden açmayın; kullanıcı etkileşimi içeride kalır
            } else {
              // Valid selection - end date selected
              selectedStart = start ? moment(start) : null;
              selectedEnd = end ? moment(end) : null;

              // Update instance variables
              this.selectedStart = selectedStart
                ? selectedStart.toDate()
                : null;
              this.selectedEnd = selectedEnd ? selectedEnd.toDate() : null;

              if (this.moveOutDisplay) {
                this.moveOutDisplay.textContent =
                  moment(end).format("D MMM YYYY");
              }
              this.updateNightsCount(start, end);

              // Enable all dates when both dates are selected (within minDate-maxDate range)
              updateDisabledDates();

              // Auto-apply: Update filter display and apply filters immediately
              this.updateDatesQuickFilter();
              // Update available filter state immediately
              this.updateAvailableFilterState();
              this.applyFilters();

              // Close dropdown when end date is selected
              setTimeout(() => {
                if (this.quickFilterDates) {
                  this.quickFilterDates.classList.remove("active");
                }
                this.updateQuickFilterWrapperState();
                if (this.updateSlidingBackground) {
                  this.updateSlidingBackground(null);
                }
              }, 300);
            }

            if (this.moveInDisplay) {
              this.moveInDisplay.textContent =
                moment(start).format("D MMM YYYY");
            }
          }
        },
        onSelectStart: (start) => {
          // Dropdownu zorla yeniden açmayın; iç tıklamalar zaten kapanmayı tetiklemez

          // If both dates were selected, fully reset before starting new selection
          if (selectedStart && selectedEnd) {
            selectedStart = null;
            selectedEnd = null;
            if (this.quickDatePickerObj) {
              this.quickDatePickerObj.setStartDate(null, true);
              this.quickDatePickerObj.setEndDate(null, true);
            }
            // Clear displays
            if (this.moveOutDisplay) {
              this.moveOutDisplay.textContent = "Takvim seçin";
            }
            if (this.moveInDisplay) {
              this.moveInDisplay.textContent = "Takvim seçin";
            }
            this.updateNightsCount(null, null);
          }

          // If end date was previously selected (even if start is different), clear it
          // This handles the case where user clicks a new start date while end date is still selected
          if (selectedEnd) {
            selectedEnd = null;
            if (this.quickDatePickerObj) {
              this.quickDatePickerObj.setEndDate(null, true);
            }
            if (this.moveOutDisplay) {
              this.moveOutDisplay.textContent = "Çıkış tarihi seçin";
            }
            this.updateNightsCount(null, null);
          }

          // Set the new start date (prevent triggering callbacks)
          selectedStart = start ? moment(start) : null;
          selectedEnd = null; // Explicitly clear end date to ensure +100 days rule applies

          // Update instance variables
          this.selectedStart = selectedStart ? selectedStart.toDate() : null;
          this.selectedEnd = null;

          if (this.quickDatePickerObj) {
            this.quickDatePickerObj.setStartDate(start, true);
            this.quickDatePickerObj.setEndDate(null, true); // Explicitly clear end date
          }

          if (this.moveInDisplay) {
            this.moveInDisplay.textContent = moment(start).format("D MMM YYYY");
          }
          if (this.moveOutDisplay) {
            this.moveOutDisplay.textContent = "Çıkış tarihi seçin";
          }
          this.updateNightsCount(null, null);

          // Update disabled dates after setting new start date
          setTimeout(() => {
            updateDisabledDates();
          }, 100);
          if (this.moveOutDisplay) {
            this.moveOutDisplay.textContent = "Çıkış tarihi seçin";
          }

          // Clear nights count
          this.updateNightsCount(null, null);
        },
      });

      // Add smooth slide animation to navigation arrows
      setTimeout(() => {
        const prevButton = this.querySelector(
          "#quick-dates-dropdown .lightpick__previous-action"
        );
        const nextButton = this.querySelector(
          "#quick-dates-dropdown .lightpick__next-action"
        );
        const monthsContainer = this.querySelector(
          "#quick-dates-dropdown .lightpick__months"
        );

        if (prevButton && monthsContainer) {
          prevButton.addEventListener("click", () => {
            // Slide animation for previous month (slide from left)
            monthsContainer.style.transform = "translateX(-20px)";
            monthsContainer.style.opacity = "0.5";

            setTimeout(() => {
              monthsContainer.style.transform = "translateX(0)";
              monthsContainer.style.opacity = "1";
              // Update disabled dates after navigation
              updateDisabledDates();
            }, 150);
          });
        }

        if (nextButton && monthsContainer) {
          nextButton.addEventListener("click", () => {
            // Slide animation for next month (slide from right)
            monthsContainer.style.transform = "translateX(20px)";
            monthsContainer.style.opacity = "0.5";

            setTimeout(() => {
              monthsContainer.style.transform = "translateX(0)";
              monthsContainer.style.opacity = "1";
              // Update disabled dates after navigation
              updateDisabledDates();
            }, 150);
          });
        }
      }, 100);

      // Initialize residence types after data is loaded
      if (this.data) {
        this.initResidenceTypes();
      }
    }

    updateNightsCount(start, end) {
      if (this.nightsCount) {
        if (start && end) {
          const nights = moment(end).diff(moment(start), "days");
          this.nightsCount.innerHTML = `<span class="flats__nights-count">${nights} gece</span>`;
        } else {
          this.nightsCount.innerHTML = "";
        }
      }
    }

    initProjects() {
      if (!this.data || !this.data.properties) return;

      // Helper function to capitalize project names (first letter of each word)
      const capitalizeProjectName = (name) => {
        if (!name) return name;
        return name
          .toLocaleLowerCase("tr-TR")
          .split(" ")
          .map((word) => {
            if (word.length === 0) return word;
            return word.charAt(0).toLocaleUpperCase("tr-TR") + word.slice(1);
          })
          .join(" ");
      };

      // Extract unique project names from properties
      const projectNames = this.data.properties
        .filter((property) => !this.isPropertyHidden(property))
        .map((property) => {
          return property.projectName || null;
        })
        .filter((name) => name !== null && name !== undefined && name !== "")
        .filter((name, index, self) => self.indexOf(name) === index) // Get unique values
        .sort(); // Sort alphabetically

      // Populate main filter projects
      const mainFilterProjects = this.querySelector("#main-filter-projects");
      if (!mainFilterProjects) return;

      mainFilterProjects.innerHTML = ""; // Clear previous

      // Add "All" option
      const allOption = document.createElement("div");
      allOption.className = "flats__filters-option-project-item";
      const allCheckbox = document.createElement("div");
      allCheckbox.className = "flats__filters-option-project-checkbox";
      const allText = document.createElement("span");
      allText.className = "flats__filters-option-project-text";
      allText.textContent = window.translations?.flats?.all || "Tümü";
      allOption.appendChild(allCheckbox);
      allOption.appendChild(allText);
      allOption.dataset.value = "";
      allOption.classList.add("selected"); // Default selected
      allOption.addEventListener("click", () => {
        this.options.projectName = [];
        mainFilterProjects
          .querySelectorAll(".flats__filters-option-project-item")
          .forEach((opt) => opt.classList.remove("selected"));
        allOption.classList.add("selected");

        // Update other filters
        this.updateAllQuickFilterOptions();
        this.updatePriceRangeForFilters();
        this.updateRoomOptionsForFilters();
        // Update available filter state immediately
        this.updateAvailableFilterState();
        this.applyFilters();
      });
      mainFilterProjects.appendChild(allOption);

      // Add each project name option
      projectNames.forEach((name) => {
        const option = document.createElement("div");
        option.className = "flats__filters-option-project-item";
        const checkbox = document.createElement("div");
        checkbox.className = "flats__filters-option-project-checkbox";
        const text = document.createElement("span");
        text.className = "flats__filters-option-project-text";
        text.textContent = capitalizeProjectName(name);
        option.appendChild(checkbox);
        option.appendChild(text);
        option.dataset.value = name;
        option.addEventListener("click", () => {
          // Toggle selection
          const isSelected = option.classList.contains("selected");

          if (isSelected) {
            // Deselect
            option.classList.remove("selected");
            this.options.projectName = this.options.projectName.filter(
              (proj) => proj !== name
            );
          } else {
            // Select
            option.classList.add("selected");
            if (!this.options.projectName.includes(name)) {
              this.options.projectName.push(name);
            }
          }

          // Update "All" option
          const allOpt = mainFilterProjects.querySelector(
            '.flats__filters-option-project-item[data-value=""]'
          );
          if (allOpt) {
            allOpt.classList.remove("selected");
          }

          // Immediately update all filter options
          this.updateAllQuickFilterOptions();

          // Update main filters
          this.updateMainFilterOptions();

          // Update available filter state immediately
          this.updateAvailableFilterState();

          // Then apply filters with the cleaned selections
          this.applyFilters();
        });
        mainFilterProjects.appendChild(option);
      });
    }

    initResidenceTypes() {
      if (!this.data || !this.data.properties) return;

      // Extract unique residence types from properties
      const residenceTypes = this.data.properties
        .filter((property) => !this.isPropertyHidden(property))
        .map((property) => {
          return (
            property.residenceTypes?.[0]?.name || property.odaSayisi || null
          );
        })
        .filter((type) => type !== null && type !== undefined)
        .filter((type, index, self) => self.indexOf(type) === index) // Get unique values
        .sort(); // Sort alphabetically

      // Add residence types to quick filter dropdown
      const quickFilterDropdown = this.querySelector(
        "#quick-residence-type-options"
      );
      if (!quickFilterDropdown) return;

      const dropdownContent = quickFilterDropdown;

      dropdownContent.innerHTML = ""; // Clear previous

      // Add "All" option
      const allOption = document.createElement("div");
      allOption.className = "flats__quick-filter-option";
      allOption.dataset.value = "";
      allOption.innerHTML = `
        <span class="flats__quick-filter-option-checkbox"></span>
        <span class="flats__quick-filter-option-text">${
          window.translations?.flats?.all || "Tümü"
        }</span>
      `;
      allOption.classList.add("active");
      allOption.addEventListener("click", () => {
        // Clear all selections
        dropdownContent
          .querySelectorAll(".flats__quick-filter-option")
          .forEach((opt) => opt.classList.remove("active"));
        allOption.classList.add("active");
        this.options.residenceType = [];
        this.updateResidenceTypeQuickFilter();
        this.updateAllQuickFilterOptions();
        // Update available filter state immediately
        this.updateAvailableFilterState();
        this.applyFilters();
      });
      dropdownContent.appendChild(allOption);

      // Add each residence type option
      residenceTypes.forEach((type) => {
        const option = document.createElement("div");
        option.className = "flats__quick-filter-option";
        option.dataset.value = type;
        option.innerHTML = `
          <span class="flats__quick-filter-option-checkbox"></span>
          <span class="flats__quick-filter-option-text">${type}</span>
        `;
        option.addEventListener("click", () => {
          // Remove "All" selection
          const allOption = dropdownContent.querySelector(
            '.flats__quick-filter-option[data-value=""]'
          );
          if (allOption) allOption.classList.remove("active");

          // Toggle this option
          option.classList.toggle("active");

          // Update options
          const selectedOptions = Array.from(
            dropdownContent.querySelectorAll(
              '.flats__quick-filter-option.active:not([data-value=""])'
            )
          ).map((opt) => opt.dataset.value);

          this.options.residenceType = selectedOptions;

          // If no specific type is selected, select "All"
          if (selectedOptions.length === 0 && allOption) {
            allOption.classList.add("active");
          }

          this.updateResidenceTypeQuickFilter();
          this.updateAllQuickFilterOptions();
          // Update available filter state immediately
          this.updateAvailableFilterState();
          this.applyFilters();
        });
        dropdownContent.appendChild(option);
      });
    }

    updateResidenceTypeQuickFilter() {
      if (!this.quickResidenceTypeValue) return;

      // Get selected residence types from options.residenceType array
      const selectedTypes = this.options.residenceType || [];
      const quickFilterItem = this.quickFilterResidenceType;

      if (selectedTypes.length === 0) {
        this.quickResidenceTypeValue.textContent =
          window.translations?.flats?.select_residence_type ||
          "Daire tipi seçin";
        quickFilterItem?.classList.remove("has-selection");
        // Remove clear button if exists
        const existingClear = quickFilterItem?.querySelector(
          ".flats__quick-filter-clear"
        );
        if (existingClear) existingClear.remove();
      } else {
        if (selectedTypes.length === 1) {
          this.quickResidenceTypeValue.textContent = selectedTypes[0];
        } else {
          this.quickResidenceTypeValue.textContent = `${selectedTypes.length} Daire Tipi`;
        }
        quickFilterItem?.classList.add("has-selection");
        // Add clear button if not exists
        if (
          quickFilterItem &&
          !quickFilterItem.querySelector(".flats__quick-filter-clear")
        ) {
          const clearBtn = document.createElement("button");
          clearBtn.className = "flats__quick-filter-clear";
          clearBtn.type = "button";
          clearBtn.innerHTML =
            '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          clearBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            this.options.residenceType = [];
            // Clear dropdown selections
            const quickOptions =
              this.quickResidenceTypeDropdown?.querySelectorAll(
                ".flats__quick-filter-option"
              );
            if (quickOptions) {
              quickOptions.forEach((option) => {
                option.classList.remove("selected", "active");
              });
            }
            this.updateResidenceTypeQuickFilter();
            this.updateAllQuickFilterOptions();
            this.applyFilters();
          });
          const input = quickFilterItem.querySelector(
            ".flats__quick-filter-input"
          );
          if (input) {
            input.style.position = "relative";
            input.appendChild(clearBtn);
          }
        }
      }

      // Update quick filter dropdown options
      const quickOptions = this.quickResidenceTypeDropdown?.querySelectorAll(
        ".flats__quick-filter-option"
      );
      if (quickOptions) {
        quickOptions.forEach((option) => {
          const value = option.dataset.value;
          if (value === "") {
            // "All" option
            option.classList.toggle("active", selectedTypes.length === 0);
          } else {
            option.classList.toggle("active", selectedTypes.includes(value));
          }
        });
      }
    }

    updateLocationQuickFilter() {
      if (!this.quickLocationValue) return;

      // Get selected locations from options.location array
      const selectedLocations = this.options.location || [];
      const quickFilterItem = this.quickFilterLocation;

      if (selectedLocations.length === 0) {
        this.quickLocationValue.textContent =
          window.translations?.flats?.select_location || "Lokasyon seçin";
        quickFilterItem?.classList.remove("has-selection");
        // Remove clear button if exists
        const existingClear = quickFilterItem?.querySelector(
          ".flats__quick-filter-clear"
        );
        if (existingClear) existingClear.remove();
      } else {
        if (selectedLocations.length === 1) {
          // Capitalize first letter
          const location = selectedLocations[0];
          const capitalizedLocation =
            location.charAt(0).toUpperCase() + location.slice(1).toLowerCase();
          this.quickLocationValue.textContent = capitalizedLocation;
        } else {
          this.quickLocationValue.textContent = `${selectedLocations.length} Lokasyon`;
        }
        quickFilterItem?.classList.add("has-selection");
        // Add clear button if not exists
        if (
          quickFilterItem &&
          !quickFilterItem.querySelector(".flats__quick-filter-clear")
        ) {
          const clearBtn = document.createElement("button");
          clearBtn.className = "flats__quick-filter-clear";
          clearBtn.type = "button";
          clearBtn.innerHTML =
            '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          clearBtn.addEventListener("click", (e) => {
            e.stopPropagation();
            this.options.location = [];
            // Clear dropdown selections
            const quickOptions = this.quickLocationDropdown?.querySelectorAll(
              ".flats__quick-filter-option"
            );
            if (quickOptions) {
              quickOptions.forEach((option) => {
                option.classList.remove("selected", "active");
              });
            }
            // Clear main filter checkboxes
            if (this.locations) {
              this.locations
                .querySelectorAll('input[type="checkbox"]')
                .forEach((checkbox) => {
                  checkbox.checked = false;
                });
            }
            this.updateLocationQuickFilter();
            this.updateAllQuickFilterOptions();
            this.applyFilters();
          });
          const input = quickFilterItem.querySelector(
            ".flats__quick-filter-input"
          );
          if (input) {
            input.style.position = "relative";
            input.appendChild(clearBtn);
          }
        }
      }

      // Update quick filter dropdown options
      const quickOptions = this.quickLocationDropdown?.querySelectorAll(
        ".flats__quick-filter-option"
      );
      if (quickOptions) {
        quickOptions.forEach((option) => {
          const optionValue = option.dataset.value;
          if (optionValue === "") {
            // "All" option
            if (selectedLocations.length === 0) {
              option.classList.add("selected");
            } else {
              option.classList.remove("selected");
            }
          } else {
            // Location option
            if (selectedLocations.includes(optionValue)) {
              option.classList.add("selected");
            } else {
              option.classList.remove("selected");
            }
          }
        });
      }

      // Also update main filter checkboxes if they exist
      if (this.locations) {
        this.locations
          .querySelectorAll('input[type="checkbox"]')
          .forEach((checkbox) => {
            checkbox.checked = selectedLocations.includes(checkbox.value);
          });
      }
    }

    updateDatesQuickFilter() {
      if (!this.quickDatesValue) return;

      // Check quick date picker (new single calendar system)
      const start = this.quickDatePickerObj?.getStartDate();
      const end = this.quickDatePickerObj?.getEndDate();

      // Fallback to main date picker if quick picker not initialized
      if (!start && !end) {
        const datePicker = this.datePickerObj;
        if (datePicker) {
          const mainStart = datePicker.getStartDate();
          const mainEnd = datePicker.getEndDate();
          if (mainStart && mainEnd) {
            const startStr = moment(mainStart).format("D MMM");
            const endStr = moment(mainEnd).format("D MMM");
            this.quickDatesValue.textContent = `${startStr} - ${endStr}`;
            return;
          }
        }
      }

      if (start && end) {
        const startStr = moment(start).format("D MMM");
        const endStr = moment(end).format("D MMM");
        this.quickDatesValue.textContent = `${startStr} - ${endStr}`;
        const quickFilterItem = this.quickFilterDates;
        quickFilterItem?.classList.add("has-selection");
        // Add clear button if not exists
        if (
          quickFilterItem &&
          !quickFilterItem.querySelector(".flats__quick-filter-clear")
        ) {
          const clearBtn = document.createElement("button");
          clearBtn.className = "flats__quick-filter-clear";
          clearBtn.type = "button";
          clearBtn.innerHTML =
            '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
          clearBtn.addEventListener("click", (e) => {
            e.stopPropagation();

            // Clear quick date picker - this will clear the visual selection in the dropdown
            if (this.quickDatePickerObj) {
              this.quickDatePickerObj.setStartDate(null, true);
              this.quickDatePickerObj.setEndDate(null, true);

              // Manually trigger onSelect callback with null values to clear closure variables
              // This ensures selectedStart and selectedEnd in initQuickDatePicker are also cleared
              if (
                this.quickDatePickerObj._opts &&
                typeof this.quickDatePickerObj._opts.onSelect === "function"
              ) {
                this.quickDatePickerObj._opts.onSelect.call(
                  this.quickDatePickerObj,
                  null,
                  null
                );
              }
            }

            // Clear main date picker if exists
            if (this.datePickerObj) {
              this.datePickerObj.setStartDate(null, true);
              this.datePickerObj.setEndDate(null, true);
            }

            // Clear instance variables
            this.selectedStart = null;
            this.selectedEnd = null;

            // Clear options
            this.options.startDate = null;
            this.options.endDate = null;

            // Clear display elements
            if (this.moveInDisplay) {
              this.moveInDisplay.textContent = "Takvim seçin";
            }
            if (this.moveOutDisplay) {
              this.moveOutDisplay.textContent = "Çıkış tarihi seçin";
            }

            // Clear nights count
            this.updateNightsCount(null, null);

            // Update quick filter display
            this.updateDatesQuickFilter();

            // Apply filters to refresh results
            this.updateAllQuickFilterOptions();
            this.applyFilters();
          });
          const input = quickFilterItem.querySelector(
            ".flats__quick-filter-input"
          );
          if (input) {
            input.style.position = "relative";
            input.appendChild(clearBtn);
          }
        }
      } else {
        this.quickDatesValue.textContent =
          window.translations?.flats?.select_dates || "Tarih seçin";
        const quickFilterItem = this.quickFilterDates;
        quickFilterItem?.classList.remove("has-selection");
        // Remove clear button if exists
        const existingClear = quickFilterItem?.querySelector(
          ".flats__quick-filter-clear"
        );
        if (existingClear) existingClear.remove();
      }
    }

    initContactInfo() {
      // Set contact phone and email from shop metafields or settings
      // You can customize these based on your shop's metafields
      const phoneElement = this.contactPhone;
      const emailElement = this.contactEmail;

      if (phoneElement) {
        // Set phone number in display format
        const phoneDisplay = "Tel: (0212) 272 37 72";
        const phoneNumber = "+902122723772"; // For tel: link
        phoneElement.textContent = phoneDisplay;
        const phoneLink = phoneElement.closest(".flats__contact-item--phone");
        if (phoneLink) {
          phoneLink.href = `tel:${phoneNumber}`;
        }
      }

      if (emailElement) {
        // Try to get email from shop metafields or use default
        const email =
          typeof shop !== "undefined" && shop?.metafields?.custom?.contact_email
            ? shop.metafields.custom.contact_email
            : "info@rendrea.com";
        emailElement.textContent = email;
        const emailLink = emailElement.closest(".flats__contact-item--email");
        if (emailLink) {
          emailLink.href = `mailto:${email}`;
        }
      }

      // Chat button - open Crisp chat widget
      const chatButton = this.querySelector(".flats__contact-item--chat");
      if (chatButton) {
        chatButton.addEventListener("click", (e) => {
          e.preventDefault();
          // Open Crisp chat widget
          if (typeof $crisp !== "undefined" && $crisp) {
            $crisp.push(["do", "chat:open"]);
          } else {
            // If Crisp is not loaded yet, wait for it
            const checkCrisp = setInterval(() => {
              if (typeof $crisp !== "undefined" && $crisp) {
                $crisp.push(["do", "chat:open"]);
                clearInterval(checkCrisp);
              }
            }, 100);
            // Stop checking after 5 seconds
            setTimeout(() => clearInterval(checkCrisp), 5000);
          }
        });
      }
    }

    lockBodyScroll() {
      // Only lock body scroll on mobile devices
      if (window.innerWidth <= 768) {
        // Save current scroll position
        this.scrollPosition =
          window.pageYOffset || document.documentElement.scrollTop;

        // Add class to body
        document.body.classList.add("modal-open");
        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.top = `-${this.scrollPosition}px`;
        document.body.style.width = "100%";
      }
    }

    unlockBodyScroll() {
      // Only unlock if it was locked
      if (window.innerWidth <= 768) {
        // Remove class from body
        document.body.classList.remove("modal-open");
        document.body.style.overflow = "";
        document.body.style.position = "";
        document.body.style.top = "";
        document.body.style.width = "";

        // Restore scroll position
        if (this.scrollPosition !== undefined) {
          window.scrollTo(0, this.scrollPosition);
          this.scrollPosition = undefined;
        }
      }
    }

    resetFilters() {
      this.options = {
        sort: null,
        priceRange: {
          min: null,
          max: null,
        },
        location: [],
        projectName: [],
        livingRooms: null,
        bedrooms: null,
        bathrooms: null,
        searchTerm: "",
        available: null,
        residenceType: [],
      };

      // Reset location checkboxes
      if (this.locations) {
        this.locations.querySelectorAll("input").forEach((input) => {
          input.checked = false;
        });
      }

      // Reset living rooms, bedrooms, bathrooms to "all"
      if (this.livingRooms) {
        this.livingRooms.querySelectorAll("input").forEach((input) => {
          input.checked = input.value === "all";
        });
      }
      if (this.bedrooms) {
        this.bedrooms.querySelectorAll("input").forEach((input) => {
          input.checked = input.value === "all";
        });
      }
      if (this.bathrooms) {
        this.bathrooms.querySelectorAll("input").forEach((input) => {
          input.checked = input.value === "all";
        });
      }

      // Reset sort to default
      if (this.sortOptions) {
        this.sortOptions.querySelectorAll("input").forEach((input) => {
          input.checked = input.value === "default";
        });
        this.sortOptions.value = null;
      }

      // Reset main date picker
      if (this.datePickerObj) {
        this.datePickerObj.reset();
      }

      // Reset search input
      if (this.searchInput) {
        this.searchInput.value = "";
      }
      if (this.searchInputMobile) {
        this.searchInputMobile.value = "";
      }

      // Hide clear buttons
      if (this.clearSearchButton) {
        this.clearSearchButton.classList.remove("visible");
      }
      if (this.clearSearchButtonMobile) {
        this.clearSearchButtonMobile.classList.remove("visible");
      }

      // Reset price range slider
      if (this.priceRange && this.priceRangeCache) {
        const minValue = this.priceRangeCache.min;
        const maxValue = this.priceRangeCache.max;

        // Destroy existing slider if it exists
        if (this.priceSlider) {
          // Clear the container which will destroy the slider
          this.priceRange.innerHTML = "";
          this.priceSlider = null;
        }

        // Reset price range inputs to min/max values
        if (this.priceRangeMin) {
          this.priceRangeMin.value = minValue;
        }
        if (this.priceRangeMax) {
          this.priceRangeMax.value = maxValue;
        }

        // Reset the initialization flag so slider will be recreated
        this.priceRangeInitialized = false;

        // Reinitialize with default values
        this.initPriceRange();
      }

      // Reset quick filters
      this.updateLocationQuickFilter();

      // Reset quick date picker
      if (this.quickDatePickerObj) {
        this.quickDatePickerObj.reset();
      }
      if (this.moveInDisplay) {
        this.moveInDisplay.textContent = "Tarih seçin";
      }
      if (this.moveOutDisplay) {
        this.moveOutDisplay.textContent = "Tarih seçin";
      }
      this.updateNightsCount(null, null);
      this.updateDatesQuickFilter();

      // Reset main filter projects
      const mainFilterProjects = this.querySelector("#main-filter-projects");
      if (mainFilterProjects) {
        const projectOptions = mainFilterProjects.querySelectorAll(
          ".flats__filters-option-project-item"
        );
        if (projectOptions && projectOptions.length > 0) {
          projectOptions.forEach((opt, index) => {
            opt.classList.toggle("selected", index === 0);
          });
        }
      }

      // Reset residence type checkboxes in main filter
      const residenceTypeCheckboxes = this.querySelectorAll(
        'input[name="residence_type"]'
      );
      if (residenceTypeCheckboxes.length > 0) {
        residenceTypeCheckboxes.forEach((cb) => {
          if (cb.id === "residence_type_all") {
            cb.checked = true;
          } else {
            cb.checked = false;
          }
        });
      }

      // Reset available filter
      if (this.availableFilter) {
        const availableInput = this.availableFilter.querySelector(
          'input[type="checkbox"]'
        );
        if (availableInput) {
          availableInput.checked = false;
        }
      }

      // Reset available filter mobile
      if (this.availableFilterMobile) {
        const availableInputMobile = this.availableFilterMobile.querySelector(
          'input[type="checkbox"]'
        );
        if (availableInputMobile) {
          availableInputMobile.checked = false;
        }
      }

      // Reset quick filter residence type
      this.updateResidenceTypeQuickFilter();

      // Reset all quick filter options
      this.updateAllQuickFilterOptions();

      // Reset map selection
      this.mapSelectionCount = 0;
      this.hideMapSelectionBadge();
      this.isInternalSearch = false;

      // Update search button state
      this.updateSearchButtonState();
      this.updateSearchFieldValue();

      this.applyFilters();
    }
    applyFilters() {
      // Debounce filter application to prevent rapid consecutive calls
      if (this.filterTimeout) {
        clearTimeout(this.filterTimeout);
      }

      this.filterTimeout = setTimeout(() => {
        this._executeFilters();
        this.updateActiveFilterBadges();
      }, 150); // 150ms debounce
    }

    updateActiveFilterBadges() {
      // Hem desktop hem modal badge container'larını al
      const containers = [
        this.activeFilterBadges,
        this.activeFilterBadgesModal,
      ];
      containers.forEach((c) => {
        if (c) c.innerHTML = "";
      });

      // Helper: sadece modalda gösterilecek badge ekle
      const addModalBadge = (badge) => {
        if (this.activeFilterBadgesModal)
          this.activeFilterBadgesModal.appendChild(badge);
      };
      // Helper: hem desktop hem modalda gösterilecek badge ekle
      const addBothBadge = (badge) => {
        if (this.activeFilterBadges)
          this.activeFilterBadges.appendChild(badge.cloneNode(true));
        if (this.activeFilterBadgesModal)
          this.activeFilterBadgesModal.appendChild(badge);
      };

      // Sıralama (sort) badge'i (her iki tarafta da)
      if (
        this.options.sort &&
        typeof this.options.sort === "string" &&
        this.options.sort.trim() !== "" &&
        this.options.sort !== "default"
      ) {
        const badge = document.createElement("span");
        badge.className = "flats__filter-badge";
        let sortLabel = "";
        switch (this.options.sort) {
          case "price-desc":
            sortLabel = "Fiyat (Azalan)";
            break;
          case "price-asc":
            sortLabel = "Fiyat (Artan)";
            break;
          case "sqm-asc":
            sortLabel = "M² (Artan)";
            break;
          case "sqm-desc":
            sortLabel = "M² (Azalan)";
            break;
          default:
            sortLabel = this.options.sort;
        }
        badge.innerHTML = `Sırala: ${sortLabel} <button style="background:none;border:none;cursor:pointer;font-size:16px;line-height:1;" aria-label="Kaldır" title="Kaldır">×</button>`;
        badge.querySelector("button").onclick = (e) => {
          e.stopPropagation();
          this.options.sort = "default";
          if (this.sortOptions) {
            this.sortOptions
              .querySelectorAll('input[type="radio"]')
              .forEach((input) => {
                if (input.value === "" || input.value === "default")
                  input.checked = true;
                else input.checked = false;
              });
          }
          this.applyFilters();
        };
        addBothBadge(badge);
      }

      // Yatak odası (her iki tarafta da)
      if (
        this.options.bedrooms &&
        Array.isArray(this.options.bedrooms) &&
        this.options.bedrooms.length > 0 &&
        !this.options.bedrooms.includes("all")
      ) {
        this.options.bedrooms.forEach((bed) => {
          const badge = document.createElement("span");
          badge.className = "flats__filter-badge";
          badge.innerHTML = `${bed} yatak odası <button style="background:none;border:none;cursor:pointer;font-size:16px;line-height:1;" aria-label="Kaldır" title="Kaldır">×</button>`;
          badge.querySelector("button").onclick = (e) => {
            e.stopPropagation();
            this.options.bedrooms = this.options.bedrooms.filter(
              (b) => b !== bed
            );
            if (this.options.bedrooms.length === 0)
              this.options.bedrooms = ["all"];
            if (this.bedrooms) {
              this.bedrooms
                .querySelectorAll('input[type="checkbox"]')
                .forEach((input) => {
                  if (input.value === bed) input.checked = false;
                  if (input.value === "all")
                    input.checked = this.options.bedrooms.includes("all");
                });
            }
            this.applyFilters();
          };
          addBothBadge(badge);
        });
      }

      // Salon (her iki tarafta da)
      if (
        this.options.livingRooms &&
        Array.isArray(this.options.livingRooms) &&
        this.options.livingRooms.length > 0 &&
        !this.options.livingRooms.includes("all")
      ) {
        this.options.livingRooms.forEach((living) => {
          const badge = document.createElement("span");
          badge.className = "flats__filter-badge";
          badge.innerHTML = `${living} salon <button style="background:none;border:none;cursor:pointer;font-size:16px;line-height:1;" aria-label="Kaldır" title="Kaldır">×</button>`;
          badge.querySelector("button").onclick = (e) => {
            e.stopPropagation();
            this.options.livingRooms = this.options.livingRooms.filter(
              (l) => l !== living
            );
            if (this.options.livingRooms.length === 0)
              this.options.livingRooms = ["all"];
            if (this.livingRooms) {
              this.livingRooms
                .querySelectorAll('input[type="checkbox"]')
                .forEach((input) => {
                  if (input.value === living) input.checked = false;
                  if (input.value === "all")
                    input.checked = this.options.livingRooms.includes("all");
                });
            }
            this.applyFilters();
          };
          addBothBadge(badge);
        });
      }

      // Banyo (her iki tarafta da)
      if (
        this.options.bathrooms &&
        Array.isArray(this.options.bathrooms) &&
        this.options.bathrooms.length > 0 &&
        !this.options.bathrooms.includes("all")
      ) {
        this.options.bathrooms.forEach((bath) => {
          const badge = document.createElement("span");
          badge.className = "flats__filter-badge";
          badge.innerHTML = `${bath} banyo <button style="background:none;border:none;cursor:pointer;font-size:16px;line-height:1;" aria-label="Kaldır" title="Kaldır">×</button>`;
          badge.querySelector("button").onclick = (e) => {
            e.stopPropagation();
            this.options.bathrooms = this.options.bathrooms.filter(
              (b) => b !== bath
            );
            if (this.options.bathrooms.length === 0)
              this.options.bathrooms = ["all"];
            if (this.bathrooms) {
              this.bathrooms
                .querySelectorAll('input[type="checkbox"]')
                .forEach((input) => {
                  if (input.value === bath) input.checked = false;
                  if (input.value === "all")
                    input.checked = this.options.bathrooms.includes("all");
                });
            }
            this.applyFilters();
          };
          addBothBadge(badge);
        });
      }

      // Fiyat aralığı (her iki tarafta da)
      if (
        this.options.priceRange &&
        this.options.priceRange.min != null &&
        this.options.priceRange.max != null &&
        this.priceRangeCache
      ) {
        const isDefault =
          this.options.priceRange.min === this.priceRangeCache.min &&
          this.options.priceRange.max === this.priceRangeCache.max;
        if (!isDefault) {
          const badge = document.createElement("span");
          badge.className = "flats__filter-badge";
          badge.innerHTML = `Fiyat: ${this.options.priceRange.min} - ${this.options.priceRange.max} <button style="background:none;border:none;cursor:pointer;font-size:16px;line-height:1;" aria-label="Kaldır" title="Kaldır">×</button>`;
          badge.querySelector("button").onclick = (e) => {
            e.stopPropagation();
            if (this.priceRangeCache) {
              this.options.priceRange.min = this.priceRangeCache.min;
              this.options.priceRange.max = this.priceRangeCache.max;
              if (this.priceRangeMin)
                this.priceRangeMin.value = this.priceRangeCache.min;
              if (this.priceRangeMax)
                this.priceRangeMax.value = this.priceRangeCache.max;
              if (this.priceSlider)
                this.priceSlider.$set({
                  min: this.priceRangeCache.min,
                  max: this.priceRangeCache.max,
                  values: [this.priceRangeCache.min, this.priceRangeCache.max],
                });
            }
            this.applyFilters();
          };
          addBothBadge(badge);
        }
      }
      // 'Hemen Yaşamaya Başlayın' (her iki tarafta da)
      if (
        this.options.available === true &&
        (this.availableFilter || this.availableFilterMobile)
      ) {
        const badge = document.createElement("span");
        badge.className = "flats__filter-badge";
        badge.innerHTML =
          'Hemen Yaşamaya Başlayın <button style="background:none;border:none;cursor:pointer;font-size:16px;line-height:1;" aria-label="Kaldır" title="Kaldır">×</button>';
        badge.querySelector("button").onclick = (e) => {
          e.stopPropagation();
          this.options.available = false;
          if (this.availableFilter) this.availableFilter.checked = false;
          if (this.availableFilterMobile)
            this.availableFilterMobile.checked = false;
          this.applyFilters();
        };
        addBothBadge(badge);
      }

      // Lokasyon (sadece modal/mobilde)
      if (
        this.options.location &&
        Array.isArray(this.options.location) &&
        this.options.location.length > 0
      ) {
        this.options.location.forEach((loc) => {
          const badge = document.createElement("span");
          badge.className = "flats__filter-badge";
          badge.innerHTML = `${loc} lokasyon <button style="background:none;border:none;cursor:pointer;font-size:16px;line-height:1;" aria-label="Kaldır" title="Kaldır">×</button>`;
          badge.querySelector("button").onclick = (e) => {
            e.stopPropagation();
            this.options.location = this.options.location.filter(
              (l) => l !== loc
            );
            if (this.locations) {
              this.locations
                .querySelectorAll('input[type="checkbox"]')
                .forEach((input) => {
                  if (input.value === loc) input.checked = false;
                });
            }
            this.applyFilters();
          };
          addModalBadge(badge);
        });
      }

      // Proje adı (her iki tarafta da)
      if (
        this.options.projectName &&
        Array.isArray(this.options.projectName) &&
        this.options.projectName.length > 0
      ) {
        this.options.projectName.forEach((proj) => {
          const badge = document.createElement("span");
          badge.className = "flats__filter-badge";
          badge.innerHTML = `${proj} proje <button style="background:none;border:none;cursor:pointer;font-size:16px;line-height:1;" aria-label="Kaldır" title="Kaldır">×</button>`;
          badge.querySelector("button").onclick = (e) => {
            e.stopPropagation();
            this.options.projectName = this.options.projectName.filter(
              (p) => p !== proj
            );
            this.applyFilters();
          };
          addBothBadge(badge);
        });
      }

      // Residence Type (sadece modal/mobilde)
      if (
        this.options.residenceType &&
        Array.isArray(this.options.residenceType) &&
        this.options.residenceType.length > 0
      ) {
        this.options.residenceType.forEach((type) => {
          const badge = document.createElement("span");
          badge.className = "flats__filter-badge";
          badge.innerHTML = `${type} tipi <button style="background:none;border:none;cursor:pointer;font-size:16px;line-height:1;" aria-label="Kaldır" title="Kaldır">×</button>`;
          badge.querySelector("button").onclick = (e) => {
            e.stopPropagation();
            this.options.residenceType = this.options.residenceType.filter(
              (t) => t !== type
            );
            this.applyFilters();
          };
          addModalBadge(badge);
        });
      }

      // Tarih (quickDatePicker veya datePicker) (sadece modal/mobilde)
      let start = null,
        end = null;
      if (this.quickDatePickerObj) {
        start = this.quickDatePickerObj.getStartDate();
        end = this.quickDatePickerObj.getEndDate();
      } else if (this.datePickerObj) {
        start = this.datePickerObj.getStartDate();
        end = this.datePickerObj.getEndDate();
      }
      if (start && end) {
        const badge = document.createElement("span");
        badge.className = "flats__filter-badge";
        badge.innerHTML = `${moment(start).format("D MMM")} - ${moment(
          end
        ).format(
          "D MMM"
        )} <button style="background:none;border:none;cursor:pointer;font-size:16px;line-height:1;" aria-label="Kaldır" title="Kaldır">×</button>`;
        badge.querySelector("button").onclick = (e) => {
          e.stopPropagation();
          if (this.quickDatePickerObj) {
            this.quickDatePickerObj.setStartDate(null, true);
            this.quickDatePickerObj.setEndDate(null, true);
          }
          if (this.datePickerObj) {
            this.datePickerObj.setStartDate(null, true);
            this.datePickerObj.setEndDate(null, true);
          }
          this.selectedStart = null;
          this.selectedEnd = null;
          this.applyFilters();
        };
        addModalBadge(badge);
      }
    }

    _executeFilters() {
      this.loading.classList.remove("hidden");
      // Use shallow copy instead of structuredClone for better performance
      // status 0 + liste_disi olanları baştan çıkar
      const filteredData = {
        ...this.data,
        properties: this.getVisibleProperties(this.data),
      };

      // Cache current moment to avoid creating multiple instances
      if (!this.currentMoment) {
        this.currentMoment = moment();
      } else {
        // Update cached moment if more than 1 minute has passed
        const now = moment();
        if (now.diff(this.currentMoment, "minutes") > 1) {
          this.currentMoment = now;
        }
      }

      // Helper function to check if a value matches any filter criteria
      const matchesFilter = (value, filterOptions) => {
        return filterOptions.some((option) => {
          if (option === "4+") {
            return value >= 4;
          }
          return value === parseInt(option);
        });
      };

      //apply the available filter
      if (this.options.available === true) {
        filteredData.properties = filteredData.properties.filter((property) => {
          if (property.musaitlikDurumu === true) return true;
          const availabilityDate = moment(
            property.musaitlikTarihi,
            "YYYY-MM-DD"
          );
          return availabilityDate.isBefore(this.currentMoment);
        });
      }

      // Apply filters based on the options set
      if (
        this.options.bedrooms?.length > 0 &&
        !this.options.bedrooms.includes("all")
      ) {
        filteredData.properties = filteredData.properties.filter((property) => {
          const propertyBedrooms =
            property.bedrooms ||
            parseInt(property.residenceTypes[0]?.name?.split("+")[0]) ||
            0;
          return matchesFilter(propertyBedrooms, this.options.bedrooms);
        });
      }
      if (
        this.options.livingRooms?.length > 0 &&
        !this.options.livingRooms.includes("all")
      ) {
        filteredData.properties = filteredData.properties.filter((property) => {
          const propertyLivingRooms =
            property.livingRooms ||
            parseInt(property.residenceTypes[0]?.name?.split("+")[1]) ||
            0;
          return matchesFilter(propertyLivingRooms, this.options.livingRooms);
        });
      }
      if (
        this.options.bathrooms?.length > 0 &&
        !this.options.bathrooms.includes("all")
      ) {
        filteredData.properties = filteredData.properties.filter((property) => {
          return matchesFilter(property.bathrooms, this.options.bathrooms);
        });
      }

      if (
        this.options.priceRange.min !== null &&
        this.options.priceRange.max !== null
      ) {
        filteredData.properties = filteredData.properties.filter((property) => {
          const price = property.priceRange.MonthlyPrices["12_12"]["cash"];
          return (
            price >= this.options.priceRange.min &&
            price <= this.options.priceRange.max
          );
        });
      }
      if (this.options.location && this.options.location.length > 0) {
        filteredData.properties = filteredData.properties.filter((property) => {
          return this.options.location.some((location) => {
            // Check both address and buildingDistrictMainName
            const addressMatch =
              property.address && property.address.includes(location);
            const districtMatch =
              property.buildingDistrictMainName &&
              property.buildingDistrictMainName === location;
            return addressMatch || districtMatch;
          });
        });
      }
      if (this.options.projectName && this.options.projectName.length > 0) {
        filteredData.properties = filteredData.properties.filter((property) => {
          return this.options.projectName.includes(property.projectName);
        });
      }
      if (this.options.residenceType && this.options.residenceType.length > 0) {
        filteredData.properties = filteredData.properties.filter((property) => {
          const propertyResidenceType =
            property.residenceTypes?.[0]?.name || property.odaSayisi;
          return this.options.residenceType.includes(propertyResidenceType);
        });
      }
      // Apply date range filter if dates are selected
      // Check quick date picker first (new single calendar system)
      let startDate = null;
      let endDate = null;

      if (this.quickDatePickerObj) {
        startDate = this.quickDatePickerObj.getStartDate();
        endDate = this.quickDatePickerObj.getEndDate();
      } else {
        // Fallback to main date picker
        const datePicker = this.datePickerObj;
        if (datePicker) {
          startDate = datePicker.getStartDate();
          endDate = datePicker.getEndDate();
        }
      }

      if (startDate && endDate) {
        filteredData.properties = filteredData.properties.filter((property) => {
          // If property is currently available, it can be booked
          if (property.musaitlikDurumu === true) {
            return true;
          }

          // Check if property is available on or before the start date
          const availabilityDate = moment(
            property.musaitlikTarihi,
            "YYYY-MM-DD"
          );
          const startMoment = moment(startDate);
          const endMoment = moment(endDate);

          // Property should be available on or before the start date
          // and the availability date should be within or before the booking period
          return availabilityDate.isSameOrBefore(startMoment, "day");
        });
      }
      if (
        this.options.searchTerm &&
        this.options.searchTerm.trim().length > 0
      ) {
        // Use Turkish locale for proper case conversion (İ -> i, I -> ı)
        const searchTerm = this.options.searchTerm
          .trim()
          .toLocaleLowerCase("tr-TR");
        const searchTermNum = parseInt(searchTerm);
        const isNumericSearch =
          !isNaN(searchTermNum) && searchTerm.trim() === String(searchTermNum);

        filteredData.properties = filteredData.properties.filter((property) => {
          property.projectName = property.projectName || "";
          property.description = property.description || "";
          property.address = property.address || "";
          property.idCode = property.idCode || "";

          // If search term is purely numeric, prioritize exact ID match
          if (isNumericSearch) {
            const idCodeNum = parseInt(property.idCode);
            // Exact ID match takes priority
            if (idCodeNum === searchTermNum) {
              return true;
            }
            // If exact ID match found, don't search in other fields
            // But if no exact match, continue with other field searches
          }

          // Case-insensitive search for all text fields using Turkish locale
          const projectNameLower = (
            property.projectName || ""
          ).toLocaleLowerCase("tr-TR");
          const descriptionLower = (
            property.description || ""
          ).toLocaleLowerCase("tr-TR");
          const addressLower = (property.address || "").toLocaleLowerCase(
            "tr-TR"
          );
          const idCodeStr = String(property.idCode || "");

          return (
            projectNameLower.includes(searchTerm) ||
            descriptionLower.includes(searchTerm) ||
            addressLower.includes(searchTerm) ||
            (!isNumericSearch && idCodeStr === searchTerm) ||
            (!isNumericSearch &&
              !isNaN(parseInt(searchTerm)) &&
              parseInt(idCodeStr) === parseInt(searchTerm))
          );
        });

        // If numeric search and exact ID match found, filter to only exact matches
        if (isNumericSearch) {
          const exactMatches = filteredData.properties.filter((property) => {
            const idCodeNum = parseInt(property.idCode);
            return idCodeNum === searchTermNum;
          });
          // If exact ID matches found, show only those
          if (exactMatches.length > 0) {
            filteredData.properties = exactMatches;
          }
        }
      }
      // Sort the data if sort option is set
      if (filteredData) {
        filteredData.properties.sort((a, b) => {
          switch (this.options.sort) {
            case "price-asc":
              // Use the same price shown on cards (MonthlyPrices["12_12"]["cash"])
              return (
                (a.priceRange?.MonthlyPrices?.["12_12"]?.["cash"] ??
                  Number.POSITIVE_INFINITY) -
                (b.priceRange?.MonthlyPrices?.["12_12"]?.["cash"] ??
                  Number.POSITIVE_INFINITY)
              );
            case "price-desc":
              // Use the same price shown on cards (MonthlyPrices["12_12"]["cash"])
              return (
                (b.priceRange?.MonthlyPrices?.["12_12"]?.["cash"] ??
                  Number.NEGATIVE_INFINITY) -
                (a.priceRange?.MonthlyPrices?.["12_12"]?.["cash"] ??
                  Number.NEGATIVE_INFINITY)
              );
            case "sqm-asc":
              return a.netMetrekare - b.netMetrekare;
            case "sqm-desc":
              return b.netMetrekare - a.netMetrekare;
            default:
              //sort by availability date
              let aDate = moment(a.musaitlikTarihi, "YYYY-MM-DD");
              let bDate = moment(b.musaitlikTarihi, "YYYY-MM-DD");
              if (!aDate.isAfter(this.currentMoment) || !aDate.isValid()) {
                aDate = this.currentMoment;
              }
              if (!bDate.isAfter(this.currentMoment) || !bDate.isValid()) {
                bDate = this.currentMoment;
              }
              return aDate.diff(bDate);
          }
        });
      }

      this.filteredData = filteredData;
      this.page = 1;

      // Close filters modal
      if (this.filtersModal) {
        const modal = bootstrap.Modal.getInstance(this.filtersModal);
        if (modal) {
          modal.hide();
        }
      }

      // Batch DOM updates
      requestAnimationFrame(() => {
        // Render cards first (most important for user)
        this.render(true);

        // Only initialize price range if it hasn't been initialized
        if (!this.priceRangeInitialized) {
          this.initPriceRange();
          this.priceRangeInitialized = true;

          // İlk yüklemede facet hesapla ve filtreleri güncelle
          // Böylece count 0 olan seçenekler (örn: 4+) gizlenir
          this.updateAllQuickFilterOptions();
        }

        // Defer map update to next frame for better performance
        if (this.mapInitialized) {
          if (window.requestIdleCallback) {
            requestIdleCallback(
              () => {
                this.updateMapMarkers();
              },
              { timeout: 1000 }
            );
          } else {
            // Fallback for browsers that don't support requestIdleCallback
            setTimeout(() => {
              this.updateMapMarkers();
            }, 100);
          }
        }

        // Update available filter state
        this.updateAvailableFilterState();
      });
    }

    updateAvailableFilterState() {
      // Check if there are any filters active (excluding available filter itself)
      const hasActiveFilters = this.hasActiveFiltersExcluding(["available"]);

      // If no filters are active, enable the checkbox (default state)
      if (!hasActiveFilters) {
        this.enableAvailableFilter();
        return;
      }

      // Get properties filtered by everything EXCEPT available filter
      const propertiesForAvailable = this.getFilteredPropertiesExcluding([
        "available",
      ]);

      // Check if any properties have musaitlikDurumu === true or past dates
      const now = moment();
      const hasAvailableProperties = propertiesForAvailable.some((property) => {
        if (property.musaitlikDurumu === true) return true;
        const availabilityDate = moment(property.musaitlikTarihi, "YYYY-MM-DD");
        return availabilityDate.isBefore(now);
      });

      // Enable or disable based on availability
      if (hasAvailableProperties) {
        this.enableAvailableFilter();
      } else {
        this.disableAvailableFilter();
      }
    }

    enableAvailableFilter() {
      // Sadece badge güncellemesi yap
      this.updateActiveFilterBadges();
    }

    updateResidenceTypeFilterOptions() {
      if (!this.quickFilterResidenceType) return;

      const dropdownContent = this.quickFilterResidenceType.querySelector(
        ".flats__quick-filter-dropdown-content"
      );
      if (!dropdownContent) return;

      const options = dropdownContent.querySelectorAll(
        '.flats__quick-filter-option:not([data-value=""])'
      );

      // If residence type is not selected (Tümü is selected), show all options
      if (
        !this.options.residenceType ||
        this.options.residenceType.length === 0
      ) {
        options.forEach((option) => {
          option.style.display = "";
        });
        return;
      }

      // Check if any filters are active (excluding residence type)
      const hasActiveFilters = this.hasActiveFiltersExcluding([
        "residenceType",
      ]);

      // If no other filters active, show all options
      if (!hasActiveFilters) {
        options.forEach((option) => {
          option.style.display = "";
        });
        return;
      }

      // Get properties filtered by everything EXCEPT residence type
      const propertiesForResidence = this.getFilteredPropertiesExcluding([
        "residenceType",
      ]);
      const availableTypes = [
        ...new Set(
          propertiesForResidence.map(
            (p) => p.residenceTypes?.[0]?.name || p.odaSayisi
          )
        ),
      ].filter((t) => t);

      // Update dropdown display options
      // Don't remove user's selections, just hide unavailable options
      options.forEach((option) => {
        const type = option.dataset.value;
        const isCurrentlySelected = option.classList.contains("selected");

        if (availableTypes.includes(type)) {
          // Available option: show normally
          option.style.display = "";
        } else if (isCurrentlySelected) {
          // Not available but selected: keep it visible but maybe grey it out
          option.style.display = "";
          // User can still see their selection
        } else {
          // Not available and not selected: hide it
          option.style.display = "none";
        }
      });
    }

    updateAllQuickFilterOptions() {
      // Merkezi facet hesaplama ile quick filter'ları güncelle
      const facets = this.calculateFacets();

      this.updateLocationFilterOptionsWithFacets(facets.locations);
      this.updateResidenceTypeFilterOptionsWithFacets(facets.residenceTypes);
      // Fiyat aralığını ve histogramı güncelle
      if (facets.priceRange) {
        this.updatePriceRangeWithFacets(facets.priceRange);
      }

      // Modal filtreleri de güncelle (odalar, banyolar)
      this.updateRoomOptionsWithFacets({
        livingRooms: facets.livingRooms,
        bedrooms: facets.bedrooms,
        bathrooms: facets.bathrooms,
      });
    }

    /**
     * Facet tabanlı fiyat aralığı güncelleme
     * Diğer filtrelere göre min/max ve histogramı dinamik ayarlar
     */
    updatePriceRangeWithFacets(priceFacet) {
      if (
        !this.priceRange ||
        !this.priceSlider ||
        !this.priceRangeCache ||
        !priceFacet
      )
        return;

      // Slider'dan değişiklik yapılıyorsa, bu fonksiyonu çalıştırma (döngüyü kır)
      if (this.priceSliderUpdating) {
        console.log(
          "Skipping updatePriceRangeWithFacets - slider is being updated by user"
        );
        return;
      }

      // İlk histogram henüz çizilmemişse, bu fonksiyon bir şey yapmamalı
      if (!this.histogramInitialData) {
        console.log(
          "Histogram initial data not ready yet, skipping updatePriceRangeWithFacets"
        );
        return;
      }

      const binSize = 1000;

      // Başka filtreler aktif mi kontrol et
      const hasActiveOtherFilters = this.hasActiveFiltersExcluding([
        "priceRange",
      ]);

      // Facet min/max; yoksa cache
      let facetMin =
        priceFacet.min !== undefined && priceFacet.min !== Infinity
          ? priceFacet.min
          : this.priceRangeCache.min;
      let facetMax =
        priceFacet.max !== undefined && priceFacet.max !== -Infinity
          ? priceFacet.max
          : this.priceRangeCache.max;

      // Histogram verisi ve aralık değişkenleri
      let histogramData = null;
      let hMin = facetMin;
      let hMax = facetMax;
      let selMin, selMax;

      // Histogram container'ı kontrol et, boşsa kesinlikle çiz
      const histogramContainer = document.getElementById("price-histogram");
      const needsRedraw =
        !histogramContainer || histogramContainer.children.length === 0;

      // Eğer başka hiçbir filtre yoksa, fiyat aralığını her zaman sıfırla
      if (!hasActiveOtherFilters) {
        console.log(
          "No active filters, resetting to initial histogram and price range"
        );
        histogramData = this.histogramInitialData.histogramData;
        hMin = this.histogramInitialData.minValue;
        hMax = this.histogramInitialData.maxValue;
        selMin = hMin;
        selMax = hMax;

        // UI limitlerini ve seçili değerleri sıfırla
        this.currentPriceMinLimit = hMin;
        this.currentPriceMaxLimit = hMax;
        this.options.priceRange.min = hMin;
        this.options.priceRange.max = hMax;
        this.binSize = binSize;
      } else {
        // Başka filtreler varsa
        // Histogram HER ZAMAN initial data'dan çizilir, sadece slider aralığı değişir
        console.log(
          "Active filters detected, using initial histogram but updating slider range"
        );

        // Histogram her zaman initial data
        histogramData = this.histogramInitialData.histogramData;
        hMin = this.histogramInitialData.minValue;
        hMax = this.histogramInitialData.maxValue;

        // UI limitlerini güncel tut (inputlar için) - fakat histogram limitleri değil
        this.currentPriceMinLimit = facetMin;
        this.currentPriceMaxLimit = facetMax;
        this.binSize = binSize;

        // Mevcut seçili değerleri korur veya sıkıştırır
        selMin =
          this.options.priceRange.min != null
            ? this.options.priceRange.min
            : facetMin;
        selMax =
          this.options.priceRange.max != null
            ? this.options.priceRange.max
            : facetMax;
        selMin = Math.max(facetMin, selMin);
        selMax = Math.min(facetMax, selMax);
        if (selMin > selMax) {
          selMin = facetMin;
          selMax = facetMax;
        }
      }

      // Histogram'ı çiz (container boşsa veya veri varsa)
      if (
        needsRedraw ||
        (histogramData && Object.keys(histogramData).length > 0)
      ) {
        console.log(
          "Drawing histogram from updatePriceRangeWithFacets (needsRedraw:",
          needsRedraw,
          ")"
        );
        this.drawHistogram(histogramData, hMin, hMax, binSize);
      } else {
        console.log("Histogram already drawn, only updating selection");
      }

      // Slider ve inputları güncelle + seçim renklendirme
      // Histogram çizimi tamamlandıktan sonra selection'ı güncelle
      requestAnimationFrame(() => {
        // priceSliderUpdating flag'i varsa slider güncelleme
        if (!this.priceSliderUpdating) {
          this.priceSlider.$set({
            min: hMin,
            max: hMax,
            values: [selMin, selMax],
          });
        }

        // Input'ları güncelle
        if (this.priceRangeMin) this.priceRangeMin.value = selMin;
        if (this.priceRangeMax) this.priceRangeMax.value = selMax;

        // Histogram seçimini güncelle (bir sonraki frame'de çalışsın)
        requestAnimationFrame(() => {
          this.updateHistogramSelection(selMin, selMax, hMin, binSize);
        });
      });
    }

    /**
     * Facet tabanlı konum filter seçenekleri güncelleme
     * Sayıları da gösterir
     */
    updateLocationFilterOptionsWithFacets(locationFacets) {
      if (!this.quickLocationDropdown) return;

      const dropdownContent = this.quickLocationDropdown.querySelector(
        ".flats__quick-filter-dropdown-content"
      );
      if (!dropdownContent) return;

      const options = dropdownContent.querySelectorAll(
        '.flats__quick-filter-option:not([data-value=""])'
      );
      const hasActiveFilters = this.hasActiveFiltersExcluding(["location"]);

      options.forEach((option) => {
        const location = option.dataset.value;
        const count = locationFacets[location] || 0;

        if (!hasActiveFilters || count > 0) {
          option.style.display = "";
          option.style.opacity = "1";
        } else {
          option.style.display = "none";
        }
      });
    }

    /**
     * Facet tabanlı residence type filter seçenekleri güncelleme
     * Sayıları da gösterir
     */
    updateResidenceTypeFilterOptionsWithFacets(residenceTypeFacets) {
      if (!this.quickResidenceTypeDropdown) return;

      const dropdownContent = this.quickResidenceTypeDropdown.querySelector(
        "#quick-residence-type-options"
      );
      if (!dropdownContent) return;

      const options = dropdownContent.querySelectorAll(
        '.flats__quick-filter-option:not([data-value=""])'
      );
      const hasActiveFilters = this.hasActiveFiltersExcluding([
        "residenceType",
      ]);

      options.forEach((option) => {
        const type = option.dataset.value;
        const count = residenceTypeFacets[type] || 0;

        if (!hasActiveFilters || count > 0) {
          option.style.display = "";
          option.style.opacity = "1";
        } else {
          option.style.display = "none";
        }
      });
    }

    /**
     * Merkezi Facet Hesaplama Fonksiyonu
     * Her filtre için mevcut (kullanılabilir) değerleri hesaplar
     * Cascading filter sisteminin kalbini oluşturur
     */
    calculateFacets() {
      const facets = {
        locations: {},
        residenceTypes: {},
        livingRooms: {},
        bedrooms: {},
        bathrooms: {},
        priceRange: {
          min: Infinity,
          max: -Infinity,
          histogram: {},
        },
        availability: {
          available: 0,
          total: 0,
        },
      };

      // Her filtre tipi için ayrı hesaplama yap
      // Odalar için özel: bir oda filtresi hesaplanırken diğer oda filtreleri DAHIL edilmeli

      // Konum facet'i - location hariç her şey dahil
      const propertiesForLocation = this.getFilteredPropertiesExcluding([
        "location",
      ]);
      propertiesForLocation.forEach((property) => {
        const location =
          property.buildingDistrictMainName || property.address?.split(", ")[1];
        if (location) {
          facets.locations[location] = (facets.locations[location] || 0) + 1;
        }
      });

      // Residence type facet'i - residenceType hariç her şey dahil
      const propertiesForResidenceType = this.getFilteredPropertiesExcluding([
        "residenceType",
      ]);
      propertiesForResidenceType.forEach((property) => {
        const residenceType =
          property.residenceTypes?.[0]?.name || property.odaSayisi;
        if (residenceType) {
          facets.residenceTypes[residenceType] =
            (facets.residenceTypes[residenceType] || 0) + 1;
        }
      });

      // Oda facet'leri - Cascading filter: Her oda filtresi, diğer oda filtrelerini DAHIL eder
      // Böylece bir oda seçildiğinde, diğer odalar ona göre daraltılır

      // Living rooms: sadece livingRooms hariç, bedrooms ve bathrooms DAHIL
      const propertiesForLivingRooms = this.getFilteredPropertiesExcluding([
        "livingRooms",
      ]);
      propertiesForLivingRooms.forEach((property) => {
        const livingRooms =
          property.livingRooms ||
          parseInt(property.residenceTypes[0]?.name?.split("+")[1]) ||
          0;
        const key = livingRooms >= 4 ? "4+" : String(livingRooms);
        facets.livingRooms[key] = (facets.livingRooms[key] || 0) + 1;
      });

      // Bedrooms: sadece bedrooms hariç, livingRooms ve bathrooms DAHIL
      const propertiesForBedrooms = this.getFilteredPropertiesExcluding([
        "bedrooms",
      ]);
      propertiesForBedrooms.forEach((property) => {
        const bedrooms =
          property.bedrooms ||
          parseInt(property.residenceTypes[0]?.name?.split("+")[0]) ||
          0;
        const key = bedrooms >= 4 ? "4+" : String(bedrooms);
        facets.bedrooms[key] = (facets.bedrooms[key] || 0) + 1;
      });

      // Bathrooms: sadece bathrooms hariç, livingRooms ve bedrooms DAHIL
      const propertiesForBathrooms = this.getFilteredPropertiesExcluding([
        "bathrooms",
      ]);
      propertiesForBathrooms.forEach((property) => {
        const bathrooms = property.bathrooms || 0;
        const key = bathrooms >= 4 ? "4+" : String(bathrooms);
        facets.bathrooms[key] = (facets.bathrooms[key] || 0) + 1;
      });

      // Fiyat facet'i - priceRange hariç her şey dahil
      const propertiesForPrice = this.getFilteredPropertiesExcluding([
        "priceRange",
      ]);
      propertiesForPrice.forEach((property) => {
          const price = property.priceRange?.MonthlyPrices?.["12_12"]?.["cash"] || 0;
        if (price > 0) {
          if (price < facets.priceRange.min) facets.priceRange.min = price;
          if (price > facets.priceRange.max) facets.priceRange.max = price;

          // Histogram için bin hesapla (1000'lik aralıklar)
          const binSize = 1000;
          const binValue = Math.floor(price / binSize) * binSize;
          facets.priceRange.histogram[binValue] =
            (facets.priceRange.histogram[binValue] || 0) + 1;
        }
      });

      // Müsaitlik facet'i - availability hariç her şey dahil
      const propertiesForAvailability = this.getFilteredPropertiesExcluding([
        "availability",
      ]);
      propertiesForAvailability.forEach((property) => {
        facets.availability.total++;
        if (property.musaitlikDurumu === true) {
          facets.availability.available++;
        } else if (property.musaitlikTarihi) {
          const availabilityDate = moment(
            property.musaitlikTarihi,
            "YYYY-MM-DD"
          );
          if (availabilityDate.isBefore(moment())) {
            facets.availability.available++;
          }
        }
      });

      return facets;
    }

    hasActiveFiltersExcluding(excludeFilters = []) {
      // Check if any filters are currently active (excluding the ones in excludeFilters array)

      // Check location
      if (
        !excludeFilters.includes("location") &&
        this.options.location &&
        this.options.location.length > 0
      ) {
        return true;
      }

      // Check project
      if (
        !excludeFilters.includes("projectName") &&
        this.options.projectName &&
        this.options.projectName.length > 0
      ) {
        return true;
      }

      // Check residence type
      if (
        !excludeFilters.includes("residenceType") &&
        this.options.residenceType &&
        this.options.residenceType.length > 0
      ) {
        return true;
      }

      // Check bedrooms
      if (
        !excludeFilters.includes("bedrooms") &&
        this.options.bedrooms &&
        this.options.bedrooms.length > 0 &&
        !this.options.bedrooms.includes("all")
      ) {
        return true;
      }

      // Check living rooms
      if (
        !excludeFilters.includes("livingRooms") &&
        this.options.livingRooms &&
        this.options.livingRooms.length > 0 &&
        !this.options.livingRooms.includes("all")
      ) {
        return true;
      }

      // Check bathrooms
      if (
        !excludeFilters.includes("bathrooms") &&
        this.options.bathrooms &&
        this.options.bathrooms.length > 0 &&
        !this.options.bathrooms.includes("all")
      ) {
        return true;
      }

      // Check price range (if it's not the default)
      if (!excludeFilters.includes("priceRange")) {
        if (
          this.priceRangeCache &&
          this.options.priceRange.min !== null &&
          this.options.priceRange.max !== null
        ) {
          if (
            this.options.priceRange.min !== this.priceRangeCache.min ||
            this.options.priceRange.max !== this.priceRangeCache.max
          ) {
            return true;
          }
        }
      }

      // Check available filter
      if (
        !excludeFilters.includes("available") &&
        this.options.available === true
      ) {
        return true;
      }

      // Check date range
      if (!excludeFilters.includes("dateRange")) {
        let hasDateFilter = false;
        if (this.quickDatePickerObj) {
          const startDate = this.quickDatePickerObj.getStartDate();
          const endDate = this.quickDatePickerObj.getEndDate();
          if (startDate && endDate) hasDateFilter = true;
        } else if (this.datePickerObj) {
          const startDate = this.datePickerObj.getStartDate();
          const endDate = this.datePickerObj.getEndDate();
          if (startDate && endDate) hasDateFilter = true;
        }
        if (hasDateFilter) return true;
      }

      // Check search term
      if (
        !excludeFilters.includes("searchTerm") &&
        this.options.searchTerm &&
        this.options.searchTerm.length > 0
      ) {
        return true;
      }

      return false;
    }

    updateMainFilterOptions() {
      // Merkezi facet hesaplama ile tüm filtreleri güncelle
      const facets = this.calculateFacets();

      // Location ve residence type'ları güncelle
      this.updateLocationFilterOptionsWithFacets(facets.locations);
      this.updateResidenceTypeFilterOptionsWithFacets(facets.residenceTypes);

      // Fiyat aralığını ve histogramı güncelle
      if (facets.priceRange) {
        this.updatePriceRangeWithFacets(facets.priceRange);
      }

      // Oda seçeneklerini güncelle (ANINDA!)
      this.updateRoomOptionsWithFacets({
        livingRooms: facets.livingRooms,
        bedrooms: facets.bedrooms,
        bathrooms: facets.bathrooms,
      });

      // Update price slider to show current filter values
      if (
        this.priceSlider &&
        this.options.priceRange.min !== null &&
        this.options.priceRange.max !== null
      ) {
        requestAnimationFrame(() => {
          this.priceSlider.$set({
            values: [this.options.priceRange.min, this.options.priceRange.max],
          });

          // Update input fields to match
          if (this.priceRangeMin) {
            this.priceRangeMin.value = this.options.priceRange.min;
          }
          if (this.priceRangeMax) {
            this.priceRangeMax.value = this.options.priceRange.max;
          }

          // Update histogram selection
          if (this.priceRangeCache) {
            const minValue = this.priceRangeCache.min;
            const binSize = 1000;
            this.updateHistogramSelection(
              this.options.priceRange.min,
              this.options.priceRange.max,
              minValue,
              binSize
            );
          }
        });
      }
    }

    updatePriceRangeForFilters() {
      if (!this.priceRange || !this.priceSlider || !this.priceRangeCache)
        return;

      // Check if any filters are active (excluding price range)
      const hasActiveFilters = this.hasActiveFiltersExcluding(["priceRange"]);

      // Check if price range itself is actively filtered (not at original min/max)
      const isPriceRangeFiltered =
        this.options.priceRange.min !== this.priceRangeCache.min ||
        this.options.priceRange.max !== this.priceRangeCache.max;

      // If no filters active AND price range is not filtered, reset to original min/max
      if (!hasActiveFilters && !isPriceRangeFiltered) {
        const minValue = this.priceRangeCache.min;
        const maxValue = this.priceRangeCache.max;

        // Reset options to original values
        this.options.priceRange.min = minValue;
        this.options.priceRange.max = maxValue;

        // Update the slider's min/max range and values together
        // Use requestAnimationFrame to ensure smooth update
        requestAnimationFrame(() => {
          this.priceSlider.$set({
            min: minValue,
            max: maxValue,
            values: [minValue, maxValue],
          });

          // Update input fields
          if (this.priceRangeMin) {
            this.priceRangeMin.value = minValue;
          }
          if (this.priceRangeMax) {
            this.priceRangeMax.value = maxValue;
          }
        });

        return;
      }

      // If price range is filtered but no other filters, keep the user's selection
      if (!hasActiveFilters && isPriceRangeFiltered) {
        // Just keep current price range - don't reset
        return;
      }

      // Get properties filtered by everything except price range
      const propertiesForPrice = this.getFilteredPropertiesExcluding([
        "priceRange",
      ]);

      if (propertiesForPrice.length === 0) return;

      // Calculate min and max from filtered properties
      const prices = propertiesForPrice.map((property) => {
        return property.priceRange.MonthlyPrices["12_12"]["cash"];
      });

      const minValue = Math.min(...prices);
      const maxValue = Math.max(...prices);

      // If current values are outside the new range OR not set, adjust them
      if (
        this.options.priceRange.min === null ||
        this.options.priceRange.min < minValue ||
        this.options.priceRange.min > maxValue
      ) {
        this.options.priceRange.min = minValue;
      }
      if (
        this.options.priceRange.max === null ||
        this.options.priceRange.max > maxValue ||
        this.options.priceRange.max < minValue
      ) {
        this.options.priceRange.max = maxValue;
      }

      // Update the slider with new min/max and values together
      // Use requestAnimationFrame to ensure smooth update
      requestAnimationFrame(() => {
        this.priceSlider.$set({
          min: minValue,
          max: maxValue,
          values: [this.options.priceRange.min, this.options.priceRange.max],
        });

        // Update input fields
        if (this.priceRangeMin) {
          this.priceRangeMin.value = this.options.priceRange.min;
        }
        if (this.priceRangeMax) {
          this.priceRangeMax.value = this.options.priceRange.max;
        }
      });
    }

    updateRoomOptionsForFilters() {
      // Check if any filters are active (excluding rooms)
      const hasActiveFilters = this.hasActiveFiltersExcluding([
        "livingRooms",
        "bedrooms",
        "bathrooms",
      ]);

      // If no filters active, enable all room options
      if (!hasActiveFilters) {
        // Enable all living rooms
        if (this.livingRooms) {
          const checkboxes = this.livingRooms.querySelectorAll(
            'input[type="checkbox"]:not([value="all"])'
          );
          checkboxes.forEach((checkbox) => {
            const parent = checkbox.closest("label") || checkbox.parentElement;
            parent.style.opacity = "1";
            parent.style.pointerEvents = "auto";
            checkbox.disabled = false;
          });
        }

        // Enable all bedrooms
        if (this.bedrooms) {
          const checkboxes = this.bedrooms.querySelectorAll(
            'input[type="checkbox"]:not([value="all"])'
          );
          checkboxes.forEach((checkbox) => {
            const parent = checkbox.closest("label") || checkbox.parentElement;
            parent.style.opacity = "1";
            parent.style.pointerEvents = "auto";
            checkbox.disabled = false;
          });
        }

        // Enable all bathrooms
        if (this.bathrooms) {
          const checkboxes = this.bathrooms.querySelectorAll(
            'input[type="checkbox"]:not([value="all"])'
          );
          checkboxes.forEach((checkbox) => {
            const parent = checkbox.closest("label") || checkbox.parentElement;
            parent.style.opacity = "1";
            parent.style.pointerEvents = "auto";
            checkbox.disabled = false;
          });
        }

        return;
      }

      // Get properties filtered by everything except rooms
      const propertiesForRooms = this.getFilteredPropertiesExcluding([
        "livingRooms",
        "bedrooms",
        "bathrooms",
      ]);

      if (propertiesForRooms.length === 0) return;

      // Get available living rooms
      const availableLivingRooms = [
        ...new Set(
          propertiesForRooms.map((p) => {
            const livingRooms =
              p.livingRooms ||
              parseInt(p.residenceTypes[0]?.name?.split("+")[1]) ||
              0;
            if (livingRooms >= 4) return "4+";
            return String(livingRooms);
          })
        ),
      ];

      // Get available bedrooms
      const availableBedrooms = [
        ...new Set(
          propertiesForRooms.map((p) => {
            const bedrooms =
              p.bedrooms ||
              parseInt(p.residenceTypes[0]?.name?.split("+")[0]) ||
              0;
            if (bedrooms >= 4) return "4+";
            return String(bedrooms);
          })
        ),
      ];

      // Get available bathrooms
      const availableBathrooms = [
        ...new Set(
          propertiesForRooms.map((p) => {
            const bathrooms = p.bathrooms || 0;
            if (bathrooms >= 4) return "4+";
            return String(bathrooms);
          })
        ),
      ];

      // Update living rooms checkboxes
      if (this.livingRooms) {
        const checkboxes = this.livingRooms.querySelectorAll(
          'input[type="checkbox"]:not([value="all"])'
        );
        checkboxes.forEach((checkbox) => {
          const parent = checkbox.closest("label") || checkbox.parentElement;
          if (availableLivingRooms.includes(checkbox.value)) {
            parent.style.opacity = "1";
            parent.style.pointerEvents = "auto";
            checkbox.disabled = false;
          } else {
            parent.style.opacity = "0.4";
            parent.style.pointerEvents = "none";
            checkbox.disabled = true;
            if (checkbox.checked) {
              checkbox.checked = false;
              // Remove from options
              this.options.livingRooms = this.options.livingRooms.filter(
                (v) => v !== checkbox.value
              );
            }
          }
        });
      }

      // Update bedrooms checkboxes
      if (this.bedrooms) {
        const checkboxes = this.bedrooms.querySelectorAll(
          'input[type="checkbox"]:not([value="all"])'
        );
        checkboxes.forEach((checkbox) => {
          const parent = checkbox.closest("label") || checkbox.parentElement;
          if (availableBedrooms.includes(checkbox.value)) {
            parent.style.opacity = "1";
            parent.style.pointerEvents = "auto";
            checkbox.disabled = false;
          } else {
            parent.style.opacity = "0.4";
            parent.style.pointerEvents = "none";
            checkbox.disabled = true;
            if (checkbox.checked) {
              checkbox.checked = false;
              // Remove from options
              this.options.bedrooms = this.options.bedrooms.filter(
                (v) => v !== checkbox.value
              );
            }
          }
        });
      }

      // Update bathrooms checkboxes
      if (this.bathrooms) {
        const checkboxes = this.bathrooms.querySelectorAll(
          'input[type="checkbox"]:not([value="all"])'
        );
        checkboxes.forEach((checkbox) => {
          const parent = checkbox.closest("label") || checkbox.parentElement;
          if (availableBathrooms.includes(checkbox.value)) {
            parent.style.opacity = "1";
            parent.style.pointerEvents = "auto";
            checkbox.disabled = false;
          } else {
            parent.style.opacity = "0.4";
            parent.style.pointerEvents = "none";
            checkbox.disabled = true;
            if (checkbox.checked) {
              checkbox.checked = false;
              // Remove from options
              this.options.bathrooms = this.options.bathrooms.filter(
                (v) => v !== checkbox.value
              );
            }
          }
        });
      }
    }

    /**
     * Facet tabanlı oda seçenekleri güncelleme
     * Eğer seçenek listede hiç yoksa (initial data'da yok) → Tamamen gizle
     * Eğer seçenek listede var ama filtrelerde yok (count = 0) → Disabled göster
     * Eğer seçenek listede var ve filtrelerde de var (count > 0) → Aktif göster
     */
    updateRoomOptionsWithFacets(roomFacets) {
      const tooltipText = "Seçtiğiniz filtrelere göre bu seçenek mevcut değil";

      // Living Rooms - Listede yoksa gizle, varsa count'a göre disabled/enabled yap
      if (this.livingRooms && this.roomOptionsCache) {
        const checkboxes = this.livingRooms.querySelectorAll(
          'input[type="checkbox"]:not([value="all"])'
        );
        checkboxes.forEach((checkbox) => {
          const parent =
            checkbox.closest(".flats-filters-option-button") ||
            checkbox.closest("label") ||
            checkbox.parentElement;
          const label =
            parent.querySelector("label") ||
            (parent.tagName === "LABEL" ? parent : null);
          const value = checkbox.value;
          const count = roomFacets.livingRooms[value] || 0;

          // Eğer bu seçenek hiç listede yoksa (initial data'da yok), tamamen gizle
          if (!this.roomOptionsCache.livingRooms.includes(value)) {
            parent.style.display = "none";
            checkbox.disabled = true;
            if (checkbox.checked) {
              checkbox.checked = false;
              this.options.livingRooms =
                this.options.livingRooms?.filter((v) => v !== value) || [];
            }
            parent.removeAttribute("data-tooltip");
          } else if (count > 0) {
            // Listede var ve mevcut filtrelerde de var - aktif göster
            parent.style.display = "";
            checkbox.disabled = false;
            parent.removeAttribute("data-tooltip");
          } else {
            // Listede var ama mevcut filtrelerde yok - disabled göster + tooltip
            parent.style.display = "";
            checkbox.disabled = true;
            parent.setAttribute("data-tooltip", tooltipText);
            if (checkbox.checked) {
              checkbox.checked = false;
              this.options.livingRooms =
                this.options.livingRooms?.filter((v) => v !== value) || [];
            }
          }
        });

        // Eğer hiçbir şey seçili kalmadıysa, "all" seç
        if (
          !this.options.livingRooms ||
          this.options.livingRooms.length === 0 ||
          !this.options.livingRooms.some((v) => v !== "all")
        ) {
          const allCheckbox =
            this.livingRooms.querySelector('input[value="all"]');
          if (allCheckbox) allCheckbox.checked = true;
          this.options.livingRooms = ["all"];
        }
      }

      // Bedrooms - Listede yoksa gizle, varsa count'a göre disabled/enabled yap
      if (this.bedrooms && this.roomOptionsCache) {
        const checkboxes = this.bedrooms.querySelectorAll(
          'input[type="checkbox"]:not([value="all"])'
        );
        checkboxes.forEach((checkbox) => {
          const parent =
            checkbox.closest(".flats-filters-option-button") ||
            checkbox.closest("label") ||
            checkbox.parentElement;
          const label =
            parent.querySelector("label") ||
            (parent.tagName === "LABEL" ? parent : null);
          const value = checkbox.value;
          const count = roomFacets.bedrooms[value] || 0;

          // Eğer bu seçenek hiç listede yoksa (initial data'da yok), tamamen gizle
          if (!this.roomOptionsCache.bedrooms.includes(value)) {
            parent.style.display = "none";
            checkbox.disabled = true;
            if (checkbox.checked) {
              checkbox.checked = false;
              this.options.bedrooms =
                this.options.bedrooms?.filter((v) => v !== value) || [];
            }
            parent.removeAttribute("data-tooltip");
          } else if (count > 0) {
            // Listede var ve mevcut filtrelerde de var - aktif göster
            parent.style.display = "";
            checkbox.disabled = false;
            parent.removeAttribute("data-tooltip");
          } else {
            // Listede var ama mevcut filtrelerde yok - disabled göster + tooltip
            parent.style.display = "";
            checkbox.disabled = true;
            parent.setAttribute("data-tooltip", tooltipText);
            if (checkbox.checked) {
              checkbox.checked = false;
              this.options.bedrooms =
                this.options.bedrooms?.filter((v) => v !== value) || [];
            }
          }
        });

        // Eğer hiçbir şey seçili kalmadıysa, "all" seç
        if (
          !this.options.bedrooms ||
          this.options.bedrooms.length === 0 ||
          !this.options.bedrooms.some((v) => v !== "all")
        ) {
          const allCheckbox = this.bedrooms.querySelector('input[value="all"]');
          if (allCheckbox) allCheckbox.checked = true;
          this.options.bedrooms = ["all"];
        }
      }

      // Bathrooms - Listede yoksa gizle, varsa count'a göre disabled/enabled yap
      if (this.bathrooms && this.roomOptionsCache) {
        const checkboxes = this.bathrooms.querySelectorAll(
          'input[type="checkbox"]:not([value="all"])'
        );
        checkboxes.forEach((checkbox) => {
          const parent =
            checkbox.closest(".flats-filters-option-button") ||
            checkbox.closest("label") ||
            checkbox.parentElement;
          const label =
            parent.querySelector("label") ||
            (parent.tagName === "LABEL" ? parent : null);
          const value = checkbox.value;
          const count = roomFacets.bathrooms[value] || 0;

          // Eğer bu seçenek hiç listede yoksa (initial data'da yok), tamamen gizle
          if (!this.roomOptionsCache.bathrooms.includes(value)) {
            parent.style.display = "none";
            checkbox.disabled = true;
            if (checkbox.checked) {
              checkbox.checked = false;
              this.options.bathrooms =
                this.options.bathrooms?.filter((v) => v !== value) || [];
            }
            parent.removeAttribute("data-tooltip");
          } else if (count > 0) {
            // Listede var ve mevcut filtrelerde de var - aktif göster
            parent.style.display = "";
            checkbox.disabled = false;
            parent.removeAttribute("data-tooltip");
          } else {
            // Listede var ama mevcut filtrelerde yok - disabled göster + tooltip
            parent.style.display = "";
            checkbox.disabled = true;
            parent.setAttribute("data-tooltip", tooltipText);
            if (checkbox.checked) {
              checkbox.checked = false;
              this.options.bathrooms =
                this.options.bathrooms?.filter((v) => v !== value) || [];
            }
          }
        });

        // Eğer hiçbir şey seçili kalmadıysa, "all" seç
        if (
          !this.options.bathrooms ||
          this.options.bathrooms.length === 0 ||
          !this.options.bathrooms.some((v) => v !== "all")
        ) {
          const allCheckbox =
            this.bathrooms.querySelector('input[value="all"]');
          if (allCheckbox) allCheckbox.checked = true;
          this.options.bathrooms = ["all"];
        }
      }
    }

    /**
     * Checkbox yanına sonuç sayısını ekler
     */
    updateCheckboxCount(parent, count, showCount) {
      if (!showCount || count === 0) {
        // Sayıyı kaldır
        const existingCount = parent.querySelector(".filter-result-count");
        if (existingCount) existingCount.remove();
        return;
      }

      // Label'ı bul
      const label =
        parent.querySelector("label") ||
        (parent.tagName === "LABEL" ? parent : null);
      if (!label) return;

      let countSpan = label.querySelector(".filter-result-count");
      if (!countSpan) {
        countSpan = document.createElement("span");
        countSpan.className = "filter-result-count";
        countSpan.style.cssText =
          "margin-left: 4px; color: #999; font-size: 0.875em;";
        label.appendChild(countSpan);
      }
      countSpan.textContent = `(${count})`;
    }

    getFilteredPropertiesExcluding(excludeFilters = []) {
      // Returns properties filtered by all current filters EXCEPT the ones in excludeFilters array
      // This allows us to show what options are available for a specific filter

      let properties = this.getVisibleProperties(this.data);

      // Cache current moment
      if (!this.currentMoment) {
        this.currentMoment = moment();
      }

      const matchesFilter = (value, filterOptions) => {
        return filterOptions.some((option) => {
          if (option === "4+") return value >= 4;
          return value === parseInt(option);
        });
      };

      // Apply available filter
      if (
        this.options.available === true &&
        !excludeFilters.includes("available")
      ) {
        properties = properties.filter((property) => {
          if (property.musaitlikDurumu === true) return true;
          const availabilityDate = moment(
            property.musaitlikTarihi,
            "YYYY-MM-DD"
          );
          return availabilityDate.isBefore(this.currentMoment);
        });
      }

      // Apply bedroom filter
      if (
        this.options.bedrooms?.length > 0 &&
        !this.options.bedrooms.includes("all") &&
        !excludeFilters.includes("bedrooms")
      ) {
        properties = properties.filter((property) => {
          const propertyBedrooms =
            property.bedrooms ||
            parseInt(property.residenceTypes[0]?.name?.split("+")[0]) ||
            0;
          return matchesFilter(propertyBedrooms, this.options.bedrooms);
        });
      }

      // Apply living room filter
      if (
        this.options.livingRooms?.length > 0 &&
        !this.options.livingRooms.includes("all") &&
        !excludeFilters.includes("livingRooms")
      ) {
        properties = properties.filter((property) => {
          const propertyLivingRooms =
            property.livingRooms ||
            parseInt(property.residenceTypes[0]?.name?.split("+")[1]) ||
            0;
          return matchesFilter(propertyLivingRooms, this.options.livingRooms);
        });
      }

      // Apply bathroom filter
      if (
        this.options.bathrooms?.length > 0 &&
        !this.options.bathrooms.includes("all") &&
        !excludeFilters.includes("bathrooms")
      ) {
        properties = properties.filter((property) => {
          return matchesFilter(property.bathrooms, this.options.bathrooms);
        });
      }

      // Apply price range filter
      if (
        this.options.priceRange.min !== null &&
        this.options.priceRange.max !== null &&
        !excludeFilters.includes("priceRange")
      ) {
        properties = properties.filter((property) => {
          const price = property.priceRange.MonthlyPrices["12_12"]["cash"];
          return (
            price >= this.options.priceRange.min &&
            price <= this.options.priceRange.max
          );
        });
      }

      // Apply location filter
      if (
        this.options.location &&
        this.options.location.length > 0 &&
        !excludeFilters.includes("location")
      ) {
        properties = properties.filter((property) => {
          return this.options.location.some((location) => {
            const addressMatch =
              property.address && property.address.includes(location);
            const districtMatch =
              property.buildingDistrictMainName &&
              property.buildingDistrictMainName === location;
            return addressMatch || districtMatch;
          });
        });
      }

      // Apply project filter
      if (
        this.options.projectName &&
        this.options.projectName.length > 0 &&
        !excludeFilters.includes("projectName")
      ) {
        properties = properties.filter((property) => {
          return this.options.projectName.includes(property.projectName);
        });
      }

      // Apply residence type filter
      if (
        this.options.residenceType &&
        this.options.residenceType.length > 0 &&
        !excludeFilters.includes("residenceType")
      ) {
        properties = properties.filter((property) => {
          const propertyResidenceType =
            property.residenceTypes?.[0]?.name || property.odaSayisi;
          return this.options.residenceType.includes(propertyResidenceType);
        });
      }

      // Apply date range filter
      if (!excludeFilters.includes("dateRange")) {
        let startDate = null;
        let endDate = null;

        if (this.quickDatePickerObj) {
          startDate = this.quickDatePickerObj.getStartDate();
          endDate = this.quickDatePickerObj.getEndDate();
        } else if (this.datePickerObj) {
          startDate = this.datePickerObj.getStartDate();
          endDate = this.datePickerObj.getEndDate();
        }

        if (startDate && endDate) {
          properties = properties.filter((property) => {
            if (property.musaitlikDurumu === true) return true;
            const availabilityDate = moment(
              property.musaitlikTarihi,
              "YYYY-MM-DD"
            );
            const startMoment = moment(startDate);
            return availabilityDate.isSameOrBefore(startMoment, "day");
          });
        }
      }

      // Apply search term filter
      if (this.options.searchTerm && !excludeFilters.includes("searchTerm")) {
        const searchTerm = this.options.searchTerm
          .trim()
          .toLocaleLowerCase("tr-TR");
        const searchTermNum = parseInt(searchTerm);
        const isNumericSearch =
          !isNaN(searchTermNum) && searchTerm.trim() === String(searchTermNum);

        properties = properties.filter((property) => {
          if (isNumericSearch) {
            const idCodeNum = parseInt(property.idCode);
            if (idCodeNum === searchTermNum) return true;
          }

          const projectNameLower = (
            property.projectName || ""
          ).toLocaleLowerCase("tr-TR");
          const descriptionLower = (
            property.description || ""
          ).toLocaleLowerCase("tr-TR");
          const addressLower = (property.address || "").toLocaleLowerCase(
            "tr-TR"
          );
          const idCodeStr = String(property.idCode || "");

          return (
            projectNameLower.includes(searchTerm) ||
            descriptionLower.includes(searchTerm) ||
            addressLower.includes(searchTerm) ||
            (!isNumericSearch && idCodeStr === searchTerm) ||
            (!isNumericSearch &&
              !isNaN(parseInt(searchTerm)) &&
              parseInt(idCodeStr) === parseInt(searchTerm))
          );
        });
      }

      return properties;
    }

    clearSearch() {
      if (this.searchInput) {
        this.searchInput.value = "";
      }
      if (this.searchInputMobile) {
        this.searchInputMobile.value = "";
      }
      if (this.searchModalInput) {
        this.searchModalInput.value = "";
        this.searchModalClear?.classList.remove("visible");
      }
      // Hide clear buttons
      if (this.clearSearchButton) {
        this.clearSearchButton.classList.remove("visible");
      }
      if (this.clearSearchButtonMobile) {
        this.clearSearchButtonMobile.classList.remove("visible");
      }
      // Clear search term from filters
      this.options.searchTerm = "";
      // Reset internal search flag
      this.isInternalSearch = false;
      // Clear map selection
      this.mapSelectionCount = 0;
      this.hideMapSelectionBadge();
      // Apply filters to remove search filter
      this.applyFilters();
      // Update search button state
      this.updateSearchButtonState();
    }

    showMapSelectionBadge(count) {
      // Create badge if it doesn't exist
      if (!this.mapSelectionBadge) {
        this.mapSelectionBadge = document.createElement("div");
        this.mapSelectionBadge.className = "flats__map-selection-badge";
        this.mapSelectionBadge.innerHTML = `
          <span class="flats__map-selection-text">Haritadan ${count} daire seçildi</span>
          <button class="flats__map-selection-clear" type="button" title="Harita seçimini temizle">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
              <path d="M9 3L3 9M3 3L9 9" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </button>
        `;

        // Add click handler to clear button
        const clearBtn = this.mapSelectionBadge.querySelector(
          ".flats__map-selection-clear"
        );
        clearBtn.addEventListener("click", () => {
          this.clearMapSelection();
        });

        // Insert at the top of map container
        if (this.mapContainer) {
          this.mapContainer.style.position = "relative";
          this.mapContainer.insertBefore(
            this.mapSelectionBadge,
            this.mapContainer.firstChild
          );
        }
      } else {
        // Update count
        const textSpan = this.mapSelectionBadge.querySelector(
          ".flats__map-selection-text"
        );
        if (textSpan) {
          textSpan.textContent = `Haritadan ${count} daire seçildi`;
        }
        this.mapSelectionBadge.style.display = "flex";
      }
    }

    hideMapSelectionBadge() {
      if (this.mapSelectionBadge) {
        this.mapSelectionBadge.style.display = "none";
      }
    }

    clearMapSelection() {
      // Reset map selection
      this.mapSelectionCount = 0;
      this.hideMapSelectionBadge();
      this.isInternalSearch = false;

      // Reset all filters to show all properties
      this.filteredData = null;
      this.page = 1;

      // Re-render
      this.render(true);

      // Update map markers
      if (this.mapInitialized) {
        this.updateMapMarkers();
      }
    }

    search() {
      // Use Turkish locale for proper case conversion (İ -> i, I -> ı)
      // Get value from whichever input exists, prioritize desktop
      let searchValue = "";
      if (this.searchInput) {
        searchValue = this.searchInput.value;
        // Sync to mobile
        if (this.searchInputMobile) {
          this.searchInputMobile.value = searchValue;
        }
      } else if (this.searchInputMobile) {
        searchValue = this.searchInputMobile.value;
      }
      this.options.searchTerm = searchValue.trim().toLocaleLowerCase("tr-TR");
      // Update available filter state immediately
      this.updateAvailableFilterState();
      this.applyFilters();
      // Update search button state and field value
      this.updateSearchButtonState();
      this.updateSearchFieldValue();
    }
    render(initial = true) {
      // If this is an internal search (from marker click), hide search term from user
      if (this.isInternalSearch) {
        if (this.searchInput) {
          this.searchInput.value = "";
        }
        if (this.searchInputMobile) {
          this.searchInputMobile.value = "";
        }
        if (this.searchModalInput) {
          this.searchModalInput.value = "";
        }
        // Hide clear buttons
        if (this.clearSearchButton) {
          this.clearSearchButton.classList.remove("visible");
        }
        if (this.clearSearchButtonMobile) {
          this.clearSearchButtonMobile.classList.remove("visible");
        }
        // Reset flag after clearing inputs
        this.isInternalSearch = false;
      }

      // Show map selection badge if there's a map selection
      if (this.mapSelectionCount > 0) {
        this.showMapSelectionBadge(this.mapSelectionCount);
      } else {
        this.hideMapSelectionBadge();
      }

      const data = this.filteredData || this.data;
      const visibleProperties = this.getVisibleProperties(data);
      if (initial) {
        this.cardContainer.innerHTML = ""; // Clear previous cards
        this.initPagination();
        if (visibleProperties.length <= this.paginationSize) {
          this.paginationShowMore.classList.add("hidden");
        } else {
          this.paginationShowMore.classList.remove("hidden");
        }
        if (!data || !data.properties || visibleProperties.length === 0) {
          this.loading.classList.add("hidden");
          this.cardContainer.innerHTML = `<p>${window.translations.flats.no_results}</p>`;
          return;
        }
      }

      const start = (this.page - 1) * this.paginationSize;
      const end = start + this.paginationSize;
      const properties = visibleProperties.slice(start, end);

      // Use DocumentFragment for better performance
      const fragment = document.createDocumentFragment();

      for (const property of properties) {
        console.log('Property ID:', property.idCode, 'Status:', property.status);
        const card = this.cardTemplate.content.cloneNode(true);
        card.querySelector(".flats__card-title-text").textContent =
          property.projectName;
        card.querySelector(
          ".flats__card-title-id"
        ).textContent = `ID: ${property.idCode}`;
        if (
          property.buildingDistrictMainName &&
          property.buildingNeighborhoodName &&
          property.buildingCityName
        ) {
          card.querySelector(
            ".flats__card-address"
          ).textContent = `${property.buildingNeighborhoodName} / ${property.buildingDistrictMainName} / ${property.buildingCityName}`;
        } else {
          card.querySelector(".flats__card-address").textContent =
            property.address.split(", ").reverse().join(" / ");
        }
        // Ensure currencySelector is initialized before formatting price
        if (!window.currencySelector) {
          window.currencySelector = {
            name: "TRY",
            rate: 1,
            symbol: "TL",
          };
        }
        const priceValue = property.priceRange?.MonthlyPrices?.["12_12"]?.["cash"];
        card.querySelector(".flats__card-price-value").textContent =
          window.formatPrice(priceValue, 0);
        card.querySelector(".flats__card-price-value").dataset.price =
          priceValue || "";
        // Check if the property has features. If not remove
        if (property.odaSayisi) {
          card.querySelector(".flats__card-specs-label--rooms").textContent =
            property.odaSayisi;
        } else {
          card
            .querySelector(".flats__card-specs-label--rooms")
            .parentElement.remove();
        }
        if (property.bathrooms) {
          card.querySelector(
            ".flats__card-specs-label--baths"
          ).textContent = `${property.bathrooms} Banyo`;
        } else {
          card
            .querySelector(".flats__card-specs-label--baths")
            .parentElement.remove();
        }
        if (property.netMetrekare) {
          card.querySelector(
            ".flats__card-specs-label--sqm"
          ).textContent = `${property.netMetrekare} m²`;
        } else {
          card
            .querySelector(".flats__card-specs-label--sqm")
            .parentElement.remove();
        }
        const availabilityText = card.querySelector(
          ".flats__card-availability-text"
        );
        if (availabilityText && !availabilityText.dataset.defaultText) {
          availabilityText.dataset.defaultText = availabilityText.textContent;
        }
        const availabilityInfo = this.getAvailabilityDisplay(property);
        card.querySelector(".flats__card-availability-date").textContent =
          availabilityInfo.dateText;
        if (availabilityText) {
          availabilityText.textContent =
            availabilityInfo.label ||
            availabilityText.dataset.defaultText ||
            availabilityText.textContent;
        }

        // Change Links
        card.querySelectorAll("a").forEach((card) => {
          card.href = `${
            document.documentElement.lang === "tr" ? "" : "/en"
          }/products/${property.handle}`;
        });
        // Render Images
        const imageTemplate = card.querySelector(
          ".flats__card-image-element"
        ).parentElement;
        let imageIndex = 0;
        for (const imageUrl of property.images) {
          if (imageIndex >= 5) break;
          const image = imageTemplate.cloneNode(true);
          image.querySelector("img").src =
            imageUrl.split("?")[0] + "?width=500";
          image.querySelector("img").alt = property.projectName;
          if (imageIndex != 0) {
            image.querySelector("img").setAttribute("loading", "lazy");
          }
          image.href = `${
            document.documentElement.lang === "tr" ? "" : "/en"
          }/products/${property.handle}`;
          card.querySelector(".splide__list").appendChild(image);
          imageIndex++;
        }
        imageTemplate.remove();
        
        // Store property id in card for comparison visual updates and card-compare
        const cardElement = card.querySelector(".flats__card");
        if (cardElement) {
          cardElement.dataset.propertyId = property.idCode;

          const compareBtn = cardElement.querySelector(
            ".flats__card-compare-toggle"
          );
          if (compareBtn) {
            compareBtn.addEventListener("click", (e) => {
              e.preventDefault();
              e.stopPropagation();
              // Bildirimi comparison modülüne ilet
              window.dispatchEvent(
                new CustomEvent("card-compare-toggle", {
                  detail: { propertyId: property.idCode },
                })
              );
            });
          }
        }
        
        // Mount Splide before appending to DOM for better performance
        const splideElement = card.querySelector(".splide");
        if (splideElement) {
          new Splide(splideElement, {
            arrows: true,
            pagination: true,
            lazyLoad: "nearby",
            preloadPages: 1,
          }).mount();
        }
        fragment.appendChild(card);
      }

      // Append all cards at once for better performance
      this.cardContainer.appendChild(fragment);

      if (initial) {
        this.loading.classList.add("hidden");
        // Only initialize map once
        if (!this.mapInitialized) {
          if (window.isGoogleLibraryLoaded) {
            this.initMap();
            this.mapInitialized = true;
          } else {
            const mapInitHandler = () => {
              this.initMap();
              this.mapInitialized = true;
              window.removeEventListener("google-maps-loaded", mapInitHandler);
            };
            window.addEventListener("google-maps-loaded", mapInitHandler);
          }
        }
      }
    }
    initMap() {
      // Header yüksekliği bazı sayfalarda olmayabiliyor; guard ekle
      const headerEl = document.querySelector(
        ".shopify-section-group-header-group.section-header"
      );
      const headerHeight = headerEl ? headerEl.offsetHeight : 0;

      if (this.mapContainer) {
        this.mapContainer.style.maxHeight = `calc(100svh - ${headerHeight}px)`;
      }

      const data = this.filteredData || this.data;

      const renderer = {
        render: ({ count, position }) => {
          const divString = `
            <div class="flats__map-marker--cluster flats__map-marker" data-count="${count}">
              <span class="flats__map-marker--count">${count}</span>
              <div class="flats__map-marker--triangle"></div>
            </div>`;
          const title = `${count} Daire`;
          const zIndex = Number(google.maps.Marker.MAX_ZINDEX) + count;

          const parser = new DOMParser();
          const divElement = parser.parseFromString(divString, "text/html").body
            .firstChild;

          const clusterOptions = {
            map: this.map,
            position,
            zIndex,
            title,
            content: divElement,
          };

          const marker = new google.maps.marker.AdvancedMarkerElement(
            clusterOptions
          );

          return marker;
        },
      };

      if (!this.map) {
        this.map = new google.maps.Map(this.mapContainer, {
          center: {
            lat: 41.0082, // Default to Istanbul coordinates
            lng: 28.9784,
          },
          zoom: 11,
          mapTypeControl: true,
          streetViewControl: true,
          fullscreenControl: true,
          mapId: "DAIRELER_MAP",
        });
        
        // Add click listener to map to close info window when clicking on empty space
        this.map.addListener("click", () => {
          if (this.currentOpenInfoWindow) {
            this.currentOpenInfoWindow.close();
            this.currentOpenInfoWindow = null;
          }
          if (this.currentLockedMarker) {
            this.currentLockedMarker.isLocked = false;
            this.currentLockedMarker = null;
          }
        });
      }

      if (!this.markerClusterer) {
        this.markerClusterer = new markerClusterer.MarkerClusterer({
          map: this.map,
          renderer: renderer,
        });
      } else {
        this.markerClusterer.clearMarkers();
      }

      this.updateMapMarkers();
    }

    updateMapMarkers() {
      if (!this.map || !this.markerClusterer) return;

      // Ensure currencySelector is initialized before formatting prices
      if (!window.currencySelector) {
        window.currencySelector = {
          name: "TRY",
          rate: 1,
          symbol: "TL",
        };
      }

      // Track currently open info window
      if (!this.currentOpenInfoWindow) {
        this.currentOpenInfoWindow = null;
      }

      // Clear existing markers efficiently
      if (this.markers && this.markers.length > 0) {
        this.markerClusterer.clearMarkers();
        this.markers = [];
      }

      const data = this.filteredData || this.data;
      const bounds = new google.maps.LatLngBounds();

      // Group properties by location (same building)
      const locationGroups = new Map();
      // Filter out properties with status 0 before processing
      const activeProperties = this.getVisibleProperties(data);
      activeProperties.forEach((property) => {
        if (property.buildingLatitude === 0 || property.buildingLongitude === 0)
          return;
        if (!property.buildingLatitude || !property.buildingLongitude) return;
        const locationKey = `${property.buildingLatitude.toFixed(
          6
        )},${property.buildingLongitude.toFixed(6)}`;
        if (!locationGroups.has(locationKey)) {
          locationGroups.set(locationKey, []);
        }
        locationGroups.get(locationKey).push(property);
      });

      console.log("Location groups created:", locationGroups.size, "groups");

      // Batch marker creation
      const newMarkers = [];

      locationGroups.forEach((properties, locationKey) => {
        if (properties.length === 0) return;
        const property = properties[0]; // Use first property for initial display

        // Ensure property has required data
        if (!property.priceRange?.MonthlyPrices?.["12_12"]?.["cash"]) {
          console.warn("Property missing price data:", property.idCode);
          return;
        }
        // Create marker content with navigation arrows if multiple properties at same location
        const hasMultiple = properties.length > 1;
        const divString = `
          <div class="flats__map-marker flats__map-marker--single ${
            hasMultiple ? "flats__map-marker--multiple" : ""
          }">
            ${
              hasMultiple
                ? `
            <div class="flats__map-marker--nav">
              <button class="flats__map-marker--arrow flats__map-marker--prev" data-action="prev">◀</button>
              <span class="flats__map-marker--count">${properties.length}</span>
              <button class="flats__map-marker--arrow flats__map-marker--next" data-action="next">▶</button>
            </div>
            `
                : ""
            }
            <span class="flats__map-marker--info-price" data-price="${
              property.priceRange?.MonthlyPrices?.["12_12"]?.["cash"] || ""
            }">${window.formatPrice(
          property.priceRange?.MonthlyPrices?.["12_12"]?.["cash"],
          0
        )}</span>
            <div class="flats__map-marker--triangle"></div>
          </div>
        `;
        const parser = new DOMParser();
        const doc = parser.parseFromString(divString, "text/html");
        const divElement = doc.body.firstChild;

        if (!divElement) {
          console.error(
            "Failed to create marker element for property:",
            property.idCode
          );
          return;
        }

        const marker = new google.maps.marker.AdvancedMarkerElement({
          map: this.map,
          position: {
            lat: property.buildingLatitude,
            lng: property.buildingLongitude,
          },
          title: property.projectName,
          content: divElement,
        });

        // Store property data in marker for cluster click handling
        marker.propertyId = property.idCode;
        marker.property = property;
        marker.properties = properties; // Store all properties at this location
        marker.currentPropertyIndex = 0; // Track which property is currently displayed
        marker.isLocked = false;

        // Add click handlers to arrow buttons directly
        if (hasMultiple) {
          const prevButton = divElement.querySelector(
            ".flats__map-marker--prev"
          );
          const nextButton = divElement.querySelector(
            ".flats__map-marker--next"
          );

          const updateMarkerContent = () => {
            const newProperty = marker.properties[marker.currentPropertyIndex];
            marker.property = newProperty;
            marker.propertyId = newProperty.idCode;

            // Update count display
            const countElement = divElement.querySelector(
              ".flats__map-marker--count"
            );
            if (countElement) {
              countElement.textContent = `${marker.currentPropertyIndex + 1}/${marker.properties.length}`;
            }

            // Update price display
            const priceElement = divElement.querySelector(
              ".flats__map-marker--info-price"
            );
            if (priceElement) {
              const priceValue =
                newProperty.priceRange?.MonthlyPrices?.["12_12"]?.["cash"];
              priceElement.setAttribute("data-price", priceValue || "");
              const formattedPrice = window.formatPrice(priceValue, 0);
              priceElement.textContent = formattedPrice;
            }

            // Update info window
            infoWindow.setContent(`<div class="flats__map-marker--info-window">
                      <img class="flats__map-marker--info-window-image" src="${
                        newProperty.images[0]
                      }" alt="${newProperty.projectName}">
                      <div class="flats__map-marker--info-window-content">
                        <span class="flats__map-marker--info-title">${
                          newProperty.projectName
                        }</span>
                        <span class="flats__map-marker--info-price" data-price="${
                          newProperty.priceRange?.MonthlyPrices?.["12_12"]
                            ?.InAdvance || ""
                        }">${window.formatPrice(
              newProperty.priceRange?.MonthlyPrices?.["12_12"]?.["cash"],
              0
            )}</span>
                        <span class="flats__map-marker--info-details">${
                          newProperty.residenceTypes[0]?.name
                        } ${
              newProperty.netMetrekare ? ` | ${newProperty.netMetrekare}` : ""
            }</span>
                      </div>
                    </div>`);
          };

          if (prevButton) {
            const handlePrev = (e) => {
              e.stopPropagation();
              e.stopImmediatePropagation();
              e.preventDefault();
              // iOS: touchstart ile tıklama arasındaki çakışmayı önlemek için
              // touchstart geldiğinde sonraki click'i yok say.
              if (e.type === "click" && prevButton.__ignoreNextClick) {
                prevButton.__ignoreNextClick = false;
                return false;
              }
              marker.currentPropertyIndex =
                (marker.currentPropertyIndex - 1 + marker.properties.length) %
                marker.properties.length;
              updateMarkerContent();
              return false;
            };
            prevButton.addEventListener("click", handlePrev, { passive: false });
            prevButton.addEventListener(
              "touchstart",
              (e) => {
                prevButton.__ignoreNextClick = true;
                handlePrev(e);
              },
              { passive: false }
            );
          }

          if (nextButton) {
            const handleNext = (e) => {
              e.stopPropagation();
              e.stopImmediatePropagation();
              e.preventDefault();
              if (e.type === "click" && nextButton.__ignoreNextClick) {
                nextButton.__ignoreNextClick = false;
                return false;
              }
              marker.currentPropertyIndex =
                (marker.currentPropertyIndex + 1) % marker.properties.length;
              updateMarkerContent();
              return false;
            };
            nextButton.addEventListener("click", handleNext, { passive: false });
            nextButton.addEventListener(
              "touchstart",
              (e) => {
                nextButton.__ignoreNextClick = true;
                handleNext(e);
              },
              { passive: false }
            );
          }
        }
        const infoWindow = new google.maps.InfoWindow({
          content: `<div class="flats__map-marker--info-window">
                      <img class="flats__map-marker--info-window-image" src="${
                        property.images[0]
                      }" alt="${property.projectName}">
                      <div class="flats__map-marker--info-window-content">
                        <span class="flats__map-marker--info-title">${
                          property.projectName
                        }</span>
                        <span class="flats__map-marker--info-price" data-price="${
                          property.priceRange?.MonthlyPrices?.["12_12"]
                            ?.InAdvance || ""
                        }">${window.formatPrice(
            property.priceRange?.MonthlyPrices?.["12_12"]?.["cash"],
            0
          )}</span>
                        <span class="flats__map-marker--info-details">${
                          property.residenceTypes[0]?.name
                        } ${
            property.netMetrekare ? ` | ${property.netMetrekare}` : ""
          }</span>
                      </div>
                    </div>`,
          headerDisabled: true,
        });
        
        // Add click listener using Google Maps addListener
        marker.addListener("click", () => {
          // Unlock previous marker if exists
          if (this.currentLockedMarker) {
            this.currentLockedMarker.isLocked = false;
          }
          
          // Close previously open info window
          if (this.currentOpenInfoWindow) {
            this.currentOpenInfoWindow.close();
          }
          
          // Lock this marker and open info window
          marker.isLocked = true;
          infoWindow.open(this.map, marker);
          
          // Store references
          this.currentOpenInfoWindow = infoWindow;
          this.currentLockedMarker = marker;
          
          // Get all properties at this location
          const sameLocationProperties = marker.properties;

          // Clear other filters
          this.options.available = false;
          this.options.bedrooms = [];
          this.options.livingRooms = [];
          this.options.bathrooms = [];
          this.options.priceRange = { min: null, max: null };
          this.options.location = [];
          this.options.projectName = [];
          this.options.residenceType = [];
          this.options.searchTerm = "";

          // Clear date filters
          if (this.quickDatePickerObj) {
            this.quickDatePickerObj.reset();
          }

          // Set internal search flag to hide search from user
          this.isInternalSearch = true;

          // Track map selection
          this.mapSelectionCount = sameLocationProperties.length;

          // Create filtered data with all properties at this location
          this.filteredData = {
            ...this.data,
            properties: sameLocationProperties,
          };

          // Render the filtered list
          this.page = 1;
          requestAnimationFrame(() => {
            this.render(true);
          });
        });
        
        newMarkers.push(marker);
        bounds.extend(marker.position);
      });

      // Note: We're now iterating over locationGroups, not individual properties

      // Update markers array and add all at once
      this.markers = newMarkers;

      console.log("Created markers:", this.markers.length);

      if (this.markers.length > 0) {
        // Add all markers at once for better performance
        this.markerClusterer.addMarkers(this.markers);

        // Update map bounds
        this.map.fitBounds(bounds);
        this.map.setZoom(Math.min(15, this.map.getZoom()));
      } else {
        console.warn("No markers created!");
      }

      // Add click listener for clusters
      // Store marker to property mapping
      if (!this.markerToProperty) {
        this.markerToProperty = new Map();
      }
      this.markers.forEach((marker) => {
        if (marker.propertyId) {
          this.markerToProperty.set(marker, marker.property);
        }
      });

      // Listen for cluster clicks
      this.markerClusterer.addListener("clusterclick", (event) => {
        const cluster = event.cluster;
        const markers = cluster.markers;

        // Get all properties from markers in this cluster
        const clusterProperties = markers
          .map((m) => this.markerToProperty.get(m))
          .filter((prop) => prop !== undefined);

        if (clusterProperties.length > 0) {
          // Get property IDs
          const propertyIds = clusterProperties.map((p) => p.idCode);

          // Clear filters and search for all properties in this cluster
          this.options.available = false;
          this.options.bedrooms = [];
          this.options.livingRooms = [];
          this.options.bathrooms = [];
          this.options.priceRange = { min: null, max: null };
          this.options.location = [];
          this.options.projectName = [];
          this.options.residenceType = [];

          // Clear date filters
          if (this.quickDatePickerObj) {
            this.quickDatePickerObj.reset();
          }

          // Track map selection
          this.mapSelectionCount = clusterProperties.length;

          // Create filtered data with only cluster properties
          this.filteredData = {
            ...this.data,
            properties: clusterProperties,
          };

          // Update search input to show cluster info
          if (this.searchInput) {
            this.searchInput.value = `${propertyIds.length} daire`;
          }
          if (this.searchInputMobile) {
            this.searchInputMobile.value = `${propertyIds.length} daire`;
          }
          this.options.searchTerm = "";

          // Render the filtered list
          this.page = 1;
          requestAnimationFrame(() => {
            this.render(true);
          });
        }
      });
    }
    initPagination() {
      // Remove existing event listener if any
      if (this.paginationShowMoreHandler) {
        this.paginationShowMore.removeEventListener(
          "click",
          this.paginationShowMoreHandler
        );
      }

      // Create new handler that uses current filteredData (not closure)
      this.paginationShowMoreHandler = () => {
        // Always use current filteredData, not the one from when initPagination was called
        const data = this.filteredData || this.data;
        this.page++;
        const visibleCount = this.getVisibleProperties(data).length;
        if (this.page * this.paginationSize >= visibleCount) {
          this.paginationShowMore.classList.add("hidden");
        }
        this.render(false);
      };

      this.paginationShowMore.addEventListener(
        "click",
        this.paginationShowMoreHandler
      );
    }

    initLocations() {
      const locations = this.data.properties
        .filter((property) => !this.isPropertyHidden(property))
        .flatMap((property) => {
          return (
            property.buildingDistrictMainName ||
            property.address.split(", ")[1]
          );
        });
      const uniqueLocations = [...new Set(locations)].filter((loc) => loc); // Filter out null/undefined

      // Populate main filter locations (if it exists)
      if (this.locations) {
        this.locations.innerHTML = ""; // Clear previous options
        for (const location of uniqueLocations) {
          const div = document.createElement("div");
          div.classList.add("flats__filters-option-checkbox");

          const label = document.createElement("label");
          const input = document.createElement("input");
          input.type = "checkbox";
          input.value = location;
          input.id = `location-${location}`;
          div.appendChild(input);
          if (!!location) {
            let capitalizedLocation =
              location.charAt(0).toUpperCase() +
              location.slice(1).toLowerCase();
            label.textContent = capitalizedLocation;
            label.htmlFor = `location-${location}`;
            div.appendChild(label);
            this.locations.appendChild(div);
          }
        }
      }

      // Populate quick filter location dropdown
      if (this.quickLocationDropdown) {
        const dropdownContent = this.quickLocationDropdown.querySelector(
          ".flats__quick-filter-dropdown-content"
        );
        if (dropdownContent) {
          dropdownContent.innerHTML = ""; // Clear previous

          // Add "All" option
          const allOption = document.createElement("div");
          allOption.className = "flats__quick-filter-option";
          const allCheckbox = document.createElement("div");
          allCheckbox.className = "flats__quick-filter-option-checkbox";
          const allText = document.createElement("span");
          allText.className = "flats__quick-filter-option-text";
          allText.textContent = window.translations?.flats?.all || "Tümü";
          allOption.appendChild(allCheckbox);
          allOption.appendChild(allText);
          allOption.dataset.value = "";
          allOption.classList.add("selected"); // Default selected
          allOption.addEventListener("click", (e) => {
            e.stopPropagation();
            this.options.location = [];
            this.quickLocationValue.textContent =
              window.translations?.flats?.select_location || "Lokasyon seçin";
            dropdownContent
              .querySelectorAll(".flats__quick-filter-option")
              .forEach((opt) => opt.classList.remove("selected"));
            allOption.classList.add("selected");

            // Show all options in this dropdown
            const allLocationOptions = dropdownContent.querySelectorAll(
              '.flats__quick-filter-option:not([data-value=""])'
            );
            allLocationOptions.forEach((opt) => (opt.style.display = ""));

            // Don't close dropdown, let user continue selecting
            // this.quickFilterLocation.classList.remove('active');
            // Update other filters (not this one)
            this.updateAllQuickFilterOptions();
            this.applyFilters();
          });
          dropdownContent.appendChild(allOption);

          // Add location options
          uniqueLocations.forEach((location) => {
            const option = document.createElement("div");
            option.className = "flats__quick-filter-option";
            const checkbox = document.createElement("div");
            checkbox.className = "flats__quick-filter-option-checkbox";
            const text = document.createElement("span");
            text.className = "flats__quick-filter-option-text";
            const capitalizedLocation =
              location.charAt(0).toUpperCase() +
              location.slice(1).toLowerCase();
            text.textContent = capitalizedLocation;
            option.appendChild(checkbox);
            option.appendChild(text);
            option.dataset.value = location;
            option.addEventListener("click", (e) => {
              e.stopPropagation();
              // Toggle selection
              const isSelected = option.classList.contains("selected");

              if (isSelected) {
                // Deselect
                option.classList.remove("selected");
                this.options.location = this.options.location.filter(
                  (loc) => loc !== location
                );
              } else {
                // Select
                option.classList.add("selected");
                if (!this.options.location.includes(location)) {
                  this.options.location.push(location);
                }
              }

              // Update "All" option
              const allOpt = dropdownContent.querySelector(
                '.flats__quick-filter-option[data-value=""]'
              );
              if (allOpt) {
                allOpt.classList.remove("selected");
              }

              this.updateLocationQuickFilter();

              // Immediately update all dropdown options (even if closed)
              // This ensures dropdowns show correct options when opened
              this.updateAllQuickFilterOptions();

              // Update main filters
              this.updateMainFilterOptions();

              // Update available filter state immediately
              this.updateAvailableFilterState();

              // Then apply filters with the cleaned selections
              this.applyFilters();

              // Don't close dropdown, let user continue selecting
              // User can click outside or use close button to close
            });
            dropdownContent.appendChild(option);
          });
        }
      }
    }

    // İyileştirilmiş tam initPriceRange metodu
    initPriceRange() {
      if (!this.priceRange) return;

      // Cache price range if not already cached
      if (!this.priceRangeCache) {
        const prices = this.data.properties
          .filter((property) => !this.isPropertyHidden(property))
          .map(
            (property) => property.priceRange?.MonthlyPrices?.["12_12"]?.["cash"]
          )
          .filter(
            (price) => price !== null && price !== undefined && !isNaN(price)
          )
          .sort((a, b) => a - b);

        // Tüm fiyatları dahil et (outlier temizlemesi YOK)
        const rawMin = prices[0];
        const rawMax = prices[prices.length - 1];

        // Yuvarlama (1000'in katı)
        const min = Math.floor(rawMin / 1000) * 1000;
        const max = Math.ceil(rawMax / 1000) * 1000;

        this.priceRangeCache = { min, max };

        console.log("Price range (TÜM daireler dahil):", {
          min,
          max,
          totalProperties: prices.length,
        });
      }

      // Cache initial room options (which rooms exist in the dataset)
      if (!this.roomOptionsCache) {
        const livingRoomsSet = new Set();
        const bedroomsSet = new Set();
        const bathroomsSet = new Set();

        this.data.properties
          .filter((property) => !this.isPropertyHidden(property))
          .forEach((property) => {
          const livingRooms =
            property.livingRooms ||
            parseInt(property.residenceTypes[0]?.name?.split("+")[1]) ||
            0;
          const bedrooms =
            property.bedrooms ||
            parseInt(property.residenceTypes[0]?.name?.split("+")[0]) ||
            0;
          const bathrooms = property.bathrooms || 0;

          livingRoomsSet.add(livingRooms >= 4 ? "4+" : String(livingRooms));
          bedroomsSet.add(bedrooms >= 4 ? "4+" : String(bedrooms));
          bathroomsSet.add(bathrooms >= 4 ? "4+" : String(bathrooms));
        });

        this.roomOptionsCache = {
          livingRooms: Array.from(livingRoomsSet),
          bedrooms: Array.from(bedroomsSet),
          bathrooms: Array.from(bathroomsSet),
        };

        console.log("Room options cache:", this.roomOptionsCache);
      }

      const minValue = this.priceRangeCache.min;
      const maxValue = this.priceRangeCache.max;

      // Only recreate slider if it doesn't exist or values changed significantly
      if (this.priceSlider) {
        // Update existing slider values if needed
        if (
          this.options.priceRange.min !== null &&
          this.options.priceRange.max !== null
        ) {
          this.priceSlider.$set({
            values: [this.options.priceRange.min, this.options.priceRange.max],
          });
        }
        return;
      }

      this.priceRange.innerHTML = ""; // Clear previous range slider

      // Dinamik bin size hesaplama (hedef: 20-35 bar - sadece veri olanlar)
      const priceSpan = maxValue - minValue;
      const targetBinCount = 30; // Biraz daha fazla bin hedefle
      const calculatedBinSize = priceSpan / targetBinCount;

      // Bin size'ı uygun bir değere yuvarla (1000, 2000, 5000, 10000, vb.)
      let binSize = 1000;
      if (calculatedBinSize > 7500) binSize = 10000;
      else if (calculatedBinSize > 4500) binSize = 5000;
      else if (calculatedBinSize > 2500) binSize = 3000;
      else if (calculatedBinSize > 1500) binSize = 2000;
      else if (calculatedBinSize > 500) binSize = 1000;
      else binSize = 500;

      console.log(
        "Bin size:",
        binSize,
        "Expected bins:",
        Math.ceil(priceSpan / binSize)
      );

      // Calculate histogram data based on product prices
      const prices = this.data.properties
        .filter((property) => !this.isPropertyHidden(property))
        .map((property) => property.priceRange?.MonthlyPrices?.["12_12"]?.["cash"])
        .filter(
          (price) => price !== null && price !== undefined && !isNaN(price)
        );

      console.log("All prices:", prices);
      console.log("Min/Max:", minValue, maxValue);

      // Create histogram: bin prices into ranges and count
      const histogramData = {};

      // Initialize bins from min to max
      for (let i = minValue; i <= maxValue; i += binSize) {
        histogramData[i] = 0;
      }

      // Count prices in each bin
      prices.forEach((price) => {
        // Sadece görünür aralıktaki fiyatları say
        if (price < minValue || price > maxValue) return;

        const binIndex = Math.floor((price - minValue) / binSize);
        const bin = minValue + binIndex * binSize;

        if (histogramData.hasOwnProperty(bin)) {
          histogramData[bin]++;
        }
      });

      console.log("Histogram data:", histogramData);

      // Convert to arrays for RangeSliderPips
      const histogramFrom = [];
      const histogramTo = [];
      for (let i = minValue; i <= maxValue; i += binSize) {
        histogramFrom.push(i);
        histogramTo.push(histogramData[i] || 0);
      }

      // İlk histogram verisini cache'le (fallback için)
      this.histogramInitialData = {
        histogramData,
        minValue,
        maxValue,
        binSize,
      };
      this.currentPriceMinLimit = minValue;
      this.currentPriceMaxLimit = maxValue;
      this.binSize = binSize;

      console.log("Initial histogram data cached:", {
        bins: Object.keys(histogramData).length,
        minValue,
        maxValue,
        binSize,
      });

      // Draw histogram SVG
      console.log("Drawing initial histogram from initPriceRange");
      this.drawHistogram(histogramData, minValue, maxValue, binSize);

      // Set initial States
      this.priceRangeMin.value = minValue;
      this.priceRangeMax.value = maxValue;
      if (this.options.priceRange.min === null) {
        this.options.priceRange.min = minValue;
      } else {
        this.priceRangeMin.value = this.options.priceRange.min;
      }
      if (this.options.priceRange.max === null) {
        this.options.priceRange.max = maxValue;
      } else {
        this.priceRangeMax.value = this.options.priceRange.max;
      }

      // Create the range slider with pips
      this.priceSlider = new RangeSliderPips({
        target: this.priceRange,
        props: {
          values: [this.options.priceRange.min, this.options.priceRange.max],
          pips: true,
          pipstep: binSize,
          min: minValue,
          max: maxValue,
          float: true,
          range: true,
          pushy: true,
          suffix: " TL",
          step: binSize,
          histogramFrom: histogramFrom,
          histogramTo: histogramTo,
          handleFormatter: (v) => {
            return v;
          },
        },
      });

      // Update options and input fields on change
      this.priceSlider.$on("change", (event) => {
        // Flag'i set et ki updatePriceRangeWithFacets çalışmasın
        this.priceSliderUpdating = true;

        this.options.priceRange.min = event.detail.values[0];
        this.options.priceRange.max = event.detail.values[1];

        // Önce input'ları güncelle
        if (this.priceRangeMin) {
          this.priceRangeMin.value = this.options.priceRange.min;
        }
        if (this.priceRangeMax) {
          this.priceRangeMax.value = this.options.priceRange.max;
        }

        // Histogram seçimini güncelle
        // Önce histogram'ın var olduğundan emin ol
        const histogramContainer = document.getElementById("price-histogram");
        if (!histogramContainer || histogramContainer.children.length === 0) {
          // Histogram yok, yeniden çiz
          if (this.histogramInitialData) {
            this.drawHistogram(
              this.histogramInitialData.histogramData,
              this.histogramInitialData.minValue,
              this.histogramInitialData.maxValue,
              this.histogramInitialData.binSize
            );
          }
        }

        // Şimdi seçimi güncelle
        this.updateHistogramSelection(
          this.options.priceRange.min,
          this.options.priceRange.max,
          this.currentPriceMinLimit ?? minValue,
          this.binSize ?? binSize
        );

        // Diğer filtreleri güncelle (ama price range'i tekrar set etme)
        this.updateAllQuickFilterOptions();
        this.pendingFilterChanges = true;

        // Update available filter state immediately
        this.updateAvailableFilterState();

        // Flag'i kaldır
        setTimeout(() => {
          this.priceSliderUpdating = false;
        }, 100);
      });

      // Add event listeners to input fields for manual changes
      this.priceRangeMin.addEventListener("change", (event) => {
        let value = parseInt(event.target.value, 10);
        const minLim = this.currentPriceMinLimit ?? minValue;
        const maxLim = this.currentPriceMaxLimit ?? maxValue;
        if (isNaN(value)) return;
        value = Math.max(
          minLim,
          Math.min(value, this.options.priceRange.max ?? maxLim)
        );
        this.options.priceRange.min = value;
        this.priceSlider.$set({
          values: [value, this.options.priceRange.max ?? maxLim],
        });
        this.updateAllQuickFilterOptions();

        // Histogram'ın var olduğundan emin ol
        const histogramContainer = document.getElementById("price-histogram");
        if (!histogramContainer || histogramContainer.children.length === 0) {
          if (this.histogramInitialData) {
            this.drawHistogram(
              this.histogramInitialData.histogramData,
              this.histogramInitialData.minValue,
              this.histogramInitialData.maxValue,
              this.histogramInitialData.binSize
            );
          }
        }

        this.updateHistogramSelection(
          this.options.priceRange.min,
          this.options.priceRange.max ?? maxLim,
          minLim,
          this.binSize ?? binSize
        );
        this.pendingFilterChanges = true;
        // Update available filter state immediately
        this.updateAvailableFilterState();
      });

      this.priceRangeMax.addEventListener("change", (event) => {
        let value = parseInt(event.target.value, 10);
        const minLim = this.currentPriceMinLimit ?? minValue;
        const maxLim = this.currentPriceMaxLimit ?? maxValue;
        if (isNaN(value)) return;
        value = Math.min(
          maxLim,
          Math.max(value, this.options.priceRange.min ?? minLim)
        );
        this.options.priceRange.max = value;
        this.priceSlider.$set({
          values: [this.options.priceRange.min ?? minLim, value],
        });
        this.updateAllQuickFilterOptions();

        // Histogram'ın var olduğundan emin ol
        const histogramContainer = document.getElementById("price-histogram");
        if (!histogramContainer || histogramContainer.children.length === 0) {
          if (this.histogramInitialData) {
            this.drawHistogram(
              this.histogramInitialData.histogramData,
              this.histogramInitialData.minValue,
              this.histogramInitialData.maxValue,
              this.histogramInitialData.binSize
            );
          }
        }

        this.updateHistogramSelection(
          this.options.priceRange.min ?? minLim,
          this.options.priceRange.max,
          minLim,
          this.binSize ?? binSize
        );
        this.pendingFilterChanges = true;
        // Update available filter state immediately
        this.updateAvailableFilterState();
      });
    }

    drawHistogram(histogramData, minValue, maxValue, binSize) {
      const histogramContainer = document.getElementById("price-histogram");
      if (!histogramContainer) {
        console.warn("Histogram container not found");
        return;
      }

      histogramContainer.innerHTML = "";

      // Convert histogram data to array - SADECE VERİ OLAN BİNLERİ AL
      const VISUAL_GROUP_SIZE = this.VISUAL_GROUP_SIZE || binSize * 10;

      const bins = [];
      for (let i = minValue; i <= maxValue; i += VISUAL_GROUP_SIZE) {
        let sum = 0;
        for (let j = i; j < i + VISUAL_GROUP_SIZE; j += binSize) {
          sum += histogramData[j] || 0;
        }
        bins.push({ value: i, count: sum });
      }

      const maxCount = Math.max(...bins.map((b) => b.count), 1);

      console.log(
        "Drawing histogram with",
        bins.length,
        "non-empty bins, maxCount:",
        maxCount
      );

      // If Chart.js is available, render a bar chart; otherwise fallback to SVG
      if (typeof window.Chart !== "undefined") {
        try {
          const canvas = document.createElement("canvas");
          canvas.id = "priceHistogramCanvas";
          histogramContainer.appendChild(canvas);

          // Destroy previous instance if exists
          if (this.priceChart) {
            try {
              this.priceChart.destroy();
            } catch (e) {
              console.warn("Error destroying chart:", e);
            }
            this.priceChart = null;
          }

          const labels = bins.map((b) => String(b.value));
          const data = bins.map((b) => b.count);

          // Logaritmik normalizasyon (görsel olarak daha dengeli)
          const EPS = maxCount * 0.04; // görünür ama silik taban

          const normalizedData = data.map((count) => {
            if (count === 0) return EPS;

            return (
              (Math.log(count + 1) / Math.log(maxCount + 1)) * maxCount * 0.8
            );
          });

          const ctx = canvas.getContext("2d");
          this.priceChartBins = bins;
          this.priceChart = new Chart(ctx, {
            type: "bar",
            data: {
              labels,
              datasets: [
                {
                  data: normalizedData,
                  backgroundColor: data.map(() => "rgba(30, 58, 95, 1)"),
                  borderWidth: 0,
                  borderRadius: 2,
                  barPercentage: 1.0,
                  categoryPercentage: 0.98,
                  minBarLength: 3, // 🔥 BOŞLAR İÇİN MİNİMUM BAR YÜKSEKLİĞİ
                },
              ],
            },
            options: {
              responsive: true,
              maintainAspectRatio: false,
              animation: true,
              plugins: {
                legend: { display: false },
                tooltip: { enabled: false },
              },
              scales: {
                x: {
                  offset: false,
                  ticks: { display: false },
                  grid: { display: false, drawBorder: false, offset: false },
                },
                y: {
                  beginAtZero: true,
                  ticks: { display: false },
                  grid: { display: false },
                  min: 0,
                },
              },
            },
          });

          console.log("Chart.js histogram created successfully");

          // Apply selection coloring if range exists
          if (
            this.options.priceRange.min !== null &&
            this.options.priceRange.max !== null
          ) {
            this.updateHistogramSelection(
              this.options.priceRange.min,
              this.options.priceRange.max,
              minValue,
              binSize
            );
          }
          return;
        } catch (error) {
          console.error("Error creating Chart.js histogram:", error);
          // Continue to SVG fallback
        }
      } else {
        console.warn("Chart.js not available, using SVG fallback");
      }

      // Fallback: simple SVG bars
      const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
      const totalBins = bins.length;
      const viewBoxWidth = 1000;
      const viewBoxHeight = 100;
      svg.setAttribute("viewBox", `0 0 ${viewBoxWidth} ${viewBoxHeight}`);
      svg.setAttribute("preserveAspectRatio", "none");
      svg.style.width = "100%";
      svg.style.height = "100%";
      svg.style.display = "block";
      const barWidth = viewBoxWidth / totalBins;
      const barGap = Math.max(1, barWidth * 0.1);
      const actualBarWidth = barWidth - barGap;

      bins.forEach((bin, index) => {
        // Logaritmik scale for SVG too
        const minBarHeight = 2;
        const normalizedHeight =
          bin.count > 0 ? Math.log(bin.count + 1) / Math.log(maxCount + 1) : 0;
        const barHeight =
          bin.count > 0 ? normalizedHeight * (viewBoxHeight - 5) : minBarHeight;
        const x = index * barWidth + barGap / 2;
        const y = viewBoxHeight - barHeight;
        const rect = document.createElementNS(
          "http://www.w3.org/2000/svg",
          "rect"
        );
        rect.setAttribute("class", "price-bar");
        rect.setAttribute("data-bin", bin.value);
        rect.setAttribute("x", x);
        rect.setAttribute("y", y);
        rect.setAttribute("width", actualBarWidth);
        rect.setAttribute("height", barHeight);
        rect.setAttribute("rx", "2");
        if (bin.count === 0) {
          rect.setAttribute("fill", "#E5E7EB"); // Açık gri
        } else {
          rect.setAttribute("fill", "#1E3A5F"); // Koyu renk
        }
        svg.appendChild(rect);
      });

      histogramContainer.appendChild(svg);

      if (
        this.options.priceRange.min !== null &&
        this.options.priceRange.max !== null
      ) {
        this.updateHistogramSelection(
          this.options.priceRange.min,
          this.options.priceRange.max,
          minValue,
          binSize
        );
      }
    }

    updateHistogramSelection(selectedMin, selectedMax, minValue, binSize) {
      // If Chart.js is used, recolor dataset bars based on selection
      if (this.priceChart && this.priceChartBins) {
        const colors = this.priceChartBins.map((b) => {
          return b.value >= selectedMin && b.value <= selectedMax
            ? "rgba(30, 58, 95, 1)"
            : "rgba(203, 213, 224, 0.6)";
        });
        this.priceChart.data.datasets[0].backgroundColor = colors;
        try {
          this.priceChart.update("none");
        } catch (e) {}
        return;
      }

      // Fallback for SVG
      const bars = document.querySelectorAll(".price-bar");
      bars.forEach((bar) => {
        const binValue = parseInt(bar.getAttribute("data-bin"));
        if (binValue >= selectedMin && binValue <= selectedMax) {
          bar.classList.remove("unselected");
        } else {
          bar.classList.add("unselected");
        }
      });
    }

    initMobileSearch() {
      // Get elements - modal might be outside the custom element
      const mobileSearchTrigger = this.querySelector("#mobile-search-trigger");
      const mobileSearchModal = document.getElementById("mobileSearchModal");

      if (!mobileSearchModal || !mobileSearchTrigger) {
        console.warn("Mobile search modal or trigger not found");
        return;
      }

      // Store references
      this.mobileSearchTrigger = mobileSearchTrigger;
      this.mobileSearchModal = mobileSearchModal;

      // Open modal when mobile search trigger is clicked
      mobileSearchTrigger.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();

        if (mobileSearchModal) {
          const BootstrapModal =
            (window.bootstrap && window.bootstrap.Modal) ||
            (typeof bootstrap !== "undefined" && bootstrap.Modal);
          if (BootstrapModal) {
            const modal = new BootstrapModal(mobileSearchModal);

            // Lock body scroll before showing modal
            this.lockBodyScroll();

            modal.show();

            // Initialize modal content when opened
            this.initMobileSearchContent();

            // Update displays
            this.updateMobileSearchDisplays();

            // Determine which section to open based on selections
            // Close all sections first
            const allSections = mobileSearchModal.querySelectorAll(
              ".flats__mobile-search-section"
            );
            allSections.forEach((sec) => {
              sec.classList.remove("active");
            });

            // Open the appropriate section based on what's already selected
            const hasLocation =
              this.options.location && this.options.location.length > 0;
            const hasDates =
              this.options.priceRange &&
              this.options.priceRange.min &&
              this.options.priceRange.max;
            const hasResidence =
              this.options.residenceType &&
              this.options.residenceType.length > 0;

            let sectionToOpen = null;

            if (!hasLocation) {
              // No location selected -> open location
              sectionToOpen = "location";
            } else if (!hasDates) {
              // Location selected but no dates -> open dates
              sectionToOpen = "dates";
            } else if (!hasResidence) {
              // Location and dates selected but no residence type -> open residence
              sectionToOpen = "residence";
            }
            // If all are selected, don't open any section (leave all closed)

            if (sectionToOpen) {
              const sectionHeader = mobileSearchModal.querySelector(
                `.flats__mobile-search-section-header[data-section="${sectionToOpen}"]`
              );
              if (sectionHeader) {
                const section = sectionHeader.closest(
                  ".flats__mobile-search-section"
                );
                if (section) {
                  section.classList.add("active");

                  // Initialize content for the opened section
                  if (sectionToOpen === "location") {
                    this.initMobileLocationDropdown();
                  } else if (sectionToOpen === "residence") {
                    this.initMobileResidenceDropdown();
                  } else if (sectionToOpen === "dates") {
                    this.initMobileDatePicker();
                  }
                }
              }
            }
          } else {
            console.error("Bootstrap Modal not available");
          }
        }
      });

      // Setup accordion functionality - use event delegation
      if (!mobileSearchModal.dataset.accordionSetup) {
        mobileSearchModal.dataset.accordionSetup = "true";

        // Add hide event listener to restore body scroll
        mobileSearchModal.addEventListener("hide.bs.modal", () => {
          this.unlockBodyScroll();
        });

        mobileSearchModal.addEventListener("click", (e) => {
          // Check if click is on a section header or its children
          const header = e.target.closest(
            ".flats__mobile-search-section-header"
          );
          if (!header) return;

          e.preventDefault();
          e.stopPropagation();

          const section = header.closest(".flats__mobile-search-section");
          if (!section) return;

          const sectionType = header.dataset.section;
          const isCurrentlyActive = section.classList.contains("active");

          // Always close all sections first
          const allSections = mobileSearchModal.querySelectorAll(
            ".flats__mobile-search-section"
          );
          allSections.forEach((sec) => {
            sec.classList.remove("active");
          });

          // If the clicked section was not active, open it
          // If it was active, it will remain closed (all sections are now closed)
          if (!isCurrentlyActive) {
            section.classList.add("active");

            // Initialize content when opening
            if (sectionType === "location") {
              this.initMobileLocationDropdown();
            } else if (sectionType === "residence") {
              this.initMobileResidenceDropdown();
            } else if (sectionType === "dates") {
              this.initMobileDatePicker();
            }
          }
        });
      }

      // Setup clear button
      const clearBtn = mobileSearchModal.querySelector(
        ".flats__mobile-search-clear"
      );
      if (clearBtn) {
        clearBtn.addEventListener("click", () => {
          this.clearMobileSearch();
        });
      }

      // Setup submit button
      const submitBtn = mobileSearchModal.querySelector(
        ".flats__mobile-search-submit"
      );
      if (submitBtn) {
        submitBtn.addEventListener("click", () => {
          // Apply filters when user clicks "ARA" button
          this.applyFilters();

          // Sync quick filter displays with selected values
          this.updateLocationQuickFilter();
          this.updateResidenceTypeQuickFilter();
          this.updateDatesQuickFilter();

          // Close modal
          const BootstrapModal =
            (window.bootstrap && window.bootstrap.Modal) ||
            (typeof bootstrap !== "undefined" && bootstrap.Modal);
          if (BootstrapModal) {
            const modal = BootstrapModal.getInstance(mobileSearchModal);
            if (modal) {
              modal.hide();
            }
          }

          // Update mobile search bar displays
          this.updateMobileSearchBarDisplays();
        });
      }

      // Update submit button text based on selections
      this.updateMobileSearchSubmitButton();
    }

    initMobileSearchContent() {
      // All sections start closed - content will be initialized when sections are opened
      // Populate location and residence dropdowns when their sections are opened
      // They will be populated when user clicks on them
    }

    initMobileLocationDropdown() {
      const dropdownContent = this.mobileSearchModal.querySelector(
        "#mobile-location-dropdown-content"
      );
      if (!dropdownContent || dropdownContent.dataset.initialized === "true")
        return;

      // Mark as initialized
      dropdownContent.dataset.initialized = "true";

      // Clear previous content
      dropdownContent.innerHTML = "";

      // Get location data from quick filter dropdown
      const quickLocationDropdown = this.quickLocationDropdown;
      if (!quickLocationDropdown) return;

      const quickDropdownContent = quickLocationDropdown.querySelector(
        ".flats__quick-filter-dropdown-content"
      );
      if (!quickDropdownContent) return;

      // Clone options from quick filter dropdown
      const quickOptions = quickDropdownContent.querySelectorAll(
        ".flats__quick-filter-option"
      );
      quickOptions.forEach((quickOption) => {
        const clonedOption = quickOption.cloneNode(true);

        // Update event listeners
        clonedOption.addEventListener("click", (e) => {
          e.stopPropagation();

          // Toggle selection
          const isSelected = clonedOption.classList.contains("selected");
          const locationValue = clonedOption.dataset.value;

          if (isSelected) {
            clonedOption.classList.remove("selected");
            this.options.location = this.options.location.filter(
              (loc) => loc !== locationValue
            );
          } else {
            clonedOption.classList.add("selected");
            if (!this.options.location.includes(locationValue)) {
              this.options.location.push(locationValue);
            }
          }

          // Update "All" option
          const allOpt = dropdownContent.querySelector(
            '.flats__quick-filter-option[data-value=""]'
          );
          if (allOpt && locationValue !== "") {
            allOpt.classList.remove("selected");
          } else if (allOpt && locationValue === "") {
            dropdownContent
              .querySelectorAll(".flats__quick-filter-option")
              .forEach((opt) => opt.classList.remove("selected"));
            allOpt.classList.add("selected");
            this.options.location = [];
          }

          // Update displays
          this.updateMobileSearchDisplays();
          this.updateMobileSearchSubmitButton();

          // Sync with quick filter (but don't apply filters - wait for user to click "ARA")
          this.updateLocationQuickFilter();
          this.updateResidenceTypeFilterOptions();
          // Don't apply filters - wait for user to click "ARA" button
        });

        dropdownContent.appendChild(clonedOption);
      });

      // Update selected state based on current options
      dropdownContent
        .querySelectorAll(".flats__quick-filter-option")
        .forEach((option) => {
          const value = option.dataset.value;
          if (
            value === "" &&
            (!this.options.location || this.options.location.length === 0)
          ) {
            option.classList.add("selected");
          } else if (
            value !== "" &&
            this.options.location &&
            this.options.location.includes(value)
          ) {
            option.classList.add("selected");
          } else {
            option.classList.remove("selected");
          }
        });
    }

    initMobileResidenceDropdown() {
      const dropdownContent = this.mobileSearchModal.querySelector(
        "#mobile-residence-dropdown-content"
      );
      if (!dropdownContent || dropdownContent.dataset.initialized === "true")
        return;

      // Mark as initialized
      dropdownContent.dataset.initialized = "true";

      // Clear previous content
      dropdownContent.innerHTML = "";

      // Get residence type data from quick filter dropdown
      const quickResidenceDropdown = this.quickResidenceTypeDropdown;
      if (!quickResidenceDropdown) return;

      const quickDropdownContent = quickResidenceDropdown.querySelector(
        ".flats__quick-filter-dropdown-content"
      );
      if (!quickDropdownContent) return;

      // Clone options from quick filter dropdown
      const quickOptions = quickDropdownContent.querySelectorAll(
        ".flats__quick-filter-option"
      );
      quickOptions.forEach((quickOption) => {
        const clonedOption = quickOption.cloneNode(true);

        // Update event listeners
        clonedOption.addEventListener("click", (e) => {
          e.stopPropagation();

          // Toggle selection
          const isSelected =
            clonedOption.classList.contains("selected") ||
            clonedOption.classList.contains("active");
          const residenceValue = clonedOption.dataset.value;

          if (isSelected) {
            clonedOption.classList.remove("selected", "active");
            this.options.residenceType = this.options.residenceType.filter(
              (type) => type !== residenceValue
            );
          } else {
            clonedOption.classList.add("selected", "active");
            if (!this.options.residenceType.includes(residenceValue)) {
              this.options.residenceType.push(residenceValue);
            }
          }

          // Update "All" option
          const allOpt = dropdownContent.querySelector(
            '.flats__quick-filter-option[data-value=""]'
          );
          if (allOpt && residenceValue !== "") {
            allOpt.classList.remove("selected", "active");
          } else if (allOpt && residenceValue === "") {
            dropdownContent
              .querySelectorAll(".flats__quick-filter-option")
              .forEach((opt) => opt.classList.remove("selected", "active"));
            allOpt.classList.add("selected", "active");
            this.options.residenceType = [];
          }

          // Update displays
          this.updateMobileSearchDisplays();
          this.updateMobileSearchSubmitButton();

          // Sync with quick filter (but don't apply filters - wait for user to click "ARA")
          this.updateResidenceTypeQuickFilter();
          this.updateAllQuickFilterOptions();
          // Don't apply filters - wait for user to click "ARA" button
        });

        dropdownContent.appendChild(clonedOption);
      });

      // Update selected state based on current options
      dropdownContent
        .querySelectorAll(".flats__quick-filter-option")
        .forEach((option) => {
          const value = option.dataset.value;
          if (
            value === "" &&
            (!this.options.residenceType ||
              this.options.residenceType.length === 0)
          ) {
            option.classList.add("selected", "active");
          } else if (
            value !== "" &&
            this.options.residenceType &&
            this.options.residenceType.includes(value)
          ) {
            option.classList.add("selected", "active");
          } else {
            option.classList.remove("selected", "active");
          }
        });
    }

    initMobileDatePicker() {
      const calendarContainer = this.mobileSearchModal.querySelector(
        "#mobile-modal-calendar-container"
      );
      const datePickerInput = this.mobileSearchModal.querySelector(
        "#mobile-modal-date-picker"
      );
      const moveInDisplay = this.mobileSearchModal.querySelector(
        "#mobile-modal-move-in-display"
      );
      const moveOutDisplay = this.mobileSearchModal.querySelector(
        "#mobile-modal-move-out-display"
      );

      if (
        !calendarContainer ||
        !datePickerInput ||
        this.mobileModalCalendarInitialized
      )
        return;

      this.mobileModalCalendarInitialized = true;

      const minDays = 100;
      const maxMonths = 12;
      let selectedStart = null;
      let selectedEnd = null;

      // Render scrollable calendar
      this.renderMobileScrollableCalendar(calendarContainer);

      // Setup date selection for mobile
      this.setupMobileDateSelection(
        calendarContainer,
        moveInDisplay,
        moveOutDisplay
      );
    }

    renderMobileScrollableCalendar(calendarContainer) {
      if (!calendarContainer) return;

      const scrollContainer = this.mobileSearchModal.querySelector(
        "#mobile-calendar-scroll-container"
      );
      if (!scrollContainer) return;

      // Clear existing content
      calendarContainer.innerHTML = "";

      // Create sticky day names header
      const dayNamesHeader = document.createElement("div");
      dayNamesHeader.className = "flats__calendar-day-names-header";
      const dayNames = ["P", "P", "S", "Ç", "P", "C", "C"];
      dayNames.forEach((name) => {
        const dayName = document.createElement("div");
        dayName.className = "flats__calendar-day-name";
        dayName.textContent = name;
        dayNamesHeader.appendChild(dayName);
      });
      calendarContainer.appendChild(dayNamesHeader);

      // Render 24 months (2 years) for scrolling
      const today = moment();
      const monthsToRender = 24;

      for (let i = 0; i < monthsToRender; i++) {
        const monthDate = moment().add(i, "months");
        this.renderMobileMonth(monthDate, calendarContainer, false); // No day names in individual months
      }

      // Initialize infinite scroll
      this.setupMobileInfiniteScroll(scrollContainer, calendarContainer);
    }

    renderMobileMonth(monthDate, container, isFirstMonth = false) {
      const monthContainer = document.createElement("div");
      monthContainer.className = "flats__calendar-month";
      monthContainer.dataset.month = monthDate.format("YYYY-MM");

      // Month title - Türkçe format
      const monthTitle = document.createElement("div");
      monthTitle.className = "flats__calendar-month-title";
      monthTitle.textContent = monthDate.locale("tr").format("MMMM YYYY");
      monthContainer.appendChild(monthTitle);

      // Calendar grid
      const grid = document.createElement("div");
      grid.className = "flats__calendar-grid";

      // Day names - Türkçe kısaltmalar (sadece ilk ay için)
      if (isFirstMonth) {
        const dayNames = ["P", "P", "S", "Ç", "P", "C", "C"]; // Pazar, Pazartesi, Salı, Çarşamba, Perşembe, Cuma, Cumartesi
        dayNames.forEach((name) => {
          const dayName = document.createElement("div");
          dayName.className = "flats__calendar-day-name";
          dayName.textContent = name;
          grid.appendChild(dayName);
        });
      }

      // Days in month
      const startOfMonth = monthDate.clone().startOf("month");
      const endOfMonth = monthDate.clone().endOf("month");
      const startDay = startOfMonth.day(); // 0 = Sunday

      // Empty cells before first day
      for (let i = 0; i < startDay; i++) {
        const emptyCell = document.createElement("div");
        emptyCell.className = "flats__calendar-day disabled";
        grid.appendChild(emptyCell);
      }

      // Days
      const daysInMonth = endOfMonth.date();
      const today = moment();
      const minDate = moment().add(1, "day");
      const maxDate = moment().add(12, "months");

      for (let day = 1; day <= daysInMonth; day++) {
        const dayDate = monthDate.clone().date(day);
        const dayCell = document.createElement("div");
        dayCell.className = "flats__calendar-day";
        dayCell.textContent = day;
        dayCell.dataset.date = dayDate.format("YYYY-MM-DD");
        dayCell.dataset.container = "mobile";

        // Disable dates outside valid range
        if (
          dayDate.isBefore(minDate, "day") ||
          dayDate.isAfter(maxDate, "day")
        ) {
          dayCell.classList.add("disabled");
        }

        grid.appendChild(dayCell);
      }

      monthContainer.appendChild(grid);
      container.appendChild(monthContainer);
    }

    setupMobileInfiniteScroll(scrollContainer, calendarContainer) {
      let isLoadingMore = false;

      scrollContainer.addEventListener("scroll", () => {
        const { scrollTop, scrollHeight, clientHeight } = scrollContainer;

        // Load more when scrolled near bottom
        if (scrollHeight - scrollTop - clientHeight < 200 && !isLoadingMore) {
          isLoadingMore = true;

          // Get last month rendered
          const lastMonth = calendarContainer.querySelector(
            ".flats__calendar-month:last-child"
          );
          if (lastMonth) {
            const lastMonthDate = moment(lastMonth.dataset.month, "YYYY-MM");

            // Render next 3 months (without day names header)
            for (let i = 1; i <= 3; i++) {
              const nextMonth = lastMonthDate.clone().add(i, "months");
              this.renderMobileMonth(nextMonth, calendarContainer, false);
            }
          }

          setTimeout(() => {
            isLoadingMore = false;
          }, 100);
        }
      });
    }

    setupMobileDateSelection(calendarContainer, moveInDisplay, moveOutDisplay) {
      if (!calendarContainer) return;

      const minDays = 100;
      const maxMonths = 12;
      let selectedStart = null;
      let selectedEnd = null;

      // Create tooltip element
      let tooltip = document.getElementById("mobile-calendar-tooltip");
      if (!tooltip) {
        tooltip = document.createElement("div");
        tooltip.id = "mobile-calendar-tooltip";
        tooltip.className = "flats__mobile-calendar-tooltip";
        document.body.appendChild(tooltip);
      }

      // Function to update and show tooltip
      const showTooltip = (dayCell, days) => {
        if (!dayCell || days === null) {
          tooltip.classList.remove("show");
          return;
        }

        const rect = dayCell.getBoundingClientRect();
        tooltip.textContent = `${days} gün`;
        // Konumu viewport'a göre ayarla ve üstte minimum boşluk bırak
        const left = rect.left + rect.width / 2;
        const top = Math.max(16, rect.top - 40);
        tooltip.style.left = `${left}px`;
        tooltip.style.top = `${top}px`;
        tooltip.classList.add("show");
      };

      // Hover effect for valid dates when start is selected
      calendarContainer.addEventListener("mouseover", (e) => {
        const dayCell = e.target.closest(".flats__calendar-day");
        if (!dayCell || dayCell.classList.contains("disabled")) {
          tooltip.classList.remove("show");
          return;
        }
        if (dayCell.dataset.container !== "mobile") return;

        // Only show tooltip when hovering over potential end dates
        if (selectedStart && !selectedEnd) {
          const hoverDate = moment(dayCell.dataset.date);
          const minEndDate = selectedStart.clone().add(minDays, "days");
          const maxEndDate = selectedStart.clone().add(maxMonths, "months");

          if (
            hoverDate.isSameOrAfter(minEndDate) &&
            hoverDate.isSameOrBefore(maxEndDate)
          ) {
            const days = hoverDate.diff(selectedStart, "days");
            showTooltip(dayCell, days);
          } else {
            tooltip.classList.remove("show");
          }
        } else {
          tooltip.classList.remove("show");
        }
      });

      // Hide tooltip when mouse leaves calendar
      calendarContainer.addEventListener("mouseleave", () => {
        tooltip.classList.remove("show");
      });

      calendarContainer.addEventListener("click", (e) => {
        const dayCell = e.target.closest(".flats__calendar-day");
        if (!dayCell || dayCell.classList.contains("disabled")) return;
        if (dayCell.dataset.container !== "mobile") return; // Only handle mobile calendar clicks

        const clickedDate = moment(dayCell.dataset.date);

        // If no dates selected or both dates selected, start new selection
        if (!selectedStart || (selectedStart && selectedEnd)) {
          // If both dates were selected, fully reset before starting new selection
          if (selectedStart && selectedEnd) {
            selectedStart = null;
            selectedEnd = null;
            this.selectedStart = null;
            this.selectedEnd = null;
          }

          selectedStart = clickedDate;
          selectedEnd = null;
          this.selectedStart = clickedDate.toDate();
          this.selectedEnd = null;

          // Update UI
          this.clearMobileDateSelections(calendarContainer);
          dayCell.classList.add("selected", "range-start");

          // Update displays
          if (moveInDisplay) {
            moveInDisplay.textContent = clickedDate
              .locale("tr")
              .format("D MMM YYYY");
          }
          if (moveOutDisplay) {
            moveOutDisplay.textContent = "Takvim seçin";
          }

          // Update disabled dates
          this.updateMobileDateDisabledStates(
            calendarContainer,
            selectedStart,
            null
          );

          // Show notification
          this.showNotification("Minimum 100 gün seçebilirsiniz");

          // Scroll to +100 days after start date (exact day)
          const scrollContainer = this.mobileSearchModal.querySelector(
            "#mobile-calendar-scroll-container"
          );
          if (scrollContainer) {
            setTimeout(() => {
              // Calculate the exact target date (+100 days from selected start)
              const targetDate = selectedStart.clone().add(minDays, "days");
              const targetDateKey = targetDate.format("YYYY-MM-DD");

              // Find the exact day element
              const targetDayElement = calendarContainer.querySelector(
                `[data-date="${targetDateKey}"]`
              );

              if (targetDayElement) {
                // Get the month container of the target day
                const monthContainer = targetDayElement.closest(
                  ".flats__calendar-month"
                );
                if (monthContainer) {
                  // Calculate scroll position to show the target day at top of visible area
                  const scrollPosition =
                    monthContainer.offsetTop - scrollContainer.offsetTop - 20; // 20px padding
                  scrollContainer.scrollTo({
                    top: scrollPosition,
                    behavior: "smooth",
                  });
                }
              }
            }, 100);
          }
        } else {
          // Selecting end date
          const minEndDate = selectedStart.clone().add(minDays, "days");
          const maxEndDate = selectedStart.clone().add(maxMonths, "months");

          if (
            clickedDate.isBefore(minEndDate) ||
            clickedDate.isAfter(maxEndDate)
          ) {
            return; // Invalid end date - do nothing
          }

          selectedEnd = clickedDate;
          this.selectedEnd = clickedDate.toDate();

          // Update UI
          this.clearMobileDateSelections(calendarContainer);
          this.highlightMobileDateRange(
            calendarContainer,
            selectedStart,
            selectedEnd
          );

          // Update displays
          if (moveOutDisplay) {
            moveOutDisplay.textContent = clickedDate
              .locale("tr")
              .format("D MMM YYYY");
          }

          // Show final day count
          const totalDays = selectedEnd.diff(selectedStart, "days");
          showTooltip(dayCell, totalDays);
          setTimeout(() => {
            tooltip.classList.remove("show");
          }, 2000);

          // Notify user of the total selected days
          this.showNotification(`Toplam ${totalDays} gün seçtiniz`);

          // Reset disabled dates (all dates available again except past/future limits)
          this.updateMobileDateDisabledStates(calendarContainer, null, null);

          // Update mobile search displays
          this.updateMobileSearchDisplays();
          this.updateMobileSearchSubmitButton();
        }
      });
    }

    clearMobileDateSelections(calendarContainer) {
      const allDays = calendarContainer.querySelectorAll(
        '.flats__calendar-day[data-container="mobile"]'
      );
      allDays.forEach((day) => {
        day.classList.remove(
          "selected",
          "in-range",
          "range-start",
          "range-end"
        );
      });
    }

    highlightMobileDateRange(calendarContainer, start, end) {
      const allDays = calendarContainer.querySelectorAll(
        '.flats__calendar-day[data-container="mobile"]'
      );

      // Format start and end as date strings to avoid timezone issues
      const startStr = start.format("YYYY-MM-DD");
      const endStr = end.format("YYYY-MM-DD");

      let startFound = false,
        endFound = false,
        inRangeCount = 0;

      allDays.forEach((day) => {
        const dayDateStr = day.dataset.date;

        // Compare as strings to avoid timezone issues
        if (dayDateStr === startStr) {
          // Ensure selected days are not disabled
          day.classList.remove("disabled");
          day.classList.add("selected", "range-start");
          startFound = true;
        } else if (dayDateStr === endStr) {
          day.classList.remove("disabled");
          day.classList.add("selected", "range-end");
          endFound = true;
        } else if (dayDateStr > startStr && dayDateStr < endStr) {
          // Mark in-range regardless of disabled state
          day.classList.remove("disabled");
          day.classList.add("in-range");
          inRangeCount++;
        }
      });

      console.log(
        "Start found:",
        startFound,
        "End found:",
        endFound,
        "In-range count:",
        inRangeCount
      );
    }

    updateMobileDateDisabledStates(
      calendarContainer,
      selectedStart,
      selectedEnd
    ) {
      const minDays = 100;
      const maxMonths = 12;
      const today = moment();
      const minDate = moment().add(1, "day");
      const maxDate = moment().add(12, "months");

      const allDays = calendarContainer.querySelectorAll(
        '.flats__calendar-day[data-container="mobile"]'
      );

      allDays.forEach((day) => {
        if (!day.dataset.date) return;

        const dayDate = moment(day.dataset.date);
        let shouldDisable = false;

        // Always disable dates outside allowed range
        if (
          dayDate.isBefore(minDate, "day") ||
          dayDate.isAfter(maxDate, "day")
        ) {
          shouldDisable = true;
        } else if (selectedStart && !selectedEnd) {
          // If start selected but not end, disable invalid end dates
          const minEndDate = selectedStart.clone().add(minDays, "days");
          const maxEndDate = selectedStart.clone().add(maxMonths, "months");

          if (
            dayDate.isBefore(minEndDate, "day") ||
            dayDate.isAfter(maxEndDate, "day")
          ) {
            shouldDisable = true;
          }
        }

        if (shouldDisable) {
          day.classList.add("disabled");
        } else {
          day.classList.remove("disabled");
        }
      });
    }

    updateMobileSearchDisplays() {
      // Update location display
      const locationDisplay = this.mobileSearchModal.querySelector(
        "#mobile-modal-location-display"
      );
      if (locationDisplay) {
        if (this.options.location && this.options.location.length > 0) {
          const locationText =
            this.options.location.length === 1
              ? this.options.location[0]
              : `${this.options.location.length} Konum`;
          locationDisplay.textContent = locationText;
          locationDisplay.classList.add("has-selection");
        } else {
          locationDisplay.textContent = "Lokasyon Seçin";
          locationDisplay.classList.remove("has-selection");
        }
      }

      // Update dates display
      const datesDisplay = this.mobileSearchModal.querySelector(
        "#mobile-modal-dates-display"
      );
      if (datesDisplay) {
        if (this.selectedStart && this.selectedEnd) {
          const startStr = moment(this.selectedStart).format("D MMM");
          const endStr = moment(this.selectedEnd).format("D MMM");
          datesDisplay.textContent = `${startStr} - ${endStr}`;
          datesDisplay.classList.add("has-selection");
        } else if (this.selectedStart) {
          datesDisplay.textContent = moment(this.selectedStart).format(
            "D MMM YYYY"
          );
          datesDisplay.classList.add("has-selection");
        } else {
          datesDisplay.textContent = "Tarih Seçin";
          datesDisplay.classList.remove("has-selection");
        }
      }

      // Update residence display
      const residenceDisplay = this.mobileSearchModal.querySelector(
        "#mobile-modal-residence-display"
      );
      if (residenceDisplay) {
        if (
          this.options.residenceType &&
          this.options.residenceType.length > 0
        ) {
          const residenceText =
            this.options.residenceType.length === 1
              ? this.options.residenceType[0]
              : `${this.options.residenceType.length} Tip`;
          residenceDisplay.textContent = residenceText;
          residenceDisplay.classList.add("has-selection");
        } else {
          residenceDisplay.textContent = "Daire Tipi Seçin";
          residenceDisplay.classList.remove("has-selection");
        }
      }
    }

    updateMobileSearchBarDisplays() {
      // Update mobile search bar location display
      if (this.mobileLocationDisplay) {
        if (this.options.location && this.options.location.length > 0) {
          const locationText =
            this.options.location.length === 1
              ? this.options.location[0]
              : `${this.options.location.length} Konum`;
          this.mobileLocationDisplay.textContent = locationText;
        } else {
          this.mobileLocationDisplay.textContent = "Konum Seç";
        }
      }

      // Update mobile search bar dates display
      if (this.mobileDatesDisplay) {
        if (this.selectedStart && this.selectedEnd) {
          const startStr = moment(this.selectedStart).format("D MMM");
          const endStr = moment(this.selectedEnd).format("D MMM");
          this.mobileDatesDisplay.textContent = `${startStr} - ${endStr}`;
        } else if (this.selectedStart) {
          this.mobileDatesDisplay.textContent = moment(
            this.selectedStart
          ).format("D MMM YYYY");
        } else {
          this.mobileDatesDisplay.textContent = "Tarih Seç";
        }
      }
    }

    updateMobileSearchSubmitButton() {
      const submitBtn = this.mobileSearchModal.querySelector(
        ".flats__mobile-search-submit"
      );
      if (!submitBtn) return;

      const hasSelection =
        (this.options.location && this.options.location.length > 0) ||
        (this.selectedStart && this.selectedEnd) ||
        (this.options.residenceType && this.options.residenceType.length > 0);

      if (hasSelection) {
        submitBtn.textContent = "ARA";
      } else {
        submitBtn.textContent = "KAPAT";
      }
    }

    clearMobileSearch() {
      // Clear location
      this.options.location = [];
      const locationDropdown = this.mobileSearchModal.querySelector(
        "#mobile-location-dropdown-content"
      );
      if (locationDropdown) {
        locationDropdown
          .querySelectorAll(".flats__quick-filter-option")
          .forEach((opt) => {
            opt.classList.remove("selected");
            if (opt.dataset.value === "") {
              opt.classList.add("selected");
            }
          });
      }

      // Clear dates
      this.selectedStart = null;
      this.selectedEnd = null;
      this.options.startDate = null;
      this.options.endDate = null;
      if (this.mobileModalDatePickerObj) {
        this.mobileModalDatePickerObj.setStartDate(null, true);
        this.mobileModalDatePickerObj.setEndDate(null, true);
      }
      const moveInDisplay = this.mobileSearchModal.querySelector(
        "#mobile-modal-move-in-display"
      );
      const moveOutDisplay = this.mobileSearchModal.querySelector(
        "#mobile-modal-move-out-display"
      );
      if (moveInDisplay) moveInDisplay.textContent = "Takvim seçin";
      if (moveOutDisplay) moveOutDisplay.textContent = "Takvim seçin";

      // Clear residence type
      this.options.residenceType = [];
      const residenceDropdown = this.mobileSearchModal.querySelector(
        "#mobile-residence-dropdown-content"
      );
      if (residenceDropdown) {
        residenceDropdown
          .querySelectorAll(".flats__quick-filter-option")
          .forEach((opt) => {
            opt.classList.remove("selected", "active");
            if (opt.dataset.value === "") {
              opt.classList.add("selected", "active");
            }
          });
      }

      // Update displays
      this.updateMobileSearchDisplays();
      this.updateMobileSearchSubmitButton();

      // Don't apply filters - wait for user to click "ARA" button
    }

    updateFilterButtonState() {
      // Update the mobile filter button to show "Ara" or "KAPAT"
      const applyBtn = this.applyFiltersButton;
      const closeBtn = this.filtersCloseButton;

      if (!applyBtn || !closeBtn) return;

      if (this.pendingFilterChanges) {
        // Show "Ara" button
        applyBtn.classList.remove("d-none");
        closeBtn.classList.add("d-none");
      } else {
        // Show "KAPAT" button
        applyBtn.classList.add("d-none");
        closeBtn.classList.remove("d-none");
      }
    }

    initDatePicker() {
      const minDays = 100;
      this.datePickerObj = new Lightpick({
        field: this.datePicker,
        singleDate: false,
        numberOfMonths: 1,
        minDate: moment().add(1, "day").toDate(),
        inline: true,
        lang: "tr",
        minDays: minDays,
        onSelect: (start, end) => {
          if (end < start) {
            this.datePickerObj.gotoDate(moment().add(minDays, "day").toDate());
          }
          // Update quick filter display
          this.updateDatesQuickFilter();
          // Also update quick date picker if it exists
          if (this.quickDatePickerObj && start && end) {
            this.quickDatePickerObj.setDateRange(start, end);
            if (this.moveInDisplay) {
              this.moveInDisplay.textContent =
                moment(start).format("D MMM YYYY");
            }
            if (this.moveOutDisplay) {
              this.moveOutDisplay.textContent =
                moment(end).format("D MMM YYYY");
            }
            this.updateNightsCount(start, end);
          }
        },
      });
    }
  }
  customElements.define("daireler-element", Daireler);
}

// Ensure custom element is initialized when DOM is ready
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", () => {
    // Custom element will auto-initialize when defined
  });
} else {
  // DOM already loaded, custom element will auto-initialize
}

window.initMap = function () {
  window.isGoogleLibraryLoaded = true;
  window.dispatchEvent(new Event("google-maps-loaded"));
};

// Mobile Map Button functionality
document.addEventListener("DOMContentLoaded", () => {
  const mobileMapButton = document.getElementById("mobile-map-button");
  const mobileMapModal = document.getElementById("mobile-map-modal");
  const mobileMapModalClose = document.getElementById("mobile-map-modal-close");
  const mobileMapModalContent = document.getElementById("mobile-map-modal-content");
  const mapContainer = document.getElementById("map-container");

  if (mobileMapButton && mobileMapModal && mobileMapModalClose && mobileMapModalContent && mapContainer) {
    // Store original map display state
    let originalMapDisplay = null;
    let modalMap = null;
    let modalMarkerClusterer = null;
    let currentOpenInfoWindow = null; // Track currently open info window in modal
    
    // Open map modal
    mobileMapButton.addEventListener("click", () => {
      // Show modal first
      mobileMapModal.classList.add("active");
      document.body.style.overflow = "hidden";
      
      // Store original display state and hide original map
      originalMapDisplay = mapContainer.style.display;
      mapContainer.style.display = "none";
      
      // Clone the map container to modal
      const mapClone = mapContainer.cloneNode(true);
      mapClone.style.display = "block";
      mapClone.style.width = "100%";
      mapClone.style.height = "100%";
      mapClone.style.minHeight = "100%";
      mobileMapModalContent.appendChild(mapClone);
      
      // Get the daireler element and recreate map in modal with same logic
      const daireElement = document.querySelector("daireler-element");
      if (daireElement && daireElement.map && window.google) {
        setTimeout(() => {
          // Store current map state
          const currentCenter = daireElement.map.getCenter();
          const currentZoom = daireElement.map.getZoom();
          const currentMapTypeId = daireElement.map.getMapTypeId();
          
          // Create new map in cloned container with exact same settings
          modalMap = new google.maps.Map(mapClone, {
            center: currentCenter,
            zoom: currentZoom,
            mapTypeId: currentMapTypeId,
            mapId: "98d89273509c67e0",
            disableDefaultUI: false,
            zoomControl: true,
            mapTypeControl: false,
            scaleControl: true,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
          });
          
          // Track locked marker for mobile map
          let currentLockedMarker = null;
          
          // Add click listener to map to close info window when clicking on empty space
          modalMap.addListener("click", () => {
            if (currentOpenInfoWindow) {
              currentOpenInfoWindow.close();
              currentOpenInfoWindow = null;
            }
            if (currentLockedMarker) {
              currentLockedMarker.isLocked = false;
              currentLockedMarker = null;
            }
          });
          
          // Ensure currencySelector is initialized
          if (!window.currencySelector) {
            window.currencySelector = {
              name: "TRY",
              rate: 1,
              symbol: "TL",
            };
          }
          
          // Get filtered data with same logic as main map
          const data = daireElement.filteredData || daireElement.data;
          const bounds = new google.maps.LatLngBounds();
          
          // Group properties by location (same building) - EXACT SAME LOGIC
          const locationGroups = new Map();
          // Filter out properties with status 0 before processing - SAME AS MAIN MAP
          const activeProperties =
            daireElement.getVisibleProperties?.(data) || data.properties || [];
          activeProperties.forEach((property) => {
            if (property.buildingLatitude === 0 || property.buildingLongitude === 0)
              return;
            if (!property.buildingLatitude || !property.buildingLongitude) return;
            const locationKey = `${property.buildingLatitude.toFixed(6)},${property.buildingLongitude.toFixed(6)}`;
            if (!locationGroups.has(locationKey)) {
              locationGroups.set(locationKey, []);
            }
            locationGroups.get(locationKey).push(property);
          });
          
          // Create markers with exact same logic as main map
          const newMarkers = [];
          
          locationGroups.forEach((properties, locationKey) => {
            if (properties.length === 0) return;
            const property = properties[0];
            
            // Ensure property has required data
            if (!property.priceRange?.MonthlyPrices?.["12_12"]?.["cash"]) {
              return;
            }
            
            // Create marker content with navigation arrows if multiple properties at same location
            const hasMultiple = properties.length > 1;
            const divString = `
              <div class="flats__map-marker flats__map-marker--single ${hasMultiple ? "flats__map-marker--multiple" : ""}">
                ${hasMultiple ? `
                <div class="flats__map-marker--nav">
                  <button class="flats__map-marker--arrow flats__map-marker--prev" data-action="prev">◀</button>
                  <span class="flats__map-marker--count">1/${properties.length}</span>
                  <button class="flats__map-marker--arrow flats__map-marker--next" data-action="next">▶</button>
                </div>
                ` : ""}
                <span class="flats__map-marker--info-price" data-price="${property.priceRange?.MonthlyPrices?.["12_12"]?.["cash"] || ""}">${window.formatPrice(property.priceRange?.MonthlyPrices?.["12_12"]?.["cash"], 0)}</span>
                <div class="flats__map-marker--triangle"></div>
              </div>
            `;
            const parser = new DOMParser();
            const doc = parser.parseFromString(divString, "text/html");
            const divElement = doc.body.firstChild;
            
            if (!divElement) return;
            
            const marker = new google.maps.marker.AdvancedMarkerElement({
              map: modalMap,
              position: {
                lat: property.buildingLatitude,
                lng: property.buildingLongitude,
              },
              title: property.projectName,
              content: divElement,
            });
            
            // Store property data in marker
            marker.propertyId = property.idCode;
            marker.property = property;
            marker.properties = properties;
            marker.currentPropertyIndex = 0;
            marker.isLocked = false;
            
            // Create info window
            const infoWindow = new google.maps.InfoWindow({
              content: `<div class="flats__map-marker--info-window" data-property-id="${property.idCode}">
                <img class="flats__map-marker--info-window-image" src="${property.images[0]}" alt="${property.projectName}">
                <div class="flats__map-marker--info-window-content">
                  <span class="flats__map-marker--info-title">${property.projectName}</span>
                  <span class="flats__map-marker--info-price" data-price="${property.priceRange?.MonthlyPrices?.["12_12"]?.["cash"] || ""}">${window.formatPrice(property.priceRange?.MonthlyPrices?.["12_12"]?.["cash"], 0)}</span>
                  <span class="flats__map-marker--info-details">${property.residenceTypes[0]?.name}${property.netMetrekare ? ` | ${property.netMetrekare}` : ""}</span>
                </div>
                <button class="flats__map-marker--compare-toggle" type="button" aria-label="Karşılaştırmaya ekle" title="Karşılaştırmaya ekle">
                  <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M9 2H5C3.89543 2 3 2.89543 3 4V8M9 2V8M9 2H15M9 8H3M9 8V14M3 8V14M3 14H9M3 14V20C3 21.1046 3.89543 22 5 22H9M9 14V22M9 22H15M15 2H19C20.1046 2 21 2.89543 21 4V8M15 2V8M15 8H21M15 8V14M21 8V14M21 14H15M21 14V20C21 21.1046 20.1046 22 19 22H15M15 14V22" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
              </div>`,
              maxWidth: 300,
            });
            
            // Add click handlers to arrow buttons
            if (hasMultiple) {
              const prevButton = divElement.querySelector(".flats__map-marker--prev");
              const nextButton = divElement.querySelector(".flats__map-marker--next");
              
              const updateMarkerContent = () => {
                const newProperty = marker.properties[marker.currentPropertyIndex];
                marker.property = newProperty;
                marker.propertyId = newProperty.idCode;
                
                const countElement = divElement.querySelector(".flats__map-marker--count");
                if (countElement) {
                  countElement.textContent = `${marker.currentPropertyIndex + 1}/${marker.properties.length}`;
                }
                
                const priceElement = divElement.querySelector(".flats__map-marker--info-price");
                if (priceElement) {
                  const priceValue = newProperty.priceRange?.MonthlyPrices?.["12_12"]?.["cash"];
                  priceElement.setAttribute("data-price", priceValue || "");
                  priceElement.textContent = window.formatPrice(priceValue, 0);
                }
                
                infoWindow.setContent(`<div class="flats__map-marker--info-window">
                  <img class="flats__map-marker--info-window-image" src="${newProperty.images[0]}" alt="${newProperty.projectName}">
                  <div class="flats__map-marker--info-window-content">
                    <span class="flats__map-marker--info-title">${newProperty.projectName}</span>
                    <span class="flats__map-marker--info-price" data-price="${newProperty.priceRange?.MonthlyPrices?.["12_12"]?.["cash"] || ""}">${window.formatPrice(newProperty.priceRange?.MonthlyPrices?.["12_12"]?.["cash"], 0)}</span>
                    <span class="flats__map-marker--info-details">${newProperty.residenceTypes[0]?.name}${newProperty.netMetrekare ? ` | ${newProperty.netMetrekare}` : ""}</span>
                  </div>
                </div>`);
              };
              
              if (prevButton) {
                const handlePrev = (e) => {
                  // Prevent Google Maps / marker click handlers from also firing
                  // so that a single click reliably changes the property.
                  e.stopPropagation();
                  if (typeof e.stopImmediatePropagation === "function") {
                    e.stopImmediatePropagation();
                  }
                  e.preventDefault();
                  if (e.type === "click" && prevButton.__ignoreNextClick) {
                    prevButton.__ignoreNextClick = false;
                    return false;
                  }
                  marker.currentPropertyIndex =
                    (marker.currentPropertyIndex - 1 + marker.properties.length) %
                    marker.properties.length;
                  updateMarkerContent();
                  return false;
                };
                prevButton.addEventListener("click", handlePrev, { passive: false });
                prevButton.addEventListener(
                  "touchstart",
                  (e) => {
                    prevButton.__ignoreNextClick = true;
                    handlePrev(e);
                  },
                  { passive: false }
                );
              }
              
              if (nextButton) {
                const handleNext = (e) => {
                  // Prevent Google Maps / marker click handlers from also firing
                  // so that a single click reliably changes the property.
                  e.stopPropagation();
                  if (typeof e.stopImmediatePropagation === "function") {
                    e.stopImmediatePropagation();
                  }
                  e.preventDefault();
                  if (e.type === "click" && nextButton.__ignoreNextClick) {
                    nextButton.__ignoreNextClick = false;
                    return false;
                  }
                  marker.currentPropertyIndex =
                    (marker.currentPropertyIndex + 1) % marker.properties.length;
                  updateMarkerContent();
                  return false;
                };
                nextButton.addEventListener("click", handleNext, { passive: false });
                nextButton.addEventListener(
                  "touchstart",
                  (e) => {
                    nextButton.__ignoreNextClick = true;
                    handleNext(e);
                  },
                  { passive: false }
                );
              }
            }
            
            // Add click listener using Google Maps addListener
            marker.addListener("click", () => {
              // Unlock previous marker if exists
              if (currentLockedMarker) {
                currentLockedMarker.isLocked = false;
              }
              
              // Close previously open info window
              if (currentOpenInfoWindow) {
                currentOpenInfoWindow.close();
              }
              
              // Lock this marker and open info window
              marker.isLocked = true;
              infoWindow.open(modalMap, marker);
              
              // Store references
              currentOpenInfoWindow = infoWindow;
              currentLockedMarker = marker;
            });
            
              // Add info window events (link + comparison)
              google.maps.event.addListener(infoWindow, "domready", () => {
                const infoWindowElement = document.querySelector(".flats__map-marker--info-window");
                if (infoWindowElement) {
                  const titleEl = infoWindowElement.querySelector(".flats__map-marker--info-title");
                  if (titleEl) {
                    titleEl.style.cursor = "pointer";
                    titleEl.addEventListener("click", () => {
                      window.location.href = `/products/${marker.property.handle}`;
                    });
                  }

                  const compareBtn = infoWindowElement.querySelector(".flats__map-marker--compare-toggle");
                  if (compareBtn) {
                    compareBtn.addEventListener("click", (e) => {
                      e.stopPropagation();
                      window.dispatchEvent(
                        new CustomEvent("map-compare-toggle", {
                          detail: {
                            propertyId: marker.propertyId,
                            from: "mobile-map",
                          },
                        })
                      );
                    });
                  }
                }
              });
            
            bounds.extend(marker.position);
            newMarkers.push(marker);
          });
          
          // Create marker clusterer with same settings
          if (window.MarkerClusterer && newMarkers.length > 0) {
            modalMarkerClusterer = new MarkerClusterer({
              map: modalMap,
              markers: newMarkers,
            });
            
            // Add cluster click listener - EXACT SAME AS DESKTOP
            const markerToProperty = new Map();
            newMarkers.forEach((marker) => {
              if (marker.propertyId) {
                markerToProperty.set(marker, marker.property);
              }
            });
            
            // Listen for cluster clicks - EXACT SAME LOGIC AS DESKTOP
            modalMarkerClusterer.addListener("clusterclick", (event) => {
              const cluster = event.cluster;
              const markers = cluster.markers;
              
              // Get all properties from markers in this cluster - SAME AS DESKTOP
              const clusterProperties = markers
                .map((m) => markerToProperty.get(m))
                .filter((prop) => prop !== undefined);
              
              if (clusterProperties.length > 0) {
                // Get property IDs
                const propertyIds = clusterProperties.map((p) => p.idCode);
                
                // Clear filters and search for all properties in this cluster - SAME AS DESKTOP
                daireElement.options.available = false;
                daireElement.options.bedrooms = [];
                daireElement.options.livingRooms = [];
                daireElement.options.bathrooms = [];
                daireElement.options.priceRange = { min: null, max: null };
                daireElement.options.location = [];
                daireElement.options.projectName = [];
                daireElement.options.residenceType = [];
                
                // Clear date filters - SAME AS DESKTOP
                if (daireElement.quickDatePickerObj) {
                  daireElement.quickDatePickerObj.reset();
                }
                
                // Track map selection - SAME AS DESKTOP
                daireElement.mapSelectionCount = clusterProperties.length;
                
                // Create filtered data with only cluster properties - SAME AS DESKTOP
                daireElement.filteredData = {
                  ...daireElement.data,
                  properties: clusterProperties,
                };
                
                // Update search input to show cluster info - SAME AS DESKTOP
                if (daireElement.searchInput) {
                  daireElement.searchInput.value = `${propertyIds.length} daire`;
                }
                if (daireElement.searchInputMobile) {
                  daireElement.searchInputMobile.value = `${propertyIds.length} daire`;
                }
                daireElement.options.searchTerm = "";
                
                // Render the filtered list - SAME AS DESKTOP
                daireElement.page = 1;
                requestAnimationFrame(() => {
                  daireElement.render(true);
                });
                
                // Close the mobile map modal after selection
                mobileMapModal.classList.remove("active");
                document.body.style.overflow = "";
                
                // Clean up modal map
                if (mobileMapModalContent) {
                  mobileMapModalContent.innerHTML = "";
                }
                if (mapContainer && originalMapDisplay !== null) {
                  mapContainer.style.display = originalMapDisplay;
                }
                modalMap = null;
                modalMarkerClusterer = null;
                currentOpenInfoWindow = null;
              }
            });
          }
          
          // Fit bounds if we have markers
          if (newMarkers.length > 0 && !bounds.isEmpty()) {
            modalMap.fitBounds(bounds);
            const listener = google.maps.event.addListener(modalMap, "idle", () => {
              if (modalMap.getZoom() > 15) modalMap.setZoom(15);
              google.maps.event.removeListener(listener);
            });
          }
          
          // Trigger resize to ensure proper rendering
          setTimeout(() => {
            google.maps.event.trigger(modalMap, "resize");
            if (currentCenter) {
              modalMap.setCenter(currentCenter);
            }
          }, 100);
        }, 100);
      }
    });

    // Close map modal
    const closeModal = () => {
      // Restore original map display
      mapContainer.style.display = originalMapDisplay || "block";
      
      // Clear modal content
      mobileMapModalContent.innerHTML = "";
      
      // Clear modal map references
      modalMap = null;
      modalMarkerClusterer = null;
      currentOpenInfoWindow = null; // Clear info window reference
      
      // Hide modal
      mobileMapModal.classList.remove("active");
      document.body.style.overflow = "";
      
      // Trigger map resize on original map
      const daireElement = document.querySelector("daireler-element");
      if (daireElement && daireElement.map) {
        setTimeout(() => {
          google.maps.event.trigger(daireElement.map, "resize");
          if (daireElement.map.getCenter()) {
            daireElement.map.panTo(daireElement.map.getCenter());
          }
        }, 100);
      }
    };

    mobileMapModalClose.addEventListener("click", closeModal);

    // Close on backdrop click (optional)
    mobileMapModal.addEventListener("click", (e) => {
      if (e.target === mobileMapModal) {
        closeModal();
      }
    });
  }
});

// ============================================
// COMPARISON MODE FUNCTIONALITY
// ============================================

document.addEventListener("DOMContentLoaded", () => {
  const daireElement = document.querySelector("daireler-element");
  if (!daireElement) return;

  // Comparison state
  const comparisonState = {
    active: false,
    flats: [], // Max 4 flats
    colors: ["blue", "red", "green", "orange"],
    markers: new Map(), // Map of flatId -> marker
  };

  // DOM elements
  const comparisonToggle = document.getElementById("comparison-toggle");
  const comparisonCount = document.getElementById("comparison-count");
  const comparisonPanel = document.getElementById("comparison-panel");
  const comparisonBackdrop = document.getElementById("comparison-backdrop");
  const comparisonClose = document.getElementById("comparison-close");
  const comparisonClear = document.getElementById("comparison-clear");
  const comparisonGrid = document.getElementById("comparison-grid");
  const comparisonEmpty = document.getElementById("comparison-empty");
  const comparisonCardTemplate = document.getElementById(
    "comparison-card-template"
  );

  if (
    !comparisonToggle ||
    !comparisonPanel ||
    !comparisonGrid ||
    !comparisonCardTemplate
  )
    return;

  // Initialize comparison mode
  function initComparisonMode() {
    comparisonToggle.addEventListener("click", toggleComparisonMode);
    comparisonClose.addEventListener("click", closeComparisonPanel);
    comparisonClear.addEventListener("click", clearAllComparisons);
    
    // Close on backdrop click
    if (comparisonBackdrop) {
      comparisonBackdrop.addEventListener("click", closeComparisonPanel);
    }
    
    // Close on escape key
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape" && comparisonState.active) {
        closeComparisonPanel();
      }
    });

    // Mobile comparison button inside bottom action bar
    const mobileCompareBtn = document.querySelector(
      ".flats__comparison-toggle--mobile"
    );
    if (mobileCompareBtn) {
      mobileCompareBtn.addEventListener("click", (e) => {
        e.preventDefault();
        toggleComparisonMode();
      });
    }

    // Listen compare events from mobile map info windows
    window.addEventListener("map-compare-toggle", (e) => {
      const { propertyId } = e.detail || {};
      if (!propertyId) return;

      // If already in comparison, remove; otherwise add
      if (isInComparison(propertyId)) {
        removeFromComparison(propertyId);
      } else {
        if (!comparisonState.active) {
          toggleComparisonMode();
        }
        addToComparisonById(propertyId);
      }
    });

    // Listen compare events from normal cards (list view)
    window.addEventListener("card-compare-toggle", (e) => {
      const { propertyId } = e.detail || {};
      if (!propertyId) return;

      const cardElement = document.querySelector(
        `.flats__card[data-property-id="${propertyId}"]`
      );
      handleCardCompareToggle(propertyId, cardElement);
    });
  }

  // Handle compare toggle from cards
  function handleCardCompareToggle(propertyId, cardElement) {
    const alreadyIn = comparisonState.flats.some((f) => f.id == propertyId);

    // If already selected => remove
    if (alreadyIn) {
      removeFromComparison(propertyId);
      updateCardVisualState(cardElement, false);
      return;
    }

    // En fazla 4 daire
    if (comparisonState.flats.length >= 4) {
      showMaxComparisonMessage();
      return;
    }

    // Panel kapalıysa aç
    if (!comparisonState.active) {
      comparisonState.active = true;
      comparisonToggle.classList.add("active");
      comparisonPanel.classList.add("active");
      if (comparisonBackdrop) comparisonBackdrop.classList.add("active");
      document.body.style.overflow = "hidden";

       // Kart ile açıldığında da harita seçimleri çalışsın
       enableComparisonMarkers();
       showComparisonModeHint();
    }

    // State'e ekle
    addToComparisonById(propertyId);

    // Az önce eklenen flat'i bulup karta rengini uygula
    const addedFlat = comparisonState.flats.find((f) => f.id == propertyId);
    if (addedFlat) {
      updateCardVisualState(cardElement, true, addedFlat.comparisonColor);
    }
  }
  
  // Update card visual state
  function updateCardVisualState(cardElement, isInComparison, color = null) {
    if (!cardElement) return;
    
    if (isInComparison) {
      cardElement.classList.add("in-comparison");
      if (color) {
        cardElement.setAttribute("data-comparison-color", color);
      }
    } else {
      cardElement.classList.remove("in-comparison");
      cardElement.removeAttribute("data-comparison-color");
      const btn = cardElement.querySelector(".flats__card-compare-toggle");
      if (btn) {
        // Native tooltip çıkmaması için title tamamen kaldırıldı
        btn.removeAttribute("title");
        btn.setAttribute("aria-label", "Karşılaştırmaya ekle");
      }
    }
  }
  
  // Update all card visual states
  function updateAllCardVisualStates() {
    document.querySelectorAll(".flats__card").forEach((card) => {
      const propertyId = card.dataset.propertyId;
      const flat = comparisonState.flats.find((f) => f.id == propertyId);
      
      if (flat) {
        updateCardVisualState(card, true, flat.comparisonColor);
      } else {
        updateCardVisualState(card, false);
      }
    });
  }

  // Toggle comparison mode
  function toggleComparisonMode() {
    comparisonState.active = !comparisonState.active;

    if (comparisonState.active) {
      comparisonToggle.classList.add("active");
      comparisonPanel.classList.add("active");
      
      // Show backdrop
      if (comparisonBackdrop) {
        comparisonBackdrop.classList.add("active");
      }
      
      // Add visual indicator to map
      const mapContainer = document.getElementById("map-container");
      if (mapContainer) {
        mapContainer.setAttribute("data-comparison-active", "true");
      }
      
      // Prevent body scroll
      document.body.style.overflow = "hidden";
      
      enableComparisonMarkers();
      showComparisonModeHint();
    } else {
      comparisonToggle.classList.remove("active");
      comparisonPanel.classList.remove("active");
      
      // Hide backdrop
      if (comparisonBackdrop) {
        comparisonBackdrop.classList.remove("active");
      }
      
      // Remove visual indicator from map
      const mapContainer = document.getElementById("map-container");
      if (mapContainer) {
        mapContainer.removeAttribute("data-comparison-active");
      }
      
      // Restore body scroll
      document.body.style.overflow = "";
      
      disableComparisonMarkers();
    }
  }
  
  // Show comparison mode hint
  function showComparisonModeHint() {
    // Only show once per session
    if (sessionStorage.getItem("comparisonHintShown")) return;
    
    // Get CSS variable values
    const rootStyles = getComputedStyle(document.documentElement);
    const erraLogoColor = rootStyles.getPropertyValue('--erra-logo-color').trim() || "#0066FF";
    
    const hint = document.createElement("div");
    hint.className = "flats__comparison-hint";
    hint.innerHTML = `
      <div class="flats__comparison-hint-content">
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 17L12 22L22 17" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M2 12L12 17L22 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
        <div class="flats__comparison-hint-text">
          <strong>Karşılaştırma Modu Aktif</strong>
          <p>Haritadan daire seçin (Max 4 daire)</p>
        </div>
        <button class="flats__comparison-hint-close" aria-label="Kapat">
          <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18 6L6 18M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>
    `;
    
    // Calculate position below header
    const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 80;
    const topPosition = headerHeight + 20;
    
    hint.style.cssText = `
      position: fixed;
      top: ${topPosition}px;
      left: 50%;
      transform: translateX(-50%);
      background: ${erraLogoColor};
      color: white;
      padding: 16px 24px;
      border-radius: 16px;
      display: flex;
      align-items: center;
      gap: 16px;
      z-index: 9999;
      box-shadow: 0 8px 32px ${erraLogoColor}66;
      animation: slideDown 0.4s cubic-bezier(0.4, 0, 0.2, 1);
      max-width: 90%;
    `;
    
    document.body.appendChild(hint);
    
    const closeBtn = hint.querySelector(".flats__comparison-hint-close");
    closeBtn.addEventListener("click", () => {
      hint.style.animation = "slideUp 0.3s ease";
      setTimeout(() => hint.remove(), 300);
      sessionStorage.setItem("comparisonHintShown", "true");
    });
    
    // Auto hide after 5 seconds
    setTimeout(() => {
      if (hint.parentElement) {
        hint.style.animation = "slideUp 0.3s ease";
        setTimeout(() => hint.remove(), 300);
        sessionStorage.setItem("comparisonHintShown", "true");
      }
    }, 5000);
  }

  // Close comparison panel
  function closeComparisonPanel() {
    comparisonState.active = false;
    comparisonToggle.classList.remove("active");
    comparisonPanel.classList.remove("active");
    
    // Hide backdrop
    if (comparisonBackdrop) {
      comparisonBackdrop.classList.remove("active");
    }
    
    // Remove visual indicator from map
    const mapContainer = document.getElementById("map-container");
    if (mapContainer) {
      mapContainer.removeAttribute("data-comparison-active");
    }
    
    // Restore body scroll
    document.body.style.overflow = "";
    
    disableComparisonMarkers();
  }

  // Clear all comparisons
  function clearAllComparisons() {
    comparisonState.flats = [];
    comparisonState.markers.clear();
    updateComparisonUI();
    removeAllMarkerBorders();
    updateAllCardVisualStates();
  }

  // Enable comparison on markers
  function enableComparisonMarkers() {
    if (!daireElement.markers) return;

    daireElement.markers.forEach((marker) => {
      const flatId = marker.propertyId;
      if (!flatId) return;

      // Store flatId in marker for easy access
      marker.flatId = flatId;

      // Add visual indicator that marker is clickable
      if (marker.content) {
        marker.content.style.cursor = "pointer";
        marker.content.style.transition = "transform 0.2s ease";
      }

      // Add click listener for comparison (without removing existing listeners)
      const clickHandler = () => {
        handleMarkerClick(flatId, marker);

        // Visual feedback on click
        if (marker.content) {
          marker.content.style.transform = "scale(0.95)";
          setTimeout(() => {
            marker.content.style.transform = "scale(1)";
          }, 150);
        }
      };

      // Store listener handle so we can remove only our own handler later
      if (!marker.comparisonClickListener) {
        marker.comparisonClickListener = marker.addListener("click", clickHandler);
      }

      // Update marker border if already in comparison (don't change the marker itself)
      if (isInComparison(flatId)) {
        const color = getComparisonColor(flatId);
        addMarkerBorder(marker, color);
      }
    });
  }

  // Disable comparison markers
  function disableComparisonMarkers() {
    if (!daireElement.markers) return;

    daireElement.markers.forEach((marker) => {
      // Remove only our comparison click listener, keep original marker behavior
      if (marker.comparisonClickListener) {
        marker.comparisonClickListener.remove();
        delete marker.comparisonClickListener;
      }
      
      // Reset cursor style
      if (marker.content) {
        marker.content.style.cursor = "";
      }
      
      // Remove marker border
      removeMarkerBorder(marker);
    });
  }

  // Handle marker click in comparison mode
  function handleMarkerClick(flatId, marker) {
    if (!comparisonState.active) return;

    if (isInComparison(flatId)) {
      removeFromComparison(flatId);
    } else {
      addToComparison(flatId, marker);
    }
  }

  // Add flat to comparison
  function addToComparison(flatId, marker) {
    if (comparisonState.flats.length >= 4) {
      showMaxComparisonMessage();
      return;
    }

    // Get property data from marker or search in data
    let flat = marker.property;
    
    if (!flat && daireElement.data) {
      flat = daireElement.data.find((f) => f.idCode == flatId || f.id == flatId);
    }
    
    if (!flat) {
      console.warn("Flat not found:", flatId);
      return;
    }

    const colorIndex = comparisonState.flats.length;
    const color = comparisonState.colors[colorIndex];

    comparisonState.flats.push({
      ...flat,
      id: flat.idCode || flat.id,
      comparisonColor: color,
      comparisonAvailabilityDisplay: computeAvailabilityDisplay(flat),
    });

    comparisonState.markers.set(flatId, marker);
    addMarkerBorder(marker, color);
    updateComparisonUI();
    updateAllCardVisualStates();

    // Show added notification
    showComparisonAddedMessage(comparisonState.flats.length);
  }

  // Add flat to comparison only by id (used from mobile map, card, etc.)
  function addToComparisonById(flatId) {
    if (comparisonState.flats.length >= 4) {
      showMaxComparisonMessage();
      return;
    }

    // Already in comparison, skip
    if (isInComparison(flatId)) return;

    // Find flat data from loaded API data (filteredData varsa onu kullan)
    const sourceData = daireElement.filteredData || daireElement.data;
    const flat =
      sourceData?.properties?.find((p) => String(p.idCode) == String(flatId)) ||
      null;

    if (!flat) {
      console.warn("Flat not found for comparison (by id):", flatId);
      return;
    }

    const colorIndex = comparisonState.flats.length;
    const color = comparisonState.colors[colorIndex];

    const normalizedFlat = {
      ...flat,
      id: flat.idCode || flat.id,
      comparisonColor: color,
      comparisonAvailabilityDisplay: computeAvailabilityDisplay(flat),
    };

    comparisonState.flats.push(normalizedFlat);

    // Try to find main map marker to decorate
    if (daireElement.markers) {
      let markerForFlat = null;
      daireElement.markers.forEach((marker) => {
        if (marker.propertyId == flatId) {
          markerForFlat = marker;
        }
      });
      if (markerForFlat) {
        comparisonState.markers.set(flatId, markerForFlat);
        addMarkerBorder(markerForFlat, color);
      }
    }

    updateComparisonUI();
    updateAllCardVisualStates();

    // Show added notification
    showComparisonAddedMessage(comparisonState.flats.length);
  }

  // Compute availability display text (same mantık ana kartlarla)
  function computeAvailabilityDisplay(flat) {
    if (daireElement?.getAvailabilityDisplay) {
      return daireElement.getAvailabilityDisplay(flat).dateText;
    }

    const currentMoment = daireElement.currentMoment || moment();
    let endDate = moment(flat.musaitlikTarihi, "YYYY-MM-DD");

    if (!endDate.isValid()) {
      endDate = currentMoment;
    }

    let printDate = null;

    if (flat.musaitlikDurumu === true || endDate.isBefore(currentMoment)) {
      printDate = currentMoment;
    } else {
      printDate = endDate;
    }

    return printDate.format("DD MMMM YYYY");
  }

  // Remove flat from comparison
  function removeFromComparison(flatId) {
    const index = comparisonState.flats.findIndex((f) => f.id == flatId);
    if (index === -1) return;

    comparisonState.flats.splice(index, 1);

    // Reassign colors
    comparisonState.flats.forEach((flat, idx) => {
      flat.comparisonColor = comparisonState.colors[idx];
    });

    const marker = comparisonState.markers.get(flatId);
    if (marker) {
      removeMarkerBorder(marker);
      comparisonState.markers.delete(flatId);
    }

    updateComparisonUI();
    removeAllMarkerBorders();
    reapplyMarkerBorders();
    updateAllCardVisualStates();
  }

  // Check if flat is in comparison
  function isInComparison(flatId) {
    return comparisonState.flats.some((f) => f.id == flatId);
  }

  // Get comparison color for flat
  function getComparisonColor(flatId) {
    const flat = comparisonState.flats.find((f) => f.id == flatId);
    return flat?.comparisonColor || null;
  }

  // Add colored border to marker
  function addMarkerBorder(marker, color) {
    if (!marker) return;

    const colorMap = {
      blue: getComputedStyle(document.documentElement).getPropertyValue('--erra-logo-color').trim() || "#0066FF",
      red: "#FF4444",
      green: "#00C853",
      orange: "#FF9500",
    };

    // Find the marker info box and add border
    const markerElement = marker.content?.parentElement;
    if (markerElement) {
      const infoBox = markerElement.querySelector(".flats__map-marker--info");
      if (infoBox) {
        infoBox.style.border = `3px solid ${colorMap[color]}`;
        infoBox.style.boxShadow = `0 4px 20px ${colorMap[color]}80`;
        infoBox.setAttribute("data-comparison-color", color);
      }
    }
  }

  // Remove border from marker
  function removeMarkerBorder(marker) {
    if (!marker) return;

    const markerElement = marker.content?.parentElement;
    if (markerElement) {
      const infoBox = markerElement.querySelector(".flats__map-marker--info");
      if (infoBox) {
        infoBox.style.border = "";
        infoBox.style.boxShadow = "";
        infoBox.removeAttribute("data-comparison-color");
      }
    }
  }

  // Remove all marker borders
  function removeAllMarkerBorders() {
    if (!daireElement.markers) return;

    daireElement.markers.forEach((marker) => {
      removeMarkerBorder(marker);
    });
  }

  // Reapply marker borders after removal
  function reapplyMarkerBorders() {
    comparisonState.flats.forEach((flat) => {
      const marker = comparisonState.markers.get(flat.id);
      if (marker) {
        addMarkerBorder(marker, flat.comparisonColor);
      }
    });
  }

  // Create marker element from SVG
  function createMarkerElement(svgString) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgString, "image/svg+xml");
    return doc.documentElement;
  }


  // Update comparison UI
  function updateComparisonUI() {
    const count = comparisonState.flats.length;

    // Update count badge
    if (count > 0) {
      comparisonCount.textContent = count;
      comparisonCount.style.display = "inline-block";
    } else {
      comparisonCount.style.display = "none";
    }

    // Update panel width attribute
    comparisonPanel.setAttribute("data-items", count);
    comparisonGrid.setAttribute("data-items", count);

    // Update grid
    if (count > 0) {
      comparisonEmpty.classList.add("hidden");
      comparisonGrid.classList.add("active");
      renderComparisonCards();
    } else {
      // Empty state text – mobile: kullanıcıya kart üzerindeki ikon bilgisini ver
      const emptyTextEl = comparisonEmpty.querySelector(
        ".flats__comparison-empty-text"
      );
      if (emptyTextEl) {
        if (window.innerWidth <= 768) {
          emptyTextEl.textContent =
            "Karşılaştırma listesine eklemek için kartların sol üstündeki ikona dokunabilirsiniz.";
        } else {
          emptyTextEl.textContent =
            "Haritadan dairelere tıklayarak veya kartların sol üstündeki ikona basarak karşılaştırma listesine ekleyebilirsiniz.";
        }
      }

      comparisonEmpty.classList.remove("hidden");
      comparisonGrid.classList.remove("active");
      comparisonGrid.innerHTML = "";
    }
  }

  // Render comparison cards
  function renderComparisonCards() {
    comparisonGrid.innerHTML = "";

    comparisonState.flats.forEach((flat) => {
      const card = createComparisonCard(flat);
      comparisonGrid.appendChild(card);
    });
  }

  // Create comparison card
  function createComparisonCard(flat) {
    const template = comparisonCardTemplate.content.cloneNode(true);
    const card = template.querySelector(".flats__comparison-card");

    // Set data attributes
    card.setAttribute("data-flat-id", flat.id);
    card.setAttribute("data-comparison-color", flat.comparisonColor);

    // Color indicator
    const colorIndicator = card.querySelector(".flats__comparison-card-color");
    colorIndicator.setAttribute("data-color", flat.comparisonColor);

    // Image
    const image = card.querySelector(".flats__comparison-card-image img");
    if (flat.images && flat.images.length > 0) {
      image.src = flat.images[0];
      image.alt = flat.projectName || flat.title || "Daire";
    } else if (flat.image) {
      image.src = flat.image;
      image.alt = flat.projectName || flat.title || "Daire";
    } else {
      image.src = "https://via.placeholder.com/400x300?text=No+Image";
      image.alt = "Görsel mevcut değil";
    }

    // Title and ID
    const title = flat.projectName || flat.title || "Daire";
    card.querySelector(".flats__comparison-card-title").textContent = title;
    card.querySelector(".flats__comparison-card-id").textContent = `ID: ${flat.idCode || flat.id}`;

    // Address - Same format as normal cards
    let address = "-";
    if (flat.buildingDistrictMainName && flat.buildingNeighborhoodName && flat.buildingCityName) {
      address = `${flat.buildingNeighborhoodName} / ${flat.buildingDistrictMainName} / ${flat.buildingCityName}`;
    } else if (flat.address) {
      address = flat.address.split(", ").reverse().join(" / ");
    } else if (flat.buildingAddress) {
      address = flat.buildingAddress;
    }
    card.querySelector(".flats__comparison-card-address").textContent = address;

    // Price - Same format as normal cards
    const priceValue = flat.priceRange?.MonthlyPrices?.["12_12"]?.["cash"];
    const priceFormatted = priceValue ? window.formatPrice(priceValue, 0) : "-";
    card.querySelector(".flats__comparison-card-price-value").textContent = priceFormatted;

    // Rooms - Same format as normal cards
    const roomsText = flat.odaSayisi || "-";
    card.querySelector(".flats__comparison-card-rooms").textContent = roomsText;

    // Bathrooms - Same format as normal cards
    const bathsText = flat.bathrooms ? `${flat.bathrooms} Banyo` : "-";
    card.querySelector(".flats__comparison-card-baths").textContent = bathsText;

    // Square meters - Same format as normal cards
    const sqmText = flat.netMetrekare ? `${flat.netMetrekare} m²` : "-";
    card.querySelector(".flats__comparison-card-sqm").textContent = sqmText;

    // Availability - use precomputed display if available
    const availabilityText =
      flat.comparisonAvailabilityDisplay !== undefined &&
      flat.comparisonAvailabilityDisplay !== null
        ? flat.comparisonAvailabilityDisplay
        : "-";
    card.querySelector(
      ".flats__comparison-card-availability-date"
    ).textContent = availabilityText;

    const availabilityLabel = card
      .querySelector(".flats__comparison-card-availability-date")
      ?.closest(".flats__comparison-card-property")
      ?.querySelector(".flats__comparison-card-property-label");
    if (availabilityLabel && !availabilityLabel.dataset.defaultText) {
      availabilityLabel.dataset.defaultText = availabilityLabel.textContent;
    }
    if (availabilityLabel) {
      const availabilityInfo = daireElement.getAvailabilityDisplay
        ? daireElement.getAvailabilityDisplay(flat)
        : null;
      availabilityLabel.textContent = availabilityInfo?.label
        ? `${availabilityInfo.label}:`
        : availabilityLabel.dataset.defaultText || availabilityLabel.textContent;
    }

    // Details link
    const detailsLink = card.querySelector(".flats__comparison-card-details");
    const lang = document.documentElement.lang === "tr" ? "" : "/en";
    const url = flat.handle ? `${lang}/products/${flat.handle}` : "#";
    detailsLink.href = url;

    // Remove button
    const removeBtn = card.querySelector(".flats__comparison-card-remove");
    removeBtn.addEventListener("click", () => {
      removeFromComparison(flat.id);
    });

    return card;
  }

  let comparisonNotificationTimeout = null;

  function createComparisonNotification(message, iconStroke = "#FFD700") {
    const rootStyles = getComputedStyle(document.documentElement);
    const erraPrimaryColor =
      rootStyles.getPropertyValue("--erra-primary-color").trim() || "#151515";

    const headerHeight =
      parseInt(rootStyles.getPropertyValue("--header-height")) || 80;
    const topPosition = headerHeight + 16;

    // Remove existing notification if any
    const existing = document.querySelector(".flats__comparison-notification");
    if (existing) existing.remove();

    const notification = document.createElement("div");
    notification.className = "flats__comparison-notification";
    notification.innerHTML = `
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="12" cy="12" r="10" stroke="currentColor" stroke-width="2"/>
        <path d="M12 8v4M12 16h.01" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
      </svg>
      <span>${message}</span>
    `;

    notification.style.cssText = `
      position: fixed;
      top: ${topPosition}px;
      left: 50%;
      transform: translateX(-50%);
      background: ${erraPrimaryColor};
      color: white;
      padding: 10px 28px;
      border-radius: 999px;
      display: flex;
      align-items: center;
      gap: 12px;
      z-index: 10000;
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
      font-size: 12px;
      font-weight: 600;
      max-width: min(90vw, 560px);
      width: max-content;
    `;

    const svg = notification.querySelector("svg");
    if (svg) {
      svg.style.width = "20px";
      svg.style.height = "20px";
      svg.style.stroke = iconStroke;
    }

    document.body.appendChild(notification);

    if (comparisonNotificationTimeout) {
      clearTimeout(comparisonNotificationTimeout);
    }
    comparisonNotificationTimeout = setTimeout(() => {
      notification.remove();
    }, 2500);
  }

  // Show info when max comparison reached
  function showMaxComparisonMessage() {
    createComparisonNotification(
      "Maksimum 4 daire karşılaştırabilirsiniz",
      "#FFD700"
    );
  }

  // Show info when a flat is added
  function showComparisonAddedMessage(count) {
    const remaining = Math.max(0, 4 - count);
    const msg =
      remaining > 0
        ? `Karşılaştırmaya eklendi (${count}/4) - ${remaining} daire daha ekleyebilirsiniz`
        : `Karşılaştırmaya eklendi (${count}/4)`;
    createComparisonNotification(msg, "#00C853");
  }

  // Add CSS animations
  const style = document.createElement("style");
  style.textContent = `
    @keyframes slideDown {
      from {
        opacity: 0;
        transform: translate(-50%, -20px);
      }
      to {
        opacity: 1;
        transform: translate(-50%, 0);
      }
    }
    @keyframes slideUp {
      from {
        opacity: 1;
        transform: translate(-50%, 0);
      }
      to {
        opacity: 0;
        transform: translate(-50%, -20px);
      }
    }
  `;
  document.head.appendChild(style);

  // Initialize when Google Maps is ready
  function initWhenReady() {
    if (window.google && window.google.maps && daireElement.mapInitialized) {
      initComparisonMode();
    } else {
      setTimeout(initWhenReady, 500);
    }
  }

  initWhenReady();
});
